import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  /**
   * A CSS font-family value restricted to a safe charset (letters, numbers,
   * spaces, hyphens, commas and quotes).
   */
  FontFamily: string;
  HexColourCode: string;
  /**
   * A URL that must use the https:// scheme, with no whitespace or
   * quote/angle-bracket characters. Used for brand fields that get
   * interpolated into markup/CSS on the public booking widget.
   */
  HttpsUrl: string;
  IANATimeZone: string;
  ObjectID: string;
  /**
   * A CSS background value restricted to a safe grammar: hex colours,
   * rgb()/rgba(), url(https://...), or linear-gradient()/radial-gradient().
   */
  PageBackground: string;
  RRule: string;
};

export type ApTokenOverrideInput = {
  id: Scalars["ObjectID"];
  kind: ApTokenOverrideSource;
};

/**
 * Enumeration of possible types of overrides for ap_tokened users. Appointedd
 * staff by definition have access to all accounts/entities, so we may want to
 * return a specific subset based on some source as not to run into
 * performance issues.
 */
export enum ApTokenOverrideSource {
  Bookingtool = "BOOKINGTOOL",
}

export type AddNewAccountResourceInput = {
  /** A unique 'key' used when assigning resources to services. */
  key: Scalars["String"];
  /** The name of the new resource. */
  name: Scalars["String"];
  /** The type of resource. */
  type?: Maybe<AddNewAccountResourceType>;
};

export enum AddNewAccountResourceType {
  Other = "OTHER",
  Person = "PERSON",
  Space = "SPACE",
}

export type AddNewAccountServiceInput = {
  /** The duration of the service in minutes. */
  duration: Scalars["Int"];
  /** The name of the new service. */
  name: Scalars["String"];
  /** The price of the service (a price of 0 denotes the service is free). */
  price: Scalars["Float"];
  /**
   * An array of unique resource 'keys' used to determine which resources should be
   * assigned to this service.
   */
  resourceKeys: Array<Scalars["String"]>;
};

export type AdyenAuthenticationData = {
  threeDSRequestData: AdyenThreeDsRequestData;
};

export type AdyenBrowserInfo = {
  acceptHeader?: Maybe<Scalars["String"]>;
  colorDepth?: Maybe<Scalars["Int"]>;
  javaEnabled?: Maybe<Scalars["Boolean"]>;
  language?: Maybe<Scalars["String"]>;
  screenHeight?: Maybe<Scalars["Int"]>;
  screenWidth?: Maybe<Scalars["Int"]>;
  timeZoneOffset?: Maybe<Scalars["Int"]>;
  userAgent?: Maybe<Scalars["String"]>;
};

/** Represents the adyen integration being enabled on an organisation. */
export type AdyenIntegration = {
  __typename?: "AdyenIntegration";
  /** The Adyen accountId that identifies this organisation. */
  tokenId: Scalars["ObjectID"];
};

/**
 * An OAuth 2.x token for our Adyen integration.
 *
 * This type is extended from the `OpenAuthIntegrationToken` type and shares
 * all of the same properties with additional properties specific the Adyen
 * integration.
 */
export type AdyenIntegrationToken = {
  __typename?: "AdyenIntegrationToken";
  /** Unique identifier of this token. */
  _id: Scalars["ObjectID"];
  /** One or more merchant accounts that this token is allowed to access. */
  adyenAllowedMerchantAccounts: Array<Scalars["String"]>;
  /** Base URL for the Adyen Checkouts API that this token should use. */
  adyenCheckoutBaseUrl: Scalars["String"];
  /**
   * Client key for this token. This is requried to load the drop-in UI for
   * payments.
   */
  adyenClientKey: Scalars["String"];
  /**
   * Merchant account that is currently selected for this token. This will be the
   * merchant account that the sessions created from this token will be created
   * for and therefore take payments for.
   */
  adyenSelectedMerchantAccount: Scalars["String"];
  /** Whether cardholder name collection is required for payments. */
  cardHolderNameRequired?: Maybe<Scalars["Boolean"]>;
  /** Date and time that this token was created at. */
  created: Scalars["Date"];
  /** Date and time that access token on this token expires at. */
  expiresAt: Scalars["Date"];
  /**
   * List of OAuth 2.x scopes on the external application that this token has
   * access to.
   */
  scopes: Array<Scalars["String"]>;
  /** If set, the date and time that this token was last updated at. */
  updated?: Maybe<Scalars["Date"]>;
};

/**
 * AdyenPayment returns the result of a payment creation request. It will either return the confirmation of a
 * successful payment or an action object which can be used to render the Adyen drop-in UI.
 *
 * The action object is a JSON string, of an unspecified format returned from Adyen, which we do not handle
 * but pass directly to the Adyen drop-in UI for parsing. The dorp-in UI will then return the required action based
 * on the payload of the action object.
 *
 * If the payment is successful, the paymentDetails field will be returned which contains a resultCode and pspReference (an Adyen payment ID).
 */
export type AdyenPayment = {
  __typename?: "AdyenPayment";
  /** The action object returned from Adyen. This is a JSON string, of an unspecified format returned from the Adyen API. */
  action?: Maybe<Scalars["String"]>;
  /** The successful payment details returned from Adyen. */
  paymentDetails?: Maybe<AdyenPaymentCreationPaymentDetails>;
  /** Unique ID generated by Appointedd that can be used to identify the payment. */
  reference?: Maybe<Scalars["String"]>;
};

/**
 * AdyenPaymentConfirmation returns the result of a payment based on the threeDSResult.
 * If the payment has been successful and the payment has been authorised, the resultCode will be Authorised.
 * A pspReference will be returned for successful payments, which is the unique identifier for this payment.
 */
export type AdyenPaymentConfirmation = {
  __typename?: "AdyenPaymentConfirmation";
  pspReference?: Maybe<Scalars["String"]>;
  resultCode: Scalars["String"];
};

export type AdyenPaymentCreationPaymentDetails = {
  __typename?: "AdyenPaymentCreationPaymentDetails";
  pspReference: Scalars["String"];
  resultCode: Scalars["String"];
};

export type AdyenRefundRequestResult = {
  __typename?: "AdyenRefundRequestResult";
  success: Scalars["Boolean"];
};

/**
 * AdyenSession returns data required for us to render the Adyen drop-in payment UI within the booking widget.
 * Each time the user navigates to the payment step, a unique session is generated for that customer
 * based upon factors such as location, currency, locale, amount and the connected organiastion. These factors
 * determine which payment methods are available for the dropin UI.
 */
export type AdyenSession = {
  __typename?: "AdyenSession";
  /** Unique Adyen client key for this token. */
  clientKey: Scalars["String"];
  /**
   * Name of the environment that this session should be loaded in. This will
   * need to be passed to the Adyen component and is also used in various URLs
   * provided by Adyen.
   *
   * Adyen maintains a
   * [list of environments](https://docs.adyen.com/development-resources/live-endpoints/#checkout-js-endpoints)
   * on their documentation site.
   */
  environment: Scalars["String"];
  /**
   * The payment methods available for this customers payment session.
   * These can change depending on the country, currency, amount, etc.
   * This value is a JSON string, of an unspecified format returned from
   * the adyen API.We don't need to know the format as it's passed directly
   * to the Adyen drop-in UI for parsing.
   */
  paymentMethods: Scalars["String"];
};

export type AdyenThreeDsRequestData = {
  nativeThreeDS: Scalars["String"];
};

export enum AppointeddSmsApprovalStatus {
  Approved = "APPROVED",
  Pending = "PENDING",
  Unapproved = "UNAPPROVED",
}

export type AppointeddSmsIntegration = {
  __typename?: "AppointeddSmsIntegration";
  name: Scalars["String"];
};

export type Asset = {
  __typename?: "Asset";
  /** Unique identifier for this asset. */
  _id: Scalars["ObjectID"];
  /** Name of this asset. */
  name: Scalars["String"];
  /** Quantity for this asset. */
  quantity?: Maybe<Scalars["Int"]>;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type AssetEdge = {
  __typename?: "AssetEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Asset that is on this page. */
  node: Asset;
};

/**
 * Page containing the resulting assets for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type AssetPage = {
  __typename?: "AssetPage";
  /** Array of nodes containing the assets that are on this page. */
  edges: Array<AssetEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: AssetPageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type AssetPageInfo = {
  __typename?: "AssetPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type AssetSearchCondition = {
  condition?: Maybe<AssetSearchConditionType>;
  parameters: Array<AssetSearchParameter>;
};

export enum AssetSearchConditionType {
  And = "AND",
  Or = "OR",
}

export type AssetSearchParameter = {
  name?: Maybe<Scalars["String"]>;
};

export enum AssetSortKey {
  Name = "NAME",
  Natural = "NATURAL",
}

/** Enumeration of possible availability display modes on the ServiceReference.availabilityDisplayMode property */
export enum AvailabilityDisplayMode {
  /** Availability is displayed in a calendar view */
  Calendar = "CALENDAR",
  /** Availability is displayed in a list view */
  List = "LIST",
}

export type AvailabilityIntervalResult =
  | AvailableInterval
  | GroupBookingInterval;

export type AvailabilityRange = {
  end: Scalars["Date"];
  start: Scalars["Date"];
};

/** Optional meta data associated with an availability request */
export type AvailabilityRequestMetaData = {
  /** Session id for tracking a user session from the front-end to the back-end */
  sessionId?: Maybe<Scalars["String"]>;
};

export type AvailabilityResult =
  | ResourceAvailableInterval
  | ResourceGroupBookingInterval;

export type AvailableDate = {
  __typename?: "AvailableDate";
  /** A date with at least one AvailableInterval */
  date: Scalars["Date"];
};

export type AvailableInterval = {
  __typename?: "AvailableInterval";
  /** End date and time of this availability interval in UTC. */
  end: Scalars["Date"];
  /** The number of spaces that can still be booked for this slot. */
  remainingSpaces?: Maybe<Scalars["Int"]>;
  /** Ids of resources who are available for this interval */
  resourceIds: Array<Scalars["ObjectID"]>;
  /** Start date and time of this availability interval in UTC. */
  start: Scalars["Date"];
};

export type BccEmail = {
  __typename?: "BccEmail";
  /** Email address to BCC emails to. */
  address: Scalars["String"];
  /** Status of address (PENDING | APPROVED). */
  status: BccEmailStatus;
};

export enum BccEmailStatus {
  Approved = "APPROVED",
  Pending = "PENDING",
}

export type Booking = {
  __typename?: "Booking";
  /** Indicates if the booking is POA, which supersedes the selected duration or price point price. */
  POA: Scalars["Boolean"];
  _id: Scalars["ObjectID"];
  /**
   * If set to true, additional participants can join this booking by
   * booking on to it from your external facing booking tools (eg. your
   * microsite and/or booking widgets).
   */
  allowExternalParticipants: Scalars["Boolean"];
  end: Scalars["Date"];
  endWithBuffer: Scalars["Date"];
  /**
   * Maximum number of spaces that can be used by participants on
   * this booking.
   */
  maxSpaces: Scalars["Int"];
  organisation: Organisation;
  participant: BookingParticipant;
  participantsByCustomerId: Array<Maybe<BookingParticipant>>;
  parts: Array<BookingPart>;
  /** A booking specific price that supersedes the selected duration or price point price */
  price?: Maybe<Scalars["Float"]>;
  /**
   * Recurring booking data
   * If present this booking is part of a recurring series of bookings
   */
  recurring?: Maybe<Recurrence>;
  /** Calculates how many spaces are left on this booking. */
  remainingSpaces: Scalars["Int"];
  resource: Resource;
  resourceV2?: Maybe<Resource>;
  service: Service;
  start: Scalars["Date"];
  startWithBuffer: Scalars["Date"];
  status: BookingStatus;
};

export type BookingParticipantArgs = {
  id: Scalars["ObjectID"];
};

export type BookingParticipantsByCustomerIdArgs = {
  id: Scalars["ObjectID"];
};

export type BookingInput = {
  bookingIds?: Maybe<Array<Scalars["ObjectID"]>>;
  bookingNotes?: Maybe<Scalars["String"]>;
  bookingQuestions: Array<BookingQuestionInput>;
  customer: CustomerInput;
  organisationId: Scalars["ObjectID"];
  pricePoints?: Maybe<Array<BookingToolPricePointInput>>;
  reservedSpaceId: Scalars["ObjectID"];
  tierId?: Maybe<Scalars["ObjectID"]>;
  timezone: Scalars["String"];
};

export type BookingPart = {
  __typename?: "BookingPart";
  end: Scalars["Date"];
  start: Scalars["Date"];
};

export type BookingParticipant = {
  __typename?: "BookingParticipant";
  arrivalStatus: Scalars["String"];
  customer_booking_id: Scalars["ObjectID"];
  price: Scalars["Float"];
  spaces: Scalars["Float"];
};

export type BookingPayment = {
  __typename?: "BookingPayment";
  /**
   * The value of a discount that the customer has applied to an invoice
   * through the redemption of a discount code.
   */
  appliedDiscountValue?: Maybe<Scalars["Float"]>;
  /** Indicates if a customer can optionally pay for their booking regardless of the booking price. */
  isPaymentOptional: Scalars["Boolean"];
  /**
   * The value added onto an invoice to ensure that the price of an invoice
   * doesn't fall below the minimum online payment charge.
   */
  minChargeAdjustmentValue?: Maybe<Scalars["Float"]>;
  /** The price that the customer is expected to pay during the booking flow. */
  paymentPrice: Scalars["Float"];
  paymentPriceInPence: Scalars["Int"];
  /** The total price of a booking excluding discounts & deposits. */
  totalPrice: Scalars["Float"];
  totalPriceInPence: Scalars["Int"];
};

/**
 * Represents a booking question defined by an organisation.
 *
 * This is the config data for the booking question as displayed in the booking
 * flow. It does NOT include answer data for any particular booking.
 */
export type BookingQuestion = {
  __typename?: "BookingQuestion";
  /**
   * The unique id of this booking question.
   *
   * Note that this is a string, not an ObjectID, because the booking question
   * data is parsed from a JSON string, rather than being stored in a
   * MongoDB document.
   */
  id?: Maybe<Scalars["String"]>;
  /**
   * The booking question's human-readable name, used as the label for the
   * question in the booking flow.
   *
   * In terms-type questions, this can be an empty string, in which case a
   * default name is used instead.
   */
  name: Scalars["String"];
  /**
   * The array of options on a dropdown-type booking question.
   *
   * Null for all other types of booking question
   */
  options?: Maybe<Array<BookingQuestionDropdownOption>>;
  /**
   * Whether a user must answer this booking question when it is presented to
   * them in the booking flow.
   */
  required: Scalars["Boolean"];
  /**
   * A list of services for which this booking question should appear in
   * the booking flow.
   *
   * If null, the booking question will appear in booking flows for all services
   * on the organisation.
   */
  services?: Maybe<Array<Service>>;
  /**
   * An array of subquestions to this question.
   *
   * Only available on dropdown-type and checkbox-type booking questions. Null on
   * all other types of booking question.
   */
  subquestions?: Maybe<Array<BookingQuestionSubquestion>>;
  /**
   * The field type for this booking question.
   *
   * Determines what type of input is presented to the user to record data for
   * this booking question, and therefore what type of data can be recorded.
   */
  type: BookingQuestionFieldType;
  /**
   * For a terms-type booking question, the url to the content the user is
   * required to acknowledge. Null for all other question types.
   */
  url?: Maybe<Scalars["String"]>;
  /** The booking flows in which this booking question should be displayed. */
  visibility: BookingQuestionVisibility;
};

/** Represents an option on a dropdown-type booking question */
export type BookingQuestionDropdownOption = {
  __typename?: "BookingQuestionDropdownOption";
  /**
   * The option's unique id.
   *
   * Note that this is a string, not an ObjectID, because the booking question
   * data is parsed from a JSON string, rather than being stored in a
   * MongoDB document.
   *
   * This is used to identify the option for the purposes of triggering display
   * of conditional subquestions.
   *
   * Dropdown options created before introduction of the conditional subquestions
   * feature will not have an id. However, any newly created or updated dropdown
   * booking question will include ids on all options, so in practice this value
   * will always exist whenever it is needed for triggering subquestion display.
   */
  optionId?: Maybe<Scalars["String"]>;
  /** The option's value. */
  value: Scalars["String"];
};

/**
 * Enumeration of possible booking question field types on the
 * Organisation.BookingQuestion.type property. This dictates the type of input
 * to be rendered, as well as the type of data collected.
 */
export enum BookingQuestionFieldType {
  /** A checkbox booking question (boolean value) */
  Checkbox = "CHECKBOX",
  /** A dropdown/select booking question */
  Dropdown = "DROPDOWN",
  /**
   * A file attachment booking question, which allows users to upload a file
   * along with their booking data.
   */
  File = "FILE",
  /**
   * A terms and conditions booking question. These are like checkbox booking
   * questions, except they also include a link to an external url containing
   * information to be acknowledged by checking the box.
   */
  Terms = "TERMS",
  /** A plain text booking question */
  Text = "TEXT",
}

export type BookingQuestionInput = {
  id?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  type: BookingQuestionFieldType;
  value?: Maybe<Scalars["String"]>;
};

/**
 * Represents a conditional subquestion on a booking question.
 *
 * This is essentially a reduced version of a BookingQuestion, as subquestions
 * cannot be nested within each other.
 */
export type BookingQuestionSubquestion = {
  __typename?: "BookingQuestionSubquestion";
  /**
   * An array of dropdown option ids which will cause this subquestion to be
   * displayed when selected.
   *
   * Only relevant to subquestions of dropdown-type booking questions. Null for
   * subquestions of checkbox-type booking questions.
   */
  dropdownTriggers?: Maybe<Array<Scalars["String"]>>;
  /**
   * The unique id of this subquestion.
   *
   * Note that this is a string, not an ObjectID, because the booking question
   * data is parsed from a JSON string, rather than being stored in a
   * MongoDB document.
   */
  id: Scalars["String"];
  /**
   * The subquestion's human-readable name, used as the label for the question
   * in the booking flow.
   *
   * In terms-type questions, this can be an empty string, in which case a
   * default name is used instead.
   */
  name: Scalars["String"];
  /**
   * The array of options on a dropdown-type subquestion.
   *
   * Null for all other types of subquestion
   */
  options?: Maybe<Array<BookingQuestionDropdownOption>>;
  /**
   * Whether a user must answer this subquestion when it is presented to
   * them in the booking flow.
   */
  required: Scalars["Boolean"];
  /**
   * The field type for this subquestion.
   *
   * Determines what type of input is presented to the user to record data for
   * this booking question, and therefore what type of data can be recorded.
   */
  type: BookingQuestionFieldType;
  /**
   * For a terms-type subquestion, the url to the content the user is required to
   * acknowledge. Null for all other question types.
   */
  url?: Maybe<Scalars["String"]>;
};

/**
 * Enumeration of possible booking question display types on the
 * Organisation.BookingQuestion.display property
 */
export enum BookingQuestionVisibility {
  /**
   * An internal and external booking question. This question will appear in both
   * the internal booking flow and in customer-facing booking flows.
   */
  Both = "BOTH",
  /**
   * An external-only booking question. This question will be displayed in
   * customer-facing booking flows, but not the internal booking flow.
   */
  External = "EXTERNAL",
  /**
   * An internal-only booking question. This question will be displayed in
   * the internal booking flow, but not in customer-facing booking flows.
   */
  Internal = "INTERNAL",
}

export type BookingReservation = {
  bookingIds?: Maybe<Array<Scalars["ObjectID"]>>;
  pricePoints?: Maybe<Array<BookingToolPricePointInput>>;
  reservedSpaceId: Scalars["ObjectID"];
  tierId?: Maybe<Scalars["ObjectID"]>;
  timezone: Scalars["String"];
};

export enum BookingStatus {
  Cancelled = "CANCELLED",
  Confirmed = "CONFIRMED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingTool = {
  __typename?: "BookingTool";
  /** Unique identifier for this booking tool. */
  _id: Scalars["ObjectID"];
  /** The number of organisations that are enabled on this booking tool. */
  accountsNumber: Scalars["Int"];
  /**
   * Go-forward brand configuration for the booking tool. When unset, this is
   * computed on-the-fly from `customColours` at resolve time (see the
   * `brand` field resolver) — it is never null for a client reading this
   * field, even if nothing has ever been written to `brand` in the database.
   */
  brand?: Maybe<Brand>;
  /**
   * Returns 'true' if the callee is an administrative user on _all_ accounts
   * that this booking tool is associated with, and consequently is allowed to
   * modify this booking tool. This field can only be returned if accessing by means
   * of a UserCredential.
   */
  canEdit: Scalars["Boolean"];
  /** Date and time that this booking tool was created at. */
  createdOn: Scalars["Date"];
  /**
   * Custom colours, defined by the client, which override
   * the default colours of the booking tool.
   */
  customColours?: Maybe<CustomColours>;
  /**
   * When present, will display a customised title (browser metadata) at the top of
   * the browser window when this tool is accessed via the "widget url".
   */
  customWidgetUrlTitle?: Maybe<Scalars["String"]>;
  /** Date the facebook business extension was last installed. */
  facebookBusinessExtensionLastInstalled?: Maybe<Scalars["Date"]>;
  /**
   * Boolean representing whether the booking tool is a
   * facebook business extension widget.
   */
  facebookBusinessExtensionWidget: Scalars["Boolean"];
  /**
   * Custom fonts, defined by the client,
   * which override the default fonts of the booking tool.
   */
  fonts?: Maybe<Fonts>;
  /**
   * Boolean representing whether the end-user will be shown the organisation
   * selection step in the booking tool in cases where the booking tool only
   * has a single organisation.
   *
   * This value only affects booking tools with a single organisation. If there
   * are multiple organisations, the organisation selection step is mandatory,
   * regardless of this field.
   *
   * However, for historical support reasons we still need to give clients the
   * option to show their users an organisation step with only one organisation
   * to choose from, so that is what this field controls.
   */
  forceOrganisationSelection: Scalars["Boolean"];
  /**
   * A country code which requires any phone number entered when placing
   * a booking through the booking tool to be from the specified country.
   */
  forcePhoneValidationToCountry?: Maybe<Scalars["String"]>;
  /**
   * Boolean representing whether the end-user will be able to select a
   * service using this booking tool.
   */
  forceServiceSelection: Scalars["Boolean"];
  /** Check if the organisation is present on this bookingTool. */
  hasOrganisationBySlug: Scalars["Boolean"];
  /** A boolean that represents if the booking tool should hide the footer or not. */
  hideAppointeddFooter?: Maybe<Scalars["Boolean"]>;
  /**
   * Config and customisation data for the
   * location selection feature of the booking tool.
   */
  locationSelection?: Maybe<LocationSelection>;
  /** A signed JWT for authenticating requests to the mapkit api on a booking tools app */
  mapkitAuthenticationToken: Scalars["String"];
  /**
   * Boolean representing whether more than one booking can be placed in
   * a single transaction using this booking tool.
   */
  multipleBookingsEnabled: Scalars["Boolean"];
  /**
   * Internal human-readable name identifying this booking tool.
   * This is not exposed to the end-user.
   */
  name: Scalars["String"];
  /** When present, will enable the booking flow which combines the organisation and availability steps */
  organisationAvailabilityFlow: Scalars["Boolean"];
  /**
   * One or more organisations that are associated with this booking tool.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  organisations: OrganisationPage;
  /**
   * Query available time slot intervals for one or more organisations
   * associated to this bookingTool for a specific date range.
   *
   * This resolver returns availability for a single service only per organisation.
   * This resolver is only intended for bookingTools that have 1 service assigned
   * to the bookingTool per organisation.
   *
   * If queryByOrganisationTimeZone is set to true, the timezone string will be ignored
   * and the timezone of each organisation will be used to make the availability query.
   */
  organisationsAvailability: Array<OrganisationIntervals>;
  /**
   * Once this percentage of spaces for a booking have been filled, the
   * booking tool will show the number of remaining spaces to end-users.
   */
  percentageThresholdForShowingRemainingNumberOfSpaces?: Maybe<Scalars["Int"]>;
  /** This determines the mode of resource selection for this bookingTool. */
  resourceEnabledMode: ResourceEnabledMode;
  /**
   * Determines how resources are displayed and selected for this booking tool.
   *
   * If the value is DISABLED, the resources step will not appear in the booking
   * flow, but otherwise this value determines which version of the resources
   * step should be used.
   */
  resourceSelectionMode: ResourceSelectionMode;
  /**
   * One or more resource groups that this booking tool is restricted to.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  restrictedToResourceGroups: ResourceGroupPage;
  /** Paginated list of resources that this booking tool is restricted to. */
  restrictedToResources: ResourcePage;
  /** Paginated list of service categories that this booking tool is restricted to. */
  restrictedToServiceCategories: CategoryPage;
  /** Paginated list of services that this booking tool is restricted to. */
  restrictedToServices: ServicePage;
  /** This determines the mode of service selection for this bookingTool. */
  serviceEnabledMode: ServiceEnabledMode;
  /**
   * One or more services that are associated with this booking tool.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  services: ServicePage;
  /**
   * The unit of measurement used when displaying distance information
   * on the booking tool.
   */
  unitOfMeasurement: UnitOfMeasurement;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolHasOrganisationBySlugArgs = {
  slug: Scalars["String"];
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolMapkitAuthenticationTokenArgs = {
  devProxy?: Maybe<Scalars["Boolean"]>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolOrganisationsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<OrganisationSortKey>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolOrganisationsAvailabilityArgs = {
  meta?: Maybe<AvailabilityRequestMetaData>;
  organisationIds: Array<Scalars["ObjectID"]>;
  queryByOrganisationTimeZone?: Maybe<Scalars["Boolean"]>;
  range: AvailabilityRange;
  timezone?: Maybe<Scalars["String"]>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolRestrictedToResourceGroupsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolRestrictedToResourcesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolRestrictedToServiceCategoriesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolRestrictedToServicesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  includeDeleted?: Maybe<Scalars["Boolean"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/** Entity for a booking tool, which can be used to make a booking. */
export type BookingToolServicesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  filters?: Maybe<ServiceFilters>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ServiceSortKey>;
};

export type BookingToolBookingResult = {
  __typename?: "BookingToolBookingResult";
  _id: Scalars["ObjectID"];
};

export type BookingToolDiscountInput = {
  customerEmail: Scalars["String"];
  discountCode: Scalars["String"];
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type BookingToolEdge = {
  __typename?: "BookingToolEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Booking tool that is on this page. */
  node: BookingTool;
};

export type BookingToolOrganisationEntry = {
  id: Scalars["ObjectID"];
  organisationAvailabilityDisplayMode: AvailabilityDisplayMode;
};

/**
 * Page containing the resulting booking tools for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type BookingToolPage = {
  __typename?: "BookingToolPage";
  /** Array of nodes containing the booking tools that are on this page. */
  edges: Array<BookingToolEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: BookingToolPageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type BookingToolPageInfo = {
  __typename?: "BookingToolPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type BookingToolPricePointInput = {
  pricePointId: Scalars["ObjectID"];
  quantity: Scalars["Int"];
};

export type BookingToolServiceEntry = {
  availabilityDisplayMode: AvailabilityDisplayMode;
  id: Scalars["ObjectID"];
};

export enum BookingToolSortKey {
  Name = "NAME",
  Natural = "NATURAL",
}

/** Enumeration of possible options on the Service.bookingBookingVisibilityType property */
export enum BookingVisibilityType {
  /** The customer completes the external booking flow online. */
  Bookable = "BOOKABLE",
  /** Customers cannot view or book this service on booking tools. */
  Invisible = "INVISIBLE",
  /** The request is sent allowing the business to accept/decline the booking. */
  Request = "REQUEST",
  /** Customers are unable to book online and are prompted to call/email the business to arrange booking. */
  Unavailable = "UNAVAILABLE",
}

export type BookingWidget = {
  __typename?: "BookingWidget";
  /** Unique identifier for this widget. */
  _id: Scalars["ObjectID"];
  /** Colour of the frame of the widget. */
  colourOne: Scalars["String"];
  /** Colour of the buttons on the widget. */
  colourTwo: Scalars["String"];
  /** Date this widget was created. */
  created: Scalars["Date"];
  /** Date when the facebook extension was last connected. */
  facebookBusinessExtensionLastInstalled?: Maybe<Scalars["Date"]>;
  /** Boolean to tell if the widget is facebook specific. */
  facebookBusinessExtensionWidget?: Maybe<Scalars["Boolean"]>;
  /** If resource group selection is allowed for the widget. */
  groupsSelectable?: Maybe<Scalars["Boolean"]>;
  /** Ever increasing id number. */
  id: Scalars["Int"];
  /** if customers are allowed to make multiple bookings within one transaction. */
  multiBookingsEnabled?: Maybe<Scalars["Boolean"]>;
  /** Name of this widget. */
  name: Scalars["String"];
  /** Unique identifier of the organisation that this widget is connected to. */
  organisation?: Maybe<Organisation>;
  /** The resource that the booking widget is filtered by. */
  resource?: Maybe<Resource>;
  /** The resource groups that the booking widget is filtered by. */
  resourceGroups?: Maybe<ResourceGroup>;
  /** The service that the booking widget is limited to use. */
  service?: Maybe<Service>;
  /** The service category that the booking widget is limited to use. */
  serviceCategory?: Maybe<Category>;
  /** If resource selection is allowed for the widget. */
  staffSelectable?: Maybe<Scalars["Boolean"]>;
};

/**
 * Go-forward brand configuration for the booking tool, replacing
 * `customColours` as the source of truth for brand-driven UI (kept
 * alongside `customColours` for backward compatibility with existing direct
 * writes/admin tooling). When unset, `BookingTool.brand` is computed
 * on-the-fly from `customColours` at resolve time — see the `brand` field
 * resolver.
 *
 * Supports side-by-side light AND dark theme customisation, mirroring
 * `@appointedd/zod-types`'s `Document.BrandConfig.BrandConfigSchema`.
 */
export type Brand = {
  __typename?: "Brand";
  /**
   * Whether end visitors may manually toggle away from `brandThemeMode`.
   * Defaults to true at consumption time.
   */
  allowVisitorThemeOverride?: Maybe<Scalars["Boolean"]>;
  /**
   * Shared fallback banner URL, used when a theme-specific
   * `light.bannerUrl`/`dark.bannerUrl` isn't set.
   */
  bannerUrl?: Maybe<Scalars["String"]>;
  /** The default theme mode for this brand config. Defaults to AUTO. */
  brandThemeMode?: Maybe<BrandThemeMode>;
  /** Dark-theme brand palette overrides. */
  dark?: Maybe<BrandPalette>;
  /**
   * The favicon URL to display in the browser tab. Falls back to
   * Appointedd's default favicon when unset. Shared across both themes.
   */
  faviconUrl?: Maybe<Scalars["String"]>;
  /**
   * The CSS font-family value to apply when fontUrl is set. Shared across
   * both themes.
   */
  fontFamily?: Maybe<Scalars["String"]>;
  /**
   * A Google Fonts (or similar) stylesheet URL to load before paint. Shared
   * across both themes.
   */
  fontUrl?: Maybe<Scalars["String"]>;
  /** Light-theme brand palette overrides. */
  light?: Maybe<BrandPalette>;
  /**
   * Shared fallback logo URL, used when a theme-specific `light.logoUrl`/
   * `dark.logoUrl` isn't set.
   */
  logoUrl?: Maybe<Scalars["String"]>;
  /** The client's company/brand name. */
  name?: Maybe<Scalars["String"]>;
  /**
   * A suffix appended to the page/tab title (e.g. "Appointedd - Booking
   * Tools | <pageTitleSuffix>"). Shared across both themes.
   */
  pageTitleSuffix?: Maybe<Scalars["String"]>;
};

export type BrandInput = {
  /** Whether end visitors may manually toggle away from `brandThemeMode`. */
  allowVisitorThemeOverride?: Maybe<Scalars["Boolean"]>;
  /** Shared fallback banner URL. */
  bannerUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** The default theme mode for this brand config. Defaults to AUTO. */
  brandThemeMode?: Maybe<BrandThemeMode>;
  /** Dark-theme brand palette overrides. */
  dark?: Maybe<BrandPaletteInput>;
  /**
   * The favicon URL to display in the browser tab. Falls back to
   * Appointedd's default favicon when unset.
   */
  faviconUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** The CSS font-family value to apply when fontUrl is set. */
  fontFamily?: Maybe<Scalars["FontFamily"]>;
  /** A Google Fonts (or similar) stylesheet URL to load before paint. */
  fontUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** Light-theme brand palette overrides. */
  light?: Maybe<BrandPaletteInput>;
  /** Shared fallback logo URL. */
  logoUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** The client's company/brand name. */
  name?: Maybe<Scalars["String"]>;
  /** A suffix appended to the page/tab title. */
  pageTitleSuffix?: Maybe<Scalars["String"]>;
};

/**
 * A single theme's worth (light OR dark) of brand colour/logo/banner
 * customisation. All fields are optional — unset fields fall back to
 * Appointedd static defaults at resolve time (see
 * `Document.BrandConfig.resolveBrandPalette` in `@appointedd/zod-types`).
 */
export type BrandPalette = {
  __typename?: "BrandPalette";
  /** Secondary accent colour for icons, labels, dividers. Defaults to primaryColor. */
  accentColor?: Maybe<Scalars["String"]>;
  /** Per-theme banner URL override. Falls back to `Brand.bannerUrl` when unset. */
  bannerUrl?: Maybe<Scalars["String"]>;
  /** Per-theme logo URL override. Falls back to `Brand.logoUrl` when unset. */
  logoUrl?: Maybe<Scalars["String"]>;
  /** The page/backdrop background — a CSS colour, gradient, or image URL. */
  pageBackground?: Maybe<Scalars["String"]>;
  /** The colour of the primary call-to-action buttons. Defaults to primaryColor. */
  primaryActionColor?: Maybe<Scalars["String"]>;
  /** The primary brand colour for the booking tool. */
  primaryColor?: Maybe<Scalars["String"]>;
  /** A darker variant of the primary colour, used for hover/pressed states. */
  primaryDarkColor?: Maybe<Scalars["String"]>;
  /** A lighter variant of the primary colour, used for tints/selected-state washes. */
  primaryLightColor?: Maybe<Scalars["String"]>;
  /** The surface/background colour for cards and panels in this theme. */
  surfaceColor?: Maybe<Scalars["String"]>;
  /** The default text/ink colour for this theme. */
  textColor?: Maybe<Scalars["String"]>;
};

export type BrandPaletteInput = {
  accentColor?: Maybe<Scalars["HexColourCode"]>;
  bannerUrl?: Maybe<Scalars["HttpsUrl"]>;
  logoUrl?: Maybe<Scalars["HttpsUrl"]>;
  pageBackground?: Maybe<Scalars["PageBackground"]>;
  primaryActionColor?: Maybe<Scalars["HexColourCode"]>;
  primaryColor?: Maybe<Scalars["HexColourCode"]>;
  primaryDarkColor?: Maybe<Scalars["HexColourCode"]>;
  primaryLightColor?: Maybe<Scalars["HexColourCode"]>;
  surfaceColor?: Maybe<Scalars["HexColourCode"]>;
  textColor?: Maybe<Scalars["HexColourCode"]>;
};

/**
 * The theme options available for forcing the booking tool UI's brand theme.
 * Legacy enum kept for `CustomColours.theme` backward compatibility only —
 * see `BrandThemeMode` for the go-forward `Brand.brandThemeMode` field.
 */
export enum BrandTheme {
  Dark = "DARK",
  Light = "LIGHT",
}

/**
 * The brand theme mode options available on `Brand.brandThemeMode`. `AUTO`
 * follows the visitor's `prefers-color-scheme` system setting;
 * `LIGHT`/`DARK` force that theme by default (subject to
 * `allowVisitorThemeOverride`).
 */
export enum BrandThemeMode {
  Auto = "AUTO",
  Dark = "DARK",
  Light = "LIGHT",
}

export type BuffersInput = {
  after: Scalars["String"];
  before: Scalars["String"];
};

export type CalculatedDiscount = {
  __typename?: "CalculatedDiscount";
  /**
   * Value of the deduction that has been applied to the service price, represented
   * in the lowest denomination of currency (i.e. pence)
   */
  discount: Scalars["Int"];
  /**
   * Net price of the service after the discount code has been applied, represented
   * in the lowest denomination of currency (i.e. pence).
   */
  discountedPrice: Scalars["Int"];
  /**
   * Unique identifier of the service the discount is applied to, its presence here
   * implies that it was a valid service to apply the discount to.
   */
  serviceId: Scalars["ObjectID"];
  /** If provided, the identifier of the servicePrice that generated this discount. */
  servicePriceId?: Maybe<Scalars["String"]>;
};

export type CalculatedDiscountResult = CalculatedDiscounts | NoDiscount;

export type CalculatedDiscounts = {
  __typename?: "CalculatedDiscounts";
  discounts: Array<CalculatedDiscount>;
};

export type CancelBookingData = {
  __typename?: "CancelBookingData";
  alreadyCancelled: Scalars["Boolean"];
  bookingId: Scalars["ObjectID"];
  customerId: Scalars["ObjectID"];
  endTime: Scalars["Float"];
  isRecurring: Scalars["Boolean"];
  locale?: Maybe<Scalars["String"]>;
  organisation: CancelBookingOrganisation;
  resource?: Maybe<CancelBookingResource>;
  service: CancelBookingService;
  startTime: Scalars["Float"];
  timezone: Scalars["String"];
};

export type CancelBookingOrganisation = {
  __typename?: "CancelBookingOrganisation";
  _id: Scalars["ObjectID"];
  /**
   * Org-level brand configuration (Phase 1 of org-level brand
   * configuration — see Organisation.brandConfig). There is no
   * BookingTool.brand/customColours available in the cancel flow (no
   * bookingToolId), so org-level brandConfig is the only brand tier
   * resolvable here.
   */
  brandConfig?: Maybe<Brand>;
  cancellationNoticePeriod?: Maybe<Scalars["Float"]>;
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type CancelBookingResource = {
  __typename?: "CancelBookingResource";
  _id: Scalars["ObjectID"];
  name: Scalars["String"];
};

export type CancelBookingResult = {
  __typename?: "CancelBookingResult";
  success: Scalars["Boolean"];
};

export type CancelBookingService = {
  __typename?: "CancelBookingService";
  _id: Scalars["ObjectID"];
  name: Scalars["String"];
};

export type Category = {
  __typename?: "Category";
  /** Unique identifier for this category. */
  _id: Scalars["ObjectID"];
  /** Label for this category. */
  label?: Maybe<Scalars["String"]>;
  /** Name of this category. */
  name: Scalars["String"];
  /** Order value for this category */
  order?: Maybe<Scalars["Int"]>;
  /** Organisation this category is associated with. */
  organisation: Organisation;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type CategoryEdge = {
  __typename?: "CategoryEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Category that is on this page. */
  node: Category;
};

/**
 * Page containing the resulting categories for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type CategoryPage = {
  __typename?: "CategoryPage";
  /** Array of nodes containing the categories that are on this page. */
  edges: Array<CategoryEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: CategoryPageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type CategoryPageInfo = {
  __typename?: "CategoryPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type CategorySearchCondition = {
  condition?: Maybe<CategorySearchConditionType>;
  parameters: Array<CategorySearchParameter>;
};

export enum CategorySearchConditionType {
  And = "AND",
  Or = "OR",
}

export type CategorySearchInput = {
  searchTerm: Scalars["String"];
  selectedOrganisationIds: Array<Scalars["ObjectID"]>;
};

export type CategorySearchParameter = {
  name?: Maybe<Scalars["String"]>;
};

export enum CategorySortKey {
  Name = "NAME",
  Natural = "NATURAL",
}

export type CloneBookingToolInput = {
  _id: Scalars["ObjectID"];
};

export type ConnectKeyloopInput = {
  clientId: Scalars["String"];
  clientSecret: Scalars["String"];
  enterpriseId: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  storeId: Scalars["String"];
};

export type ConnectKeyloopResult = {
  __typename?: "ConnectKeyloopResult";
  internalClientId: Scalars["ObjectID"];
};

export type ConvertedYextAddress = {
  __typename?: "ConvertedYextAddress";
  city?: Maybe<Scalars["String"]>;
  postcode?: Maybe<Scalars["String"]>;
  street?: Maybe<Scalars["String"]>;
};

export type CreateBookingToolInput = {
  /** Go-forward brand configuration for the booking tool. */
  brand?: Maybe<BrandInput>;
  /**
   * Custom colours, defined by the client, which override
   * the default colours of the booking tool.
   */
  customColours?: Maybe<CustomColoursInput>;
  /**
   * Custom fonts, defined by the client,
   * which override the default fonts of the booking tool.
   */
  fonts?: Maybe<FontsInput>;
  /**
   * A country code which requires any phone number entered when
   * placing a booking through the booking tool to be from the
   * specified country.
   */
  forcePhoneValidationToCountry?: Maybe<Scalars["String"]>;
  /**
   * Boolean representing whether the end-user will be able to
   * select a service using this booking tool.
   */
  forceServiceSelection?: Maybe<Scalars["Boolean"]>;
  /**
   * Config and customisation data for the
   * location selection feature of the booking tool.
   */
  locationSelection?: Maybe<LocationSelectionInput>;
  /**
   * Internal human-readable name identifying this booking tool.
   * This is not exposed to the end-user.
   */
  name: Scalars["String"];
  /**
   * One or more organisation Ids that are associated with this
   * booking tool.
   */
  organisations: Array<BookingToolOrganisationEntry>;
  /**
   * Once this percentage of spaces for a booking have been filled,
   * the booking tool will show the number of remaining spaces to
   * end-users.
   */
  percentageThresholdForShowingRemainingNumberOfSpaces?: Maybe<Scalars["Int"]>;
  /**
   * Determines how resources are displayed and selected for
   * this booking tool.
   *
   * If the value is DISABLED, the resources step will not appear
   * in the booking flow, but otherwise this value determines
   * which version of the resources step should be used.
   */
  resourceSelectionMode: ResourceSelectionMode;
  /**
   * Restricts this booking tool to resources in specific resource
   * groups
   */
  restrictToResourceGroupIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /** Restricts this booking tool to specific resources */
  restrictToResourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /**
   * Restricts this booking tool to services associated to
   * specific service categories.
   */
  restrictToServiceCategoryIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /**
   * Internal human-readable name identifying this booking tool.
   * This is not exposed to the end-user.
   */
  serviceEntries?: Maybe<Array<BookingToolServiceEntry>>;
  /**
   * The unit of measurement used when displaying distance
   * information on the booking tool.
   */
  unitOfMeasurement: UnitOfMeasurement;
};

export type CreateBookingsResult = {
  __typename?: "CreateBookingsResult";
  bookings: Array<BookingToolBookingResult>;
};

export type CreateBookingsWithAdyenResult = {
  __typename?: "CreateBookingsWithAdyenResult";
  action?: Maybe<Scalars["String"]>;
  bookings: Array<BookingToolBookingResult>;
  invoiceId?: Maybe<Scalars["ObjectID"]>;
  resultCode?: Maybe<Scalars["String"]>;
};

export type CreateCategoryInput = {
  label?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type CreateDiscountCodeInput = {
  /**
   * Boolean representing whether this discount code is currently active.
   * If 'true' this discount code is available for redemption.
   */
  active: Scalars["Boolean"];
  /**
   * Code that the end-user must provide to redeem this discount.
   * If this code is being created as live, the code must not already
   * be the same (case insensitively) as another live code for this
   * organisation.
   */
  code: Scalars["String"];
  /** Object representing the deduction applied to a given price. */
  discount: DiscountCodeDiscountInput;
  /** Range of time in which this discount code can be redeemed. */
  expiry: DiscountCodeExpiryInput;
  /**
   * Internal human-readable label identifying this discount code, this
   * label is not exposed to the end-user.
   */
  label: Scalars["String"];
  /** Maximum number of times this discount code can be claimed globally. */
  maxClaims?: Maybe<Scalars["Int"]>;
  /** Maximum number of times this discount code can be claimed for a given email address. */
  maxClaimsPerCustomer?: Maybe<Scalars["Int"]>;
  /** Id of the organisation this discount role is being created for. */
  organisationId: Scalars["ObjectID"];
  /** The services this discount code is applicable to */
  serviceIds: Array<Scalars["ObjectID"]>;
};

export type CreateParticipantUploadPresignedUrlInput = {
  /** Extension of the file that is being uploaded. */
  fileExtension: Scalars["String"];
  /**
   * Id of the organisation that the uploaded file will be
   * associated with.
   */
  organisationId: Scalars["ObjectID"];
  /**
   * Id of a valid reservation to verify file upload is
   * permissible.
   */
  reservationId: Scalars["ObjectID"];
};

export type CreateReservationRecurringInput = {
  bookingIds: Array<Maybe<Scalars["String"]>>;
  expiresAfter?: Maybe<Scalars["Int"]>;
  organisationId: Scalars["ObjectID"];
  recurringId: Scalars["String"];
  requiredSpaces: Scalars["Int"];
  source: Scalars["String"];
};

export type CreateReservationResult = {
  __typename?: "CreateReservationResult";
  reservation: Reservation;
  reservedSpace: ReservedSpace;
};

export type CreateSamlDomainInput = {
  /** The domain of the provider */
  domain: Scalars["String"];
  /** Url of the SAML file saved in an S3 bucket */
  s3SamlKey: Scalars["String"];
  /** Id of the user who will become a super user */
  userId: Scalars["ObjectID"];
};

export type CreateSamlDomainUserRoleInput = {
  /**
   * If true, the user can manage customers. This is only applicable to users
   * with the "Restricted" role as all other roles already have the ability to
   * manage customers.
   */
  allowCustomerManagement?: Maybe<Scalars["Boolean"]>;
  /**
   * Flag that indicates whether a "USER" type role can also modify their
   * associated resources working hours.
   */
  allowScheduleModification?: Maybe<Scalars["Boolean"]>;
  /** If true, prevent this user from accessing the calendar sync interface. */
  calendarSyncHidden?: Maybe<Scalars["Boolean"]>;
  /** The email address of the user who is having their role defined */
  email: Scalars["String"];
  /** Id of the organisation that the user will have access to */
  organisationId: Scalars["ObjectID"];
  /**
   * An array of resourceIds that represent the resources this user has access to.
   * This array is only populated if the role is set to USER (restricted)
   */
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /** The role that determines the users level of access */
  role: UserRole;
  /** Id of the samlDomain associated to this role */
  samlDomainId: Scalars["ObjectID"];
};

export type CreateSchedule = {
  /**
   * Indicates if this schedule marks the entity its associated with as available
   * or unavailable.
   */
  available: Scalars["Boolean"];
  /** Date and time that this schedule ends at. */
  end: Scalars["Date"];
  /** An optional array of dates where the schedule is not available */
  exceptions?: Maybe<Array<Scalars["Date"]>>;
  /** Optional reason that this schedule was made. */
  reason?: Maybe<Scalars["String"]>;
  /**
   * Recurrence rule that defines how this schedule recurs according to the RRULE
   * specification.
   */
  rrule?: Maybe<Scalars["RRule"]>;
  /** Date and time that this schedule starts at. */
  start: Scalars["Date"];
  /** Reference to the entity that is the subject of this schedule. */
  subjectEntity: EntityRef;
  /** Unique identifier of the entity that this schedule is for. */
  subjectId: Scalars["ObjectID"];
  /**
   * Optional time zone that this schedule is in.
   *
   * If not set this will default to the organisation's time zone.
   */
  zone: Scalars["IANATimeZone"];
};

export type CreateServiceInput = {
  allowOnlineGroup: Scalars["Boolean"];
  assetIds?: Maybe<Array<Scalars["ObjectID"]>>;
  bookingDepositAmount?: Maybe<Scalars["String"]>;
  bookingNoticePeriod?: Maybe<Scalars["Int"]>;
  bookingPaymentOption: PaymentOption;
  bookingPaymentOptional?: Maybe<Scalars["Boolean"]>;
  bookingVisibilityType: BookingVisibilityType;
  buffers?: Maybe<BuffersInput>;
  categoryId: Scalars["ObjectID"];
  description?: Maybe<Scalars["String"]>;
  durations: Array<ServiceDurationInput>;
  generateTicketsEnabled: Scalars["Boolean"];
  image?: Maybe<Scalars["String"]>;
  location?: Maybe<Scalars["String"]>;
  maxParticipantsPerBooking?: Maybe<Scalars["Int"]>;
  microsoftTeamsMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  occupancy: Scalars["Int"];
  order?: Maybe<Scalars["Int"]>;
  organisationId: Scalars["ObjectID"];
  parts?: Maybe<Array<ServicePartInput>>;
  rescheduleEnabled?: Maybe<Scalars["Boolean"]>;
  rescheduleNoticePeriodHours?: Maybe<Scalars["Float"]>;
  rescheduleResourceSelectionEnabled?: Maybe<Scalars["Boolean"]>;
  resourceAllocationType: ResourceAllocationType;
  resourceGroups?: Maybe<Array<ServiceResourceGroupInput>>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  schedule?: Maybe<ServiceScheduleInput>;
  serviceType: ServiceType;
  tiers?: Maybe<Array<ServiceTierInput>>;
  zoomMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
};

export type CreateStripePaymentIntentInput = {
  /** The bookings that the payment intent is for, used to calculate the intent price */
  bookings: Array<BookingInput>;
  /** An optional discount applied to the invoice */
  discount?: Maybe<BookingToolDiscountInput>;
  /** The organisation we are creating the payment intent on behalf of */
  organisationId: Scalars["ObjectID"];
  /** Payment method id provide by the stripe UI */
  paymentMethodId: Scalars["String"];
};

export type CreateUserInput = {
  email: Scalars["String"];
  name: Scalars["String"];
  password?: Maybe<Scalars["String"]>;
};

export type CreateUserInviteInput = {
  details: InvitationDetailsInput;
  permissions: Array<InvitationPermissionInput>;
};

/** Represents a custom CRM field defined by an organisation. */
export type CrmField = {
  __typename?: "CrmField";
  /**
   * The user-defined unique id of this CRM Field. Note that this is a string
   * derived from the CRM Field's name, not an ObjectID
   */
  id: Scalars["String"];
  /**
   * Whether this CRM field should be hidden from customer-facing flows (ie the
   * Booking Tools). If true, the CRM Field will only be visible from the
   * internal management console.
   */
  internalOnly: Scalars["Boolean"];
  /**
   * The human-readable name of this CRM field, displayed to the user when the
   * field is presented for data entry (either from the internal management
   * console or as part of the Booking Tools booking flow)
   */
  name: Scalars["String"];
  /**
   * Whether this CRM Field is required to have a value. If false, the CRM Field
   * can accept an empty value as an answer.
   */
  required: Scalars["Boolean"];
  /**
   * The type of this CRM Field.
   *
   * Determines what type of input is presented to the user to record data for
   * this CRM Field, and therefore what type of data can be recorded.
   */
  type: CrmFieldType;
};

export type CrmFieldInput = {
  id: Scalars["String"];
  value: Scalars["String"];
};

/**
 * Enumeration of possible CRM field types on the Organisation.CRMField.type
 * property
 */
export enum CrmFieldType {
  /** A date CRM field */
  Date = "DATE",
  /** A plain text CRM field */
  Text = "TEXT",
}

export type CustomColours = {
  __typename?: "CustomColours";
  /** Secondary accent colour for icons, labels, dividers. Defaults to primary. */
  accentColour?: Maybe<Scalars["String"]>;
  /** The CSS font-family value to apply when fontUrl is set. */
  fontFamily?: Maybe<Scalars["String"]>;
  /** A Google Fonts (or similar) stylesheet URL to load before paint. */
  fontUrl?: Maybe<Scalars["String"]>;
  /** The URL of the client's logo to display in the booking tool. */
  logoUrl?: Maybe<Scalars["String"]>;
  /** The page/backdrop background — a CSS colour, gradient, or image URL. */
  pageBackground?: Maybe<Scalars["String"]>;
  /** The primary colour for the booking tool. */
  primary?: Maybe<Scalars["String"]>;
  /** The colour of the primary call-to-action buttons. Defaults to primary. */
  primaryActionColour?: Maybe<Scalars["String"]>;
  /** A darker variant of the primary colour, used for hover/pressed states. */
  primaryDarkColour?: Maybe<Scalars["String"]>;
  /** A lighter variant of the primary colour, used for tints/selected-state washes. */
  primaryLightColour?: Maybe<Scalars["String"]>;
  /** The secondary colour for the booking tool. */
  secondary?: Maybe<Scalars["String"]>;
  /** Forces the booking tool UI to a light or dark theme. Defaults to light. */
  theme?: Maybe<BrandTheme>;
};

export type CustomColoursInput = {
  /** Secondary accent colour for icons, labels, dividers. Defaults to primary. */
  accentColour?: Maybe<Scalars["HexColourCode"]>;
  /** The CSS font-family value to apply when fontUrl is set. */
  fontFamily?: Maybe<Scalars["FontFamily"]>;
  /** A Google Fonts (or similar) stylesheet URL to load before paint. */
  fontUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** The URL of the client's logo to display in the booking tool. */
  logoUrl?: Maybe<Scalars["HttpsUrl"]>;
  /** The page/backdrop background — a CSS colour, gradient, or image URL. */
  pageBackground?: Maybe<Scalars["PageBackground"]>;
  /** The primary colour for the booking tool. */
  primary?: Maybe<Scalars["HexColourCode"]>;
  /** The colour of the primary call-to-action buttons. Defaults to primary. */
  primaryActionColour?: Maybe<Scalars["HexColourCode"]>;
  /** A darker variant of the primary colour, used for hover/pressed states. */
  primaryDarkColour?: Maybe<Scalars["HexColourCode"]>;
  /** A lighter variant of the primary colour, used for tints/selected-state washes. */
  primaryLightColour?: Maybe<Scalars["HexColourCode"]>;
  /** The secondary colour for the booking tool. */
  secondary?: Maybe<Scalars["HexColourCode"]>;
  /** Forces the booking tool UI to a light or dark theme. Defaults to light. */
  theme?: Maybe<BrandTheme>;
};

export type Customer = {
  __typename?: "Customer";
  /** Unique identifier for this customer. */
  _id: Scalars["ObjectID"];
  /**
   * Paginated list of this Customer's bookings.
   * This includes bookings on other organisations within an account group
   * if the first name, last name and email address match customers within
   * the other organisations.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  bookings: CustomerBookingsPage;
  /** The first name of this customer. */
  firstName: Scalars["String"];
  /** The last name of this customer. */
  lastName: Scalars["String"];
  /** The organisation this customer is in. */
  organisation: Organisation;
};

export type CustomerBookingsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type CustomerBookingsEdge = {
  __typename?: "CustomerBookingsEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Booking that is on this page. */
  node: Booking;
};

/**
 * Page containing the resulting bookings for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type CustomerBookingsPage = {
  __typename?: "CustomerBookingsPage";
  /** Array of nodes containing the assets that are on this page. */
  edges: Array<CustomerBookingsEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: CustomerBookingsPageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type CustomerBookingsPageInfo = {
  __typename?: "CustomerBookingsPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type CustomerInput = {
  crmFieldData: Array<CrmFieldInput>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  marketingOptIn?: Maybe<Scalars["Boolean"]>;
  phone?: Maybe<Scalars["String"]>;
};

export type DeleteBookingToolInput = {
  _id: Scalars["ObjectID"];
};

export type DeleteDiscountCodeInput = {
  _id: Scalars["ObjectID"];
};

export type DeleteUserAccountPermissionInput = {
  _id: Scalars["ObjectID"];
};

export type DeleteUserInput = {
  _id: Scalars["ObjectID"];
};

/** Type representing the deduction that should be applied to a given price. */
export type Discount = {
  __typename?: "Discount";
  type: DiscountType;
  /**
   * The value of this discount, the behaviour of this field is dependent on
   * the DiscountType field.
   */
  value: Scalars["Int"];
};

/**
 * Entity that represents a single discount code
 * that can be used when making a booking.
 */
export type DiscountCode = {
  __typename?: "DiscountCode";
  /** Unique identifier for this discount code. */
  _id: Scalars["ObjectID"];
  /**
   * Boolean representing whether this discount code is currently active.
   * If 'true' this discount code is available for redemption.
   */
  active: Scalars["Boolean"];
  calculatedDiscount: CalculatedDiscountResult;
  /** Code that the end-user must provide to redeem this discount. */
  code: Scalars["String"];
  /** Time this discount code was created. */
  created: Scalars["Date"];
  /** Time this discount code was soft deleted. */
  deleted?: Maybe<Scalars["Date"]>;
  /** Object representing the deduction applied to a given price. */
  discount: Discount;
  /** Optional range of time in which this discount code can be redeemed. */
  expiry: DiscountCodeExpiry;
  /**
   * Internal human-readable label identifying this discount code, this
   * label is not exposed to the end-user.
   */
  label: Scalars["String"];
  /** Maximum number of times this discount code can be claimed globally. */
  maxClaims?: Maybe<Scalars["Int"]>;
  /** Maximum number of times this discount code can be claimed for a given email address. */
  maxClaimsPerCustomer?: Maybe<Scalars["Int"]>;
  /** The number of services associated to this discount code. */
  serviceCount: Scalars["Int"];
  /**
   * One or more services that are associated with this discount code.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  services: ServicePage;
  /** The total number of redemptions against this discount code. */
  totalClaims: Scalars["Int"];
  /** The monetary value of all redemptions against this discount code. */
  totalMonetaryValue: Scalars["Int"];
  /** Time this discount code was last updated. */
  updated?: Maybe<Scalars["Date"]>;
};

/**
 * Entity that represents a single discount code
 * that can be used when making a booking.
 */
export type DiscountCodeCalculatedDiscountArgs = {
  email?: Maybe<Scalars["String"]>;
  input: Array<ServicePriceInput>;
};

/**
 * Entity that represents a single discount code
 * that can be used when making a booking.
 */
export type DiscountCodeServicesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ServiceSortKey>;
};

export type DiscountCodeDiscountInput = {
  type: DiscountType;
  value: Scalars["Int"];
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type DiscountCodeEdge = {
  __typename?: "DiscountCodeEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** DiscountCode that is on this page. */
  node: DiscountCode;
};

/** Represents an optional range of time which this discount code can be redeemed */
export type DiscountCodeExpiry = {
  __typename?: "DiscountCodeExpiry";
  end?: Maybe<Scalars["Date"]>;
  start?: Maybe<Scalars["Date"]>;
};

export type DiscountCodeExpiryInput = {
  end?: Maybe<Scalars["Date"]>;
  start?: Maybe<Scalars["Date"]>;
};

/**
 * Page containing the resulting DiscountCodes for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type DiscountCodePage = {
  __typename?: "DiscountCodePage";
  /** Array of nodes containing the DiscountCodes that are on this page. */
  edges: Array<DiscountCodeEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: DiscountCodePageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type DiscountCodePageInfo = {
  __typename?: "DiscountCodePageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export enum DiscountCodeSortKey {
  Natural = "NATURAL",
}

export type DiscountInput = {
  customerEmail: Scalars["String"];
  discountCode: Scalars["String"];
};

/** Enumeration of possible discount types on the discount entity. */
export enum DiscountType {
  /**
   * A discount of this type will remove the value
   * provided (represented as pence, or smallest denomination of currency)
   * from the total price.
   */
  Fixed = "FIXED",
  /**
   * A discount of this type will remove this percentage of the total
   * price.
   */
  Percentage = "PERCENTAGE",
}

export type Duration = {
  minutes: Scalars["Int"];
  type: DurationType;
};

export enum DurationType {
  Block = "BLOCK",
  Free = "FREE",
}

/**
 * Enumeration of possible entity types that can be used to dynamically reference
 * an entity without prior knowledge of the entity's name.
 *
 * See `Schedule.subjectId` and `Schedule.subjectEntity` for an example of
 * how this is used.
 */
export enum EntityRef {
  /** Reference to a resource entity in Appointedd. */
  Resource = "RESOURCE",
  /** Reference to a service entity in Appointedd. */
  Service = "SERVICE",
}

export type ExactSchedule = Schedule & {
  __typename?: "ExactSchedule";
  /** Unique identifier for this schedule. */
  _id: Scalars["ObjectID"];
  /**
   * Indicates if this schedule marks the entity its associated with as available
   * or unavailable.
   */
  available: Scalars["Boolean"];
  /** Date and time that this schedule was created at. */
  created: Scalars["Date"];
  /**
   * Optional date and time that this schedule was deleted at.
   *
   * If not set this indicates that this schedule is not deleted.
   */
  deleted?: Maybe<Scalars["Date"]>;
  /** Date and time that this schedule ends at. */
  end: Scalars["Date"];
  /** Unique identifier of the organisation that this schedule is in. */
  organisationId: Scalars["ObjectID"];
  /** Optional reason that this schedule was made. */
  reason?: Maybe<Scalars["String"]>;
  /** Date and time that this schedule starts at. */
  start: Scalars["Date"];
  /** Reference to the entity that is the subject of this schedule. */
  subjectEntity: EntityRef;
  /** Unique identifier of the entity that this schedule is for. */
  subjectId: Scalars["ObjectID"];
  /**
   * Optional date and time that this schedule was last updated at.
   *
   * If not set this indicates that this schedule has not been updated since it
   * was created.
   */
  updated?: Maybe<Scalars["Date"]>;
  /** Time zone that this schedule is in. */
  zone: Scalars["IANATimeZone"];
};

export type ExchangeGoogleCodeForDetailsInput = {
  code: Scalars["String"];
  redirectUrl: Scalars["String"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  _id: Scalars["ObjectID"];
  description: Scalars["String"];
  disabled_organisations?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  enabled_globally?: Maybe<Scalars["Boolean"]>;
  enabled_organisations?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  flag_id: Scalars["String"];
  updated?: Maybe<Scalars["Date"]>;
};

export type Fonts = {
  __typename?: "Fonts";
  /** URL for the booking tool's custom font, bold weight. */
  bold?: Maybe<Scalars["String"]>;
  /** URL for the booking tool's custom font, regular weight. */
  regular?: Maybe<Scalars["String"]>;
};

export type FontsInput = {
  /** URL for the booking tool's custom font, bold weight. */
  bold?: Maybe<Scalars["String"]>;
  /** URL for the booking tool's custom font, regular weight. */
  regular?: Maybe<Scalars["String"]>;
};

/** Enumeration of possible frequency types on the Booking.recurring property */
export enum FrequencyType {
  /** Bookings recur on a daily basis */
  Daily = "DAILY",
  /** Bookings recur on a monthly basis */
  Monthly = "MONTHLY",
  /** Bookings recur on a weekly basis */
  Weekly = "WEEKLY",
  /** Bookings recur on a yearly basis */
  Yearly = "YEARLY",
}

export type GenerateBookingWidgetInput = {
  organisationId: Scalars["ObjectID"];
};

export type GenerateGoogleOAuthLinkInput = {
  _id: Scalars["ObjectID"];
  redirectType: Scalars["String"];
};

/**
 * Feature in Appointedd that can only be active for everybody or
 * nobody at any given time.
 */
export type GlobalFeature = {
  __typename?: "GlobalFeature";
  /** Unique identifier for this feature. */
  _id: Scalars["ObjectID"];
  /** Description of what this feature does. */
  description: Scalars["String"];
  /** Indicates if the feature is enabled. */
  enabled: Scalars["Boolean"];
  /**
   * Human readable name for this feature. This must be unique among
   * the name of the other features.
   */
  name: Scalars["String"];
};

export type GoogleIdTokenInfo = {
  __typename?: "GoogleIdTokenInfo";
  email?: Maybe<Scalars["String"]>;
  sub?: Maybe<Scalars["String"]>;
};

export type GroupBookingInterval = {
  __typename?: "GroupBookingInterval";
  /** An interval may contain an existing booking that can be booked onto */
  booking: Booking;
  /** End date and time of this availability interval in UTC. */
  end: Scalars["Date"];
  /** The number of spaces that can still be booked on this group booking. */
  remainingSpaces?: Maybe<Scalars["Int"]>;
  /** Start date and time of this availability interval in UTC. */
  start: Scalars["Date"];
};

/** Represents a range of date(s) and time(s) in UTC. */
export type Interval = {
  __typename?: "Interval";
  /** End date and time of this interval in UTC. */
  end: Scalars["Date"];
  /** Start date and time of this interval in UTC. */
  start: Scalars["Date"];
};

export type IntervalQuery = {
  after: Scalars["Date"];
  before: Scalars["Date"];
};

export type InvitationDetailsInput = {
  /** Description for this UserInvitation. */
  description?: Maybe<Scalars["String"]>;
  /** Email of the user this UserInvitation is for. */
  email: Scalars["String"];
  /** First name of the user this UserInvitation is for. */
  firstName: Scalars["String"];
  /** Last name of the user this UserInvitation is for. */
  lastName: Scalars["String"];
};

export type InvitationPermissionInput = {
  /** Indicates whether the user will be able to modify their associated resources working hours for this UserInvitation. */
  allowScheduleModification: Scalars["Boolean"];
  /** The ids of the allowed resources for this UserInvitation. */
  allowedResourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /** The ID of the organisation this UserInvitation is for. */
  organisationId: Scalars["ObjectID"];
  /** The level of access this UserInvitation grants on the target organisation. */
  role: UserAccountPermissionRole;
};

export type JoinWaitlistInput = {
  bookingId: Scalars["ObjectID"];
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  phone?: Maybe<Scalars["String"]>;
  serviceId: Scalars["ObjectID"];
  timezone: Scalars["String"];
};

export type JoinWaitlistResult = {
  __typename?: "JoinWaitlistResult";
  message?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type LinkUserToFacebookInput = {
  /** The ID of the user being have their cognito account linked to google */
  _id: Scalars["ObjectID"];
  /** The ID Facebook uses to identify the user */
  facebookUserId: Scalars["String"];
};

export type LinkUserToGoogleInput = {
  /** The ID of the user being have their cognito account linked to google */
  _id: Scalars["ObjectID"];
  /** The google one time use code that is used in exchange for a google access token */
  code: Scalars["String"];
  /** The type of redirect that initiate the link to google request e.g. ACCOUNT */
  redirectType: Scalars["String"];
  /** A one time use state variable to validate the user making the request protect against CSRF attacks */
  state: Scalars["String"];
};

export type LinkUserToGoogleOnSignUpInput = {
  /** The ID of the user being have their cognito account linked to google */
  _id: Scalars["ObjectID"];
  /** Google's unique identifier for the google account ot be linked */
  googleSub: Scalars["String"];
};

export type Location = {
  __typename?: "Location";
  address: Scalars["String"];
  latitude: Scalars["String"];
  longitude: Scalars["String"];
};

export type LocationQueryMapping = {
  __typename?: "LocationQueryMapping";
  from: Scalars["String"];
  to: Scalars["String"];
};

export type LocationQueryMappingInput = {
  from: Scalars["String"];
  to: Scalars["String"];
};

export type LocationSelection = {
  __typename?: "LocationSelection";
  /** A list of countries to be included in the booking tool's location selection. */
  includedCountries?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /**
   * The maximum range, in kilometres, which can be searched in
   * the booking tool's location selection.
   */
  maxLocationSearchRange?: Maybe<Scalars["Int"]>;
  /**
   * The maximum number of location results to be displayed when using
   * the booking tool's location search.
   */
  maxLocationsToDisplay?: Maybe<Scalars["Int"]>;
  /**
   * The minimum number of location results to be displayed when using
   * the booking tool's location search.
   */
  minLocationsToDisplay?: Maybe<Scalars["Int"]>;
  /**
   * A list of location query mappings, used to override results from
   * the booking tool's location search.
   */
  overrideLocationSearchQueryMapping?: Maybe<Array<LocationQueryMapping>>;
  /**
   * If enabled the the booking tool will allow the user to search for a specific organisation
   * using a location search text input and a map displaying the searched results.
   */
  searchAndMapEnabled: Scalars["Boolean"];
};

export type LocationSelectionInput = {
  /** A list of countries to be included in the booking tool's location selection. */
  includedCountries?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /**
   * The maximum range, in kilometres, which can be searched in
   * the booking tool's location selection.
   */
  maxLocationSearchRange?: Maybe<Scalars["Int"]>;
  /**
   * The maximum number of location results to be displayed when using
   * the booking tool's location search.
   */
  maxLocationsToDisplay?: Maybe<Scalars["Int"]>;
  /**
   * The minimum number of location results to be displayed when using
   * the booking tool's location search.
   */
  minLocationsToDisplay?: Maybe<Scalars["Int"]>;
  /**
   * A list of location query mappings, used to override results from
   * the booking tool's location search.
   */
  overrideLocationSearchQueryMapping?: Maybe<Array<LocationQueryMappingInput>>;
  /**
   * If enabled the the booking tool will allow the user to search for a specific organisation
   * using a location search text input and a map displaying the searched results.
   */
  searchAndMapEnabled: Scalars["Boolean"];
};

export type MessagebirdSmsIntegration = {
  __typename?: "MessagebirdSmsIntegration";
  name: Scalars["String"];
};

export type MicrositeColours = {
  __typename?: "MicrositeColours";
  primary?: Maybe<Scalars["HexColourCode"]>;
  secondary?: Maybe<Scalars["HexColourCode"]>;
};

/** Settings that are applied to all MS Teams users for this organisation. */
export type MicrosoftTeamsMeetingIntegrationSettings = {
  __typename?: "MicrosoftTeamsMeetingIntegrationSettings";
  /** Whether automatic recording of meetings should be enabled for meetings created with this integration. */
  automaticRecordings: Scalars["Boolean"];
  /**
   * Whether we include an extended list of customer names in the title of the Teams meeting.
   * This option will include a comma seperated list of the first _four_ customers for a given meeting,
   * with an indicator showing the number of customers on the meeting above that number
   */
  extendedCustomerMeetingTitles: Scalars["Boolean"];
};

/** https://docs.microsoft.com/en-us/graph/api/resources/user?view=graph-rest-1.0 */
export type MicrosoftTeamsUserCredentials = {
  __typename?: "MicrosoftTeamsUserCredentials";
  /**
   * The unique identifier for the user. Should be treated as an opaque
   * identifier.
   *
   * Maps directly to the "id" property on the "User" object in the
   * Microsoft Graph API.
   */
  id?: Maybe<Scalars["String"]>;
  /**
   * The SMTP address for the user, for example,
   * "jeff@contoso.onmicrosoft.com".
   *
   * Maps directly to the "mail" property on the "User" object in the
   * Microsoft Graph API.
   */
  mail?: Maybe<Scalars["String"]>;
  /**
   * The user principal name (UPN) of the user. The UPN is an
   * Internet-style login name for the user based on the Internet
   * standard RFC 822. By convention, this should map to the user's
   * email name. The general format is alias@domain, where domain must
   * be present in the tenant's collection of verified domains. This
   * property is required when a user is created. The verified domains
   * for the tenant can be accessed from the verifiedDomains property
   * of organization.
   *
   * Maps directly to the "userPrincipalName" property on the "User"
   * object in the Microsoft Graph API.
   */
  userPrincipalName?: Maybe<Scalars["String"]>;
};

export type MigrateUserToCognitoInput = {
  /** The ID of the user being have their cognito account linked to google */
  _id: Scalars["ObjectID"];
  /** The users password, used for migrating the user to Cognito */
  password: Scalars["String"];
};

/** A sub configuration of the FrequencyType Monthly. Determines the behaviour of the monthly recurrence. */
export enum MonthlyRepeatType {
  /** Repeats monthly on a particular date of the month e.g. 4th of the month. */
  DayOfMonth = "DAY_OF_MONTH",
  /** Repeats monthly on a week & day e.g. Wednesday on every 2nd week of the month. */
  DayOfWeek = "DAY_OF_WEEK",
}

export type Mutation = {
  __typename?: "Mutation";
  /**
   * Creates a new account (Organisation, services and resources) and copies over the
   * selected users from the current organisation to the new organisation. The user
   * triggering the account creation must have an admin role on the current
   * organisation, that user will be made the new organisation owner and their email
   * address will be used as the business email. All organisation options and
   * settings will be the default for a new organisation with the exception of
   * is_enterprise and signup_partner, which will be copied from the current
   * organisation.
   *
   * A minimum of one resource and one service must be provided when calling this
   * mutation.
   */
  addNewAccount?: Maybe<Organisation>;
  /**
   * The same as addNewAccount but must be used for SAML SSO enabled organisations,
   * user assignment is prevented as this is handled by the SAML domain setup.
   */
  addNewSamlAccount?: Maybe<Organisation>;
  /** Adds the given step to the users setupChecklistCompletedSteps. */
  addUserSetupChecklistCompletedStep?: Maybe<User>;
  /** Marks the address as approved.. */
  approveBccAddress: BccEmail;
  assignMicrosoftTeamsUserToResource?: Maybe<Resource>;
  cancelBooking: CancelBookingResult;
  cancelSingleParticipant: BookingParticipant;
  /**
   * Clones an existing account, including organisation settings, categories,
   * services, resources, resource schedules, resource groups, communication
   * templates, custom questions, smart comms, booking widgets and copies over
   * the selected users from the current organisation to the new organisation.
   * The user triggering the clone must have an admin role on the current
   * organisation, that user will be made the new organisation owner.
   */
  cloneAccount?: Maybe<Organisation>;
  cloneBookingTool: BookingTool;
  /**
   * The same as cloneAccount but must be used for SAML SSO enabled organisations,
   * user assignment is prevented as this is handled by the SAML domain setup.
   */
  cloneSamlAccount?: Maybe<Organisation>;
  /** Marks the setup checklist as complete for the user. */
  completeUserSetupChecklist?: Maybe<User>;
  /** Connect the Appointedd SMS integration for the Organisation (requires approval). */
  connectAppointeddSmsIntegration?: Maybe<Organisation>;
  connectKeyloop: ConnectKeyloopResult;
  /** Connect the MessageBird SMS integration for the Organisation. */
  connectMessagebirdSmsIntegration?: Maybe<Organisation>;
  /** Connect the Twilio SMS integration for the Organisation. */
  connectTwilioSmsIntegration?: Maybe<Organisation>;
  /**
   * Create a new OAuth v2.x token for an organisation authorizing our Adyen
   * integration on their account.
   *
   * This is based off the `createOpenAuthIntegrationToken' mutation in our
   * `OpenAuthIntegration` module's graph, but performs some additional
   * required intialisation tasks in order for the Adyen integration to work
   * correctly.
   */
  createAdyenIntegrationToken: AdyenIntegrationToken;
  /** Attempts to create a payment in Adyen. */
  createAdyenPayment: AdyenPayment;
  /**
   * Create a new `AdyenSession` for a customers payment session within the
   * booking widget.
   */
  createAdyenSession: AdyenSession;
  createBookingTool: BookingTool;
  createBookingsForBookingTool: CreateBookingsResult;
  createBookingsWithAdyenInvoice: CreateBookingsWithAdyenResult;
  createBookingsWithSquareInvoice: CreateBookingsResult;
  createBookingsWithStripeInvoice: CreateBookingsResult;
  createBookingsWithUnpaidInvoice: CreateBookingsResult;
  createCategory: Category;
  createDiscountCode: DiscountCode;
  /** Create a new user in the Appointedd management application. */
  createManagementAppUser: User;
  createOpenAuthIntegrationGrantUrl: Scalars["String"];
  /**
   * Create a new OAuth v2.0 integration (External Application -> Appointedd) token
   * that allows us to authenticate and authorize requests to the external
   * application that this is for.
   *
   * An authorization code and state is used to create the token, which you can
   * obtain in the redirect response from an authorization flow initiated by the
   * grant URL in the `createOpenAuthIntegrationGrantUrl()` mutation.
   *
   * By default a token is assigned to a specific user in Appointedd; if you pass in
   * the `organisationId` parameter however it will instead be associated with a
   * specific organisation in Appointedd.
   */
  createOpenAuthIntegrationToken: OpenAuthIntegrationToken;
  /**
   * Creates a presigned url that allows the user to download
   * a file from the customer file upload S3 bucket.
   *
   * Url will only be generated if:
   *
   * - The caller has read permissions on the organisation
   * encoded in the key.
   * - The caller has read permissions on the organisation
   * tagged on the object itself.
   */
  createParticipantAttachmentDownloadUrl: Scalars["String"];
  /**
   * Creates a presigned url that allows the user to upload
   * a file to the customer file upload temporary S3 bucket.
   */
  createParticipantUploadPresignedUrl: Scalars["String"];
  createReservation: CreateReservationResult;
  createReservationForRecurringBooking: CreateReservationResult;
  /**
   * Creates an identity provider in cognito and stores
   * similar data in the db under saml_domain collection
   */
  createSamlDomain: SamlDomain;
  /** Creates a samlDomainUserRole document associated to a samlDomain, user & organisation */
  createSamlDomainUserRole: SamlDomainUserRole;
  /** Create a new schedule in an Appointedd organisation. */
  createSchedule: Schedule;
  createService: Service;
  createStripePaymentIntent: StripePaymentIntent;
  createUserClient: UserClientCreateResponse;
  createUserInvite: UserInvitation;
  createYextIntegrationToken: YextIntegrationToken;
  deleteBookingTool: BookingTool;
  deleteDiscountCode: DiscountCode;
  /** Delete an existing user in the Appointedd management application. */
  deleteManagementAppUser: User;
  deleteReservedSpace: Scalars["ObjectID"];
  /** Deletes a single samlDomainUserRole document using the samlDomainUserRoleId */
  deleteSamlDomainUserRole: SamlDomainUserRole;
  /** Delete a existing schedule in an Appointedd organisation. */
  deleteSchedule: Schedule;
  deleteUserAccountPermission: UserAccountPermission;
  deleteUserClient: Scalars["ObjectID"];
  /** Disables MFA for a users account. */
  disableMfa: User;
  /** Disables the Microsoft Teams meetings integration for an organisation. */
  disableMicrosoftTeamsMeetingsIntegration: Organisation;
  /**
   * Disables users with the same email address domain as the given SAML domain to
   * sign-in to their standard account via password or social sign-in if they
   * have one.
   *
   * If they attempt to sign-in via email address and password they will be
   * automatically redirected to the SAML SSO sign-in flow.
   */
  disablePasswordSignInForSamlDomain: SamlDomain;
  /** Disconnect the Adyen integration for an Appointedd organisation. */
  disconnectAdyenIntegration: Organisation;
  /** Disconnect the currently connected SMS integration for the organisation. */
  disconnectCurrentSmsIntegration?: Maybe<Organisation>;
  /** Disconnect the Facebook Business Extension integration for an organisation. */
  disconnectFacebookBusiness: Organisation;
  /** Enables MFA for a users account. */
  enableMfa: User;
  /** Enables the Microsoft Teams meetings integration for an organisation. */
  enableMicrosoftTeamsMeetingsIntegration: Organisation;
  /**
   * Enables users with the same email address domain as the given SAML domain to
   * sign-in to their standard account via password or social sign-in if they
   * have one.
   */
  enablePasswordSignInForSamlDomain: SamlDomain;
  /**
   * Takes a google code from a redirect url and exchanges it for the email and sub id
   * from the users google account.
   */
  exchangeGoogleCodeForDetails: GoogleIdTokenInfo;
  /**
   * Looks for a booking widget that is connected to an organisation and has a facebookBusinessExtensionWidget variable.
   * If no widget is found then unique widget that is specific to the facebook integration is created.
   * If a widget already exists then facebookBusinessExtensionLastInstalled variable is updated and that widget is returned.
   */
  generateFacebookBusinessExtensionWidget: BookingWidget;
  /**
   * Generate a single use OAuth2 URL with associated state for this user,
   * navigating to this url will initiate a flow which will return both an
   * authorization code and state.
   * This can be then used to associate a cognito user with a google account.
   */
  generateGoogleOAuthLink: Scalars["String"];
  /**
   * getAdyenPaymentConfirmation is used to confirm a payment after the customer has been presented a ThreeDS2 challenge.
   * The threeDSResult is generated by the Adyen drop-in component after the check has been completed
   */
  getAdyenPaymentConfirmation: AdyenPaymentConfirmation;
  getPresignedSamlUploadPostData: Scalars["String"];
  joinWaitlist: JoinWaitlistResult;
  /**
   * Connects a User to a Facebook User to allow the user to sign into their
   * Appointedd account using their Facebook credentials.
   */
  linkUserToFacebook: User;
  /**
   * Connects a User to a Google User to allow the user to sign into their
   * Appointedd account using their google credentials.
   */
  linkUserToGoogle: User;
  /**
   * Connects a User to a Google User on sign up, to allow the user to sign into their
   * Appointedd account using their google credentials.
   */
  linkUserToGoogleOnSignUp: User;
  mapYextLocationToAccount: YextIntegrationMappingResult;
  markServiceImagesForDeletion: Service;
  /**
   * If the user does not exist in the Cognito user pool they will be migrated to cognito using the
   * "migrateToCognito" shared method.
   */
  migrateUserToCognito: User;
  modifyArrivalStatus: Scalars["Boolean"];
  /** Permanently removes the address. */
  removeBccAddress: Organisation;
  removeFromWaitlist: RemoveFromWaitlistResult;
  removeYextLocationMappingToAccount?: Maybe<Organisation>;
  requestAdyenRefund: AdyenRefundRequestResult;
  /** Request approval to use the Appointedd SMS integration for the organisation. */
  requestAppointeddSmsIntegration?: Maybe<Organisation>;
  /**
   * Request a password reset email when the user has forgotten their password.
   * The email link contains a token that is made up of the users id and a random
   * 32 byte hex string.
   */
  requestManagementAppUserPasswordResetEmail: Scalars["Boolean"];
  rescheduleBooking: RescheduleBookingResult;
  /** Resends the approval email. */
  resendBccApprovalEmail: Organisation;
  /**
   * Send a test SMS message to the given number using the organisations current
   * SMS integration.
   */
  sendTestSms?: Maybe<Organisation>;
  /** Set the selected merchant account for an Appointedd organisation's Adyen integration. */
  setAdyenIntegrationSelectedMerchantAccount: AdyenIntegrationToken;
  /**
   * Set the Microsoft Teams meetings integration automatic recordings setting
   * for an organisation.
   */
  setMicrosoftTeamsMeetingsIntegrationAutomaticRecordings: Organisation;
  /**
   * Set the Microsoft Teams meetings integration extended customer titles setting
   * for an organisation.
   */
  setMicrosoftTeamsMeetingsIntegrationExtendedCustomerMeetingTitles: Organisation;
  /** Stores the email address and sends an approval email. */
  submitBccAddress: Organisation;
  /**
   * Submit the new password after requesting a password reset. If the token is
   * valid/unexpired and the password meets our complexity and history
   * requirements the users password will be updated in the legacy system and
   * cognito.
   */
  submitManagementAppUserPasswordReset: Scalars["Boolean"];
  /**
   * Is called after a super user accepts a user invite.
   * Will ensure that standard SSO users are granted the right access
   * to the organisation that has been newly added to the super user.
   */
  syncSuperUserInvite?: Maybe<SamlDomain>;
  /**
   * Unassign all Microsoft Teams users from all resources in your
   * organisation that are currently assigned to one.
   *
   * If you are making this request as a user that has only restricted
   * access to certain resources in your organisation, only those
   * resources that you have access to will be unassigned.
   *
   * The result of this mutation is the array of unique identifiers for
   * the resources that Microsoft Teams users were unassigned from.
   */
  unassignAllMicrosoftTeamsUsers: Array<Resource>;
  unassignMicrosoftTeamsUserFromResource?: Maybe<Resource>;
  /**
   * Unlinks a User from there account in the Cognito user pool and updates
   * the User account to show it is no longer connected to the Facebook account.
   */
  unlinkUserFromFacebook: User;
  /**
   * Unlinks a User from there account in the Cognito user pool and updates
   * the User account to show it is no longer connected to the Google account.
   */
  unlinkUserFromGoogle: User;
  updateBookingTool: BookingTool;
  updateDiscountCode: DiscountCode;
  /** Updates an existing user in the Appointedd management application. */
  updateManagementAppUser: User;
  /** Updates an existing users locale in the Appointedd management application. */
  updateManagementAppUserLocale: User;
  /**
   * Updates one or more sign-in properties for an existing user in the
   * Appointedd management application.
   */
  updateManagementAppUserSignInDetails: User;
  updateSamlDomain: SamlDomain;
  /** Updates a samlDomainUserRole document associated to a samlDomain, user & organisation */
  updateSamlDomainUserRole: SamlDomainUserRole;
  /** Update a schedule in an Appointedd organisation. */
  updateSchedule: Schedule;
  updateService: Service;
  /**
   * Update the currently connected SMS integration send from name or number
   * for the organisation.
   */
  updateSmsIntegrationSendFrom?: Maybe<Organisation>;
  updateUserAccountPermission: UserAccountPermission;
  updateUserClient: UserClient;
};

export type MutationAddNewAccountArgs = {
  accountName: Scalars["String"];
  currentOrganisationId: Scalars["ObjectID"];
  resources: Array<AddNewAccountResourceInput>;
  services: Array<AddNewAccountServiceInput>;
  users: Array<Scalars["ObjectID"]>;
};

export type MutationAddNewSamlAccountArgs = {
  accountName: Scalars["String"];
  currentOrganisationId: Scalars["ObjectID"];
  resources: Array<AddNewAccountResourceInput>;
  services: Array<AddNewAccountServiceInput>;
};

export type MutationAddUserSetupChecklistCompletedStepArgs = {
  step: UserSetupChecklistStep;
  userId: Scalars["ObjectID"];
};

export type MutationApproveBccAddressArgs = {
  organisationId: Scalars["ObjectID"];
  token: Scalars["String"];
};

export type MutationAssignMicrosoftTeamsUserToResourceArgs = {
  authCode: Scalars["String"];
  resourceId: Scalars["ObjectID"];
};

export type MutationCancelBookingArgs = {
  bookingId: Scalars["ObjectID"];
  customerId: Scalars["ObjectID"];
  recurringCascade?: Maybe<Scalars["Boolean"]>;
};

export type MutationCancelSingleParticipantArgs = {
  bookingId: Scalars["ObjectID"];
  participantId: Scalars["ObjectID"];
};

export type MutationCloneAccountArgs = {
  accountName: Scalars["String"];
  currentOrganisationId: Scalars["ObjectID"];
  users: Array<Scalars["ObjectID"]>;
};

export type MutationCloneBookingToolArgs = {
  input: CloneBookingToolInput;
};

export type MutationCloneSamlAccountArgs = {
  accountName: Scalars["String"];
  currentOrganisationId: Scalars["ObjectID"];
};

export type MutationCompleteUserSetupChecklistArgs = {
  userId: Scalars["ObjectID"];
};

export type MutationConnectAppointeddSmsIntegrationArgs = {
  from: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationConnectKeyloopArgs = {
  input: ConnectKeyloopInput;
};

export type MutationConnectMessagebirdSmsIntegrationArgs = {
  accessKey: Scalars["String"];
  from: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationConnectTwilioSmsIntegrationArgs = {
  accountSid: Scalars["String"];
  authToken: Scalars["String"];
  from: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationCreateAdyenIntegrationTokenArgs = {
  code: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  state: Scalars["String"];
};

export type MutationCreateAdyenPaymentArgs = {
  authenticationData: AdyenAuthenticationData;
  browserInfo: AdyenBrowserInfo;
  currency: Scalars["String"];
  invoiceId?: Maybe<Scalars["ObjectID"]>;
  organisationId: Scalars["ObjectID"];
  origin: Scalars["String"];
  paymentMethodData: Scalars["String"];
  reference: Scalars["String"];
  shopperEmail?: Maybe<Scalars["String"]>;
  shopperIP: Scalars["String"];
  value: Scalars["Float"];
};

export type MutationCreateAdyenSessionArgs = {
  countryCode: Scalars["String"];
  currency: Scalars["String"];
  locale: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  value: Scalars["Float"];
};

export type MutationCreateBookingToolArgs = {
  input: CreateBookingToolInput;
};

export type MutationCreateBookingsForBookingToolArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput>;
  createdSource: Scalars["String"];
  locale: Scalars["String"];
};

export type MutationCreateBookingsWithAdyenInvoiceArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput>;
  browserInfo?: Maybe<AdyenBrowserInfo>;
  createdSource: Scalars["String"];
  locale: Scalars["String"];
  origin: Scalars["String"];
  payment3DSResult?: Maybe<Scalars["String"]>;
  paymentAuthenticationData: AdyenAuthenticationData;
  paymentCurrency: Scalars["String"];
  paymentDiscount?: Maybe<BookingToolDiscountInput>;
  paymentInvoiceId?: Maybe<Scalars["ObjectID"]>;
  paymentMethodData?: Maybe<Scalars["String"]>;
  paymentValue: Scalars["Float"];
};

export type MutationCreateBookingsWithSquareInvoiceArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput>;
  cardToken: Scalars["String"];
  createdSource: Scalars["String"];
  discount?: Maybe<BookingToolDiscountInput>;
  locale: Scalars["String"];
  squareBuyerVerificationToken: Scalars["String"];
};

export type MutationCreateBookingsWithStripeInvoiceArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput>;
  cardToken: Scalars["String"];
  createdSource: Scalars["String"];
  discount?: Maybe<BookingToolDiscountInput>;
  locale: Scalars["String"];
};

export type MutationCreateBookingsWithUnpaidInvoiceArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput>;
  createdSource: Scalars["String"];
  discount?: Maybe<BookingToolDiscountInput>;
  locale: Scalars["String"];
};

export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};

export type MutationCreateDiscountCodeArgs = {
  input: CreateDiscountCodeInput;
};

export type MutationCreateManagementAppUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateOpenAuthIntegrationGrantUrlArgs = {
  openAuthIntegrationClientId: Scalars["ObjectID"];
};

export type MutationCreateOpenAuthIntegrationTokenArgs = {
  code: Scalars["String"];
  organisationId?: Maybe<Scalars["ObjectID"]>;
  state: Scalars["String"];
};

export type MutationCreateParticipantAttachmentDownloadUrlArgs = {
  key: Scalars["String"];
};

export type MutationCreateParticipantUploadPresignedUrlArgs = {
  input: CreateParticipantUploadPresignedUrlInput;
};

export type MutationCreateReservationArgs = {
  bookingToolId?: Maybe<Scalars["String"]>;
  expiresAfter?: Maybe<Scalars["Int"]>;
  intervalResourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  parts: Array<ReservationPartInput>;
  requiredSpaces?: Maybe<Scalars["Int"]>;
  resourceGroupId?: Maybe<Scalars["ObjectID"]>;
  resourceId?: Maybe<Scalars["ObjectID"]>;
  serviceId: Scalars["ObjectID"];
  source?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
};

export type MutationCreateReservationForRecurringBookingArgs = {
  input: CreateReservationRecurringInput;
};

export type MutationCreateSamlDomainArgs = {
  input: CreateSamlDomainInput;
};

export type MutationCreateSamlDomainUserRoleArgs = {
  input: CreateSamlDomainUserRoleInput;
};

export type MutationCreateScheduleArgs = {
  input: CreateSchedule;
};

export type MutationCreateServiceArgs = {
  input: CreateServiceInput;
};

export type MutationCreateStripePaymentIntentArgs = {
  input: CreateStripePaymentIntentInput;
};

export type MutationCreateUserClientArgs = {
  input: UserClientCreateInput;
};

export type MutationCreateUserInviteArgs = {
  input: CreateUserInviteInput;
};

export type MutationCreateYextIntegrationTokenArgs = {
  code: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  state: Scalars["String"];
};

export type MutationDeleteBookingToolArgs = {
  input: DeleteBookingToolInput;
};

export type MutationDeleteDiscountCodeArgs = {
  input: DeleteDiscountCodeInput;
};

export type MutationDeleteManagementAppUserArgs = {
  input: DeleteUserInput;
};

export type MutationDeleteReservedSpaceArgs = {
  organisationId: Scalars["ObjectID"];
  reservedSpaceId: Scalars["ObjectID"];
};

export type MutationDeleteSamlDomainUserRoleArgs = {
  samlDomainUserRoleId: Scalars["ObjectID"];
};

export type MutationDeleteScheduleArgs = {
  id: Scalars["ObjectID"];
  preserveHistoric?: Maybe<Scalars["Boolean"]>;
};

export type MutationDeleteUserAccountPermissionArgs = {
  input: DeleteUserAccountPermissionInput;
};

export type MutationDeleteUserClientArgs = {
  _id: Scalars["ObjectID"];
};

export type MutationDisableMfaArgs = {
  userId: Scalars["ObjectID"];
};

export type MutationDisableMicrosoftTeamsMeetingsIntegrationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationDisablePasswordSignInForSamlDomainArgs = {
  id: Scalars["ObjectID"];
};

export type MutationDisconnectAdyenIntegrationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationDisconnectCurrentSmsIntegrationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationDisconnectFacebookBusinessArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationEnableMfaArgs = {
  userId: Scalars["ObjectID"];
};

export type MutationEnableMicrosoftTeamsMeetingsIntegrationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationEnablePasswordSignInForSamlDomainArgs = {
  id: Scalars["ObjectID"];
};

export type MutationExchangeGoogleCodeForDetailsArgs = {
  input: ExchangeGoogleCodeForDetailsInput;
};

export type MutationGenerateFacebookBusinessExtensionWidgetArgs = {
  input: GenerateBookingWidgetInput;
};

export type MutationGenerateGoogleOAuthLinkArgs = {
  input: GenerateGoogleOAuthLinkInput;
};

export type MutationGetAdyenPaymentConfirmationArgs = {
  invoiceId?: Maybe<Scalars["ObjectID"]>;
  organisationId: Scalars["ObjectID"];
  threeDSResult: Scalars["String"];
};

export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistInput;
};

export type MutationLinkUserToFacebookArgs = {
  input: LinkUserToFacebookInput;
};

export type MutationLinkUserToGoogleArgs = {
  input: LinkUserToGoogleInput;
};

export type MutationLinkUserToGoogleOnSignUpArgs = {
  input: LinkUserToGoogleOnSignUpInput;
};

export type MutationMapYextLocationToAccountArgs = {
  entityId: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  syncAvailability: Scalars["Boolean"];
  syncLocation: Scalars["Boolean"];
  syncReservationUrl: Scalars["Boolean"];
  syncedBookingToolId?: Maybe<Scalars["ObjectID"]>;
  tokenId: Scalars["ObjectID"];
};

export type MutationMarkServiceImagesForDeletionArgs = {
  serviceId: Scalars["ObjectID"];
};

export type MutationMigrateUserToCognitoArgs = {
  input: MigrateUserToCognitoInput;
};

export type MutationModifyArrivalStatusArgs = {
  bookingId: Scalars["ObjectID"];
  participantId: Scalars["ObjectID"];
  status: Scalars["String"];
};

export type MutationRemoveBccAddressArgs = {
  emailAddress: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationRemoveFromWaitlistArgs = {
  input: RemoveFromWaitlistInput;
};

export type MutationRemoveYextLocationMappingToAccountArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationRequestAdyenRefundArgs = {
  amount: Scalars["Float"];
  invoiceId: Scalars["ObjectID"];
  organisationId: Scalars["ObjectID"];
  reason?: Maybe<Scalars["String"]>;
};

export type MutationRequestAppointeddSmsIntegrationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationRequestManagementAppUserPasswordResetEmailArgs = {
  email: Scalars["String"];
};

export type MutationRescheduleBookingArgs = {
  bookingId: Scalars["ObjectID"];
  participantId: Scalars["ObjectID"];
  reservationId: Scalars["ObjectID"];
  timeZone?: Maybe<Scalars["String"]>;
};

export type MutationResendBccApprovalEmailArgs = {
  emailAddress: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationSendTestSmsArgs = {
  organisationId: Scalars["ObjectID"];
  to: Scalars["String"];
};

export type MutationSetAdyenIntegrationSelectedMerchantAccountArgs = {
  account: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationSetMicrosoftTeamsMeetingsIntegrationAutomaticRecordingsArgs =
  {
    organisationId: Scalars["ObjectID"];
    value: Scalars["Boolean"];
  };

export type MutationSetMicrosoftTeamsMeetingsIntegrationExtendedCustomerMeetingTitlesArgs =
  {
    organisationId: Scalars["ObjectID"];
    value: Scalars["Boolean"];
  };

export type MutationSubmitBccAddressArgs = {
  emailAddress: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationSubmitManagementAppUserPasswordResetArgs = {
  password: Scalars["String"];
  token: Scalars["String"];
};

export type MutationSyncSuperUserInviteArgs = {
  input: SyncSuperUserInviteInput;
};

export type MutationUnassignAllMicrosoftTeamsUsersArgs = {
  organisationId: Scalars["ObjectID"];
};

export type MutationUnassignMicrosoftTeamsUserFromResourceArgs = {
  resourceId: Scalars["ObjectID"];
};

export type MutationUnlinkUserFromFacebookArgs = {
  userId: Scalars["ObjectID"];
};

export type MutationUnlinkUserFromGoogleArgs = {
  userId: Scalars["ObjectID"];
};

export type MutationUpdateBookingToolArgs = {
  id: Scalars["ObjectID"];
  properties: UpdateBookingToolProperties;
};

export type MutationUpdateDiscountCodeArgs = {
  input: UpdateDiscountCodeInput;
};

export type MutationUpdateManagementAppUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateManagementAppUserLocaleArgs = {
  input: UpdateUserLocaleInput;
};

export type MutationUpdateManagementAppUserSignInDetailsArgs = {
  input: UpdateUserSignInDetailsInput;
};

export type MutationUpdateSamlDomainArgs = {
  input: UpdateSamlDomainInput;
};

export type MutationUpdateSamlDomainUserRoleArgs = {
  input: UpdateSamlDomainUserRoleInput;
};

export type MutationUpdateScheduleArgs = {
  input: UpdateSchedule;
  preserveHistoric?: Maybe<Scalars["Boolean"]>;
};

export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};

export type MutationUpdateSmsIntegrationSendFromArgs = {
  from: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type MutationUpdateUserAccountPermissionArgs = {
  input: UpdateUserAccountPermissionInput;
};

export type MutationUpdateUserClientArgs = {
  input: UserClientUpdateInput;
};

export type NoDiscount = {
  __typename?: "NoDiscount";
  noDiscountReason: NoDiscountReason;
};

/**
 * Enumeration of possible reasons why a calculatedDiscount query returns
 * no results.
 */
export enum NoDiscountReason {
  Expired = "EXPIRED",
  MaxClaimsPerCustomerReached = "MAX_CLAIMS_PER_CUSTOMER_REACHED",
  MaxClaimsReached = "MAX_CLAIMS_REACHED",
  NotActive = "NOT_ACTIVE",
  NoValidServices = "NO_VALID_SERVICES",
}

/**
 * A client for an OAuth v2.x integration (e.g. External Application -> Appointedd)
 * in Appointedd. For security reasons the client secret is not included in the
 * graph.
 */
export type OpenAuthIntegrationClient = {
  __typename?: "OpenAuthIntegrationClient";
  /** Unique identifier of this client. */
  _id: Scalars["ObjectID"];
  /**
   * Unique identifier generated by the external application that this OAuth 2.x
   * client is for.
   */
  clientId: Scalars["String"];
  /** Human readable name of this OAuth v2.x client on the external application. */
  clientName: Scalars["String"];
  /** Date and time that this token was created at. */
  created: Scalars["Date"];
  /**
   * List of OAuth 2.x scopes on the external application that this token has
   * access to.
   */
  scopes: Array<Scalars["String"]>;
  /** If set, the date and time that this token was last updated at. */
  updated?: Maybe<Scalars["Date"]>;
};

/**
 * A token for an OAuth v2.x integration (e.g. External Application -> Appointedd)
 * in Appointedd. For security reasons the access token and refresh token are not
 * included in the graph.
 */
export type OpenAuthIntegrationToken = {
  __typename?: "OpenAuthIntegrationToken";
  /** Unique identifier of this token. */
  _id: Scalars["ObjectID"];
  /** Date and time that this token was created at. */
  created: Scalars["Date"];
  /** Date and time that access token on this token expires at. */
  expiresAt: Scalars["Date"];
  /**
   * List of OAuth 2.x scopes on the external application that this token has
   * access to.
   */
  scopes: Array<Scalars["String"]>;
  /** If set, the date and time that this token was last updated at. */
  updated?: Maybe<Scalars["Date"]>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type Organisation = {
  __typename?: "Organisation";
  /** Unique identifier for this organisation. */
  _id: Scalars["ObjectID"];
  adyenIntegration?: Maybe<AdyenIntegration>;
  /**
   * The token for the Adyen integration currently connected to this
   * Appointedd organisation if there is one.
   */
  adyenIntegrationToken?: Maybe<AdyenIntegrationToken>;
  /** When enabled allows the customer to associate notes to their booking */
  allowBookingNotes: Scalars["Boolean"];
  /** When enabled allows resource group selection on the microsite */
  allowResourceGroupSelection: Scalars["Boolean"];
  /** When enabled allows resource images to be displayed */
  allowResourceImageDisplay: Scalars["Boolean"];
  /** When enabled allows resource selection on the microsite */
  allowResourceSelection: Scalars["Boolean"];
  /** When enabled allows the use of an "any" button on the resource selection step */
  allowSelectAnyResource: Scalars["Boolean"];
  /** The current status of the organisations request to use the Appointedd SMS integration. */
  appointeddSmsApprovalStatus: AppointeddSmsApprovalStatus;
  /** The number of SMS credits available when using the Appointedd SMS integration. */
  appointeddSmsCredits: Scalars["Int"];
  /**
   * If true, the user will receive a confirmation email from Appointedd after
   * making a booking through a booking tool
   */
  areConfirmationEmailsEnabled: Scalars["Boolean"];
  /**
   * If true, the user will receive an invoice email after making a booking
   * with payment through a booking tool
   */
  areInvoiceEmailsEnabled: Scalars["Boolean"];
  /**
   * One or more assets that are on this organisation.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  assets: AssetPage;
  /** Search available days where at least one slot is available */
  availabilityDates: Array<AvailableDate>;
  /** Search available time slot intervals */
  availabilityIntervals: Array<AvailabilityIntervalResult>;
  /**
   * BCC email addresses for all customer email comms.
   * These addresses require approval by the owner of the mailbox
   * before BCC emails will be sent to them.
   */
  bccEmails: Array<Maybe<BccEmail>>;
  /**
   * Optional number of hours from the current date and time that all
   * bookings in this organisation must be made before.
   *
   * If not set then there is no limit to the latest date and time a
   * booking can be made for this organisation.
   */
  bookingBlockPeriod?: Maybe<Scalars["Float"]>;
  /** The message to display to users when a booking has been confirmed. */
  bookingConfirmationMessage?: Maybe<Scalars["String"]>;
  /**
   * Time increments, in minutes, to display available dates and times
   * on your external booking tools.
   */
  bookingIncrements: Scalars["Int"];
  /**
   * Number of hours from the current date and time that all bookings
   * in this organisation must be made after.
   */
  bookingNoticePeriod: Scalars["Float"];
  /**
   * Returns the account level availability display mode for a specified booking tool id. Returns
   * null if the organisation isn't present on the provided booking tool id.
   */
  bookingToolAvailabilityDisplayMode?: Maybe<AvailabilityDisplayMode>;
  /**
   * Number of non-deleted booking tools associated with this
   * organisation.
   */
  bookingToolCount: Scalars["Int"];
  /**
   * One or more booking tools that are associated with this organisation.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  bookingTools: BookingToolPage;
  /** The list of all booking tools associated with an account */
  bookingToolsForAccount: BookingToolPage;
  /**
   * Phase 1 of org-level brand configuration: allows a client's brand to be
   * configured once at the organisation level (via the `organisationBrandConfigs`
   * collection) rather than per-BookingTool, for embeds that have no BookingTool
   * at all (e.g. a microsite embed identified only by organisationId — see
   * GenericBookingToolData.tsx). Returns null if no org-level brand config has
   * been created for this organisation (no auto-creation; there is no write
   * path yet in Phase 1).
   */
  brandConfig?: Maybe<Brand>;
  /** The business email address associated with the organisation */
  businessEmail: Scalars["String"];
  /** The contact phone number associated with the organisation */
  businessPhone?: Maybe<Scalars["String"]>;
  /**
   * One or more categories that are on this organisation.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  categories: CategoryPage;
  /** The contact email for the organisation, is used as the from address in email correspondence. */
  communicationFromEmail?: Maybe<Scalars["String"]>;
  currency: Scalars["String"];
  /**
   * The currently connected integration that will be used to send SMS messages
   * on behalf of the organisation. Currently supported integrations are
   * MessageBird, Twilio and Appointedd (requires approval).
   */
  currentSmsIntegration?: Maybe<SmsIntegration>;
  /** A customizable value used as a text prompt for customer booking notes. */
  customBookingNotesText?: Maybe<Scalars["String"]>;
  customContent?: Maybe<Array<OrganisationCustomContent>>;
  /** A customizable value used as a text prompt for no availability. */
  customNoAvailabilityText?: Maybe<Scalars["String"]>;
  defaultTimeZone: Scalars["String"];
  /**
   * If defined, this is the date that the organisation was deleted on.
   *
   * Our retention policy is 180 days, once that time period has
   * elasped your organisation will be irreversible deleted from our
   * system and any data on it will not be retrievable.
   */
  deleted?: Maybe<Scalars["Date"]>;
  /**
   * Zero or more discount codes that are on this organisation.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  discountCodes: DiscountCodePage;
  /**
   * Returns true if the organisation has enabled the marketing opt in for the booking flow
   *
   * NB: This is distinct from the marketingEnabled setting, which controls the entire
   * legacy marketing suite. If marketingEnabled is true, then the marketing opt in
   * will be shown in the booking flow regardless of this setting. This setting lets you
   * enable the marketing opt in *without* enabling the whole marketing suite.
   *
   * This is necessary because our marketing suite is being deprecated, but we still need
   * to be able to record marketing opt in for certain new clients.
   */
  enableMarketingOptIn: Scalars["Boolean"];
  /**
   * Returns an array of feature flag id strings
   * that are enabled on this organisation.
   */
  enabledFeatureFlags?: Maybe<Array<Scalars["String"]>>;
  /**
   * The list of booking questions for this Organisation which are for external
   * use (ie, booking questions which are not internal-only)
   */
  externalBookingQuestions: Array<BookingQuestion>;
  /**
   * The list of CRM fields for this Organisation which are for external use
   * (ie, CRM fields which are not internal only).
   */
  externalCrmFields: Array<CrmField>;
  /**
   * Boolean value indicating whether the Facebook Business integration is
   * currently connected to this organisation.
   */
  facebookBusinessIntegrationEnabled: Scalars["Boolean"];
  /**
   * If set to AUTO_DETECT, use the detected customer timezone when using booking tools.
   * Else forceTimezone will be a timezone that will be used by default
   * instead of the auto detected value
   */
  forceTimezone: Scalars["String"];
  /** Returns true if the organisation has popover_options.hide_footer enabled */
  hideAppointeddFooter?: Maybe<Scalars["Boolean"]>;
  /**
   * Is the user required to provide a phone number in the booking flow? If true,
   * the user must provide a phone number, if false the phone number is optional.
   */
  isPhoneNumberRequiredForBookings: Scalars["Boolean"];
  /**
   * Location of this organisation, for use in the booking tool organisation
   * step map view. Composed of a street address, latitude and longitude.
   */
  location?: Maybe<Location>;
  /**
   * Paginated list of Appointedd users that are a manager on this Appointedd
   * organisation.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  managers: OrganisationManagerPage;
  /** Returns true if the organisation has marketing enabled */
  marketingEnabled: Scalars["Boolean"];
  /**
   * Returns the custom label (if any) to be used on the marketing opt-in in
   * the booking flow
   */
  marketingOptInLabel?: Maybe<Scalars["String"]>;
  /** Boolean value indicating whether the organisation is a member of an account group. */
  memberOfAccountGroup: Scalars["Boolean"];
  /** Returns the colours used on the microsite */
  micrositeColours: MicrositeColours;
  /**
   * If this organisation has the Micorsoft Teams meetings integration
   * enabled this will be set to the date that it was enabled,
   * otherwise this will be set to null.
   */
  microsoftTeamsMeetingsIntegrationEnabled?: Maybe<Scalars["Date"]>;
  /** Settings that are applied to all MS Teams users for this organisation. */
  microsoftTeamsMeetingsIntegrationSettings: MicrosoftTeamsMeetingIntegrationSettings;
  name: Scalars["String"];
  /** Get payment information based on the provided reservations & other options. */
  payment: BookingPayment;
  /** An external link to the organisation's privacy policy */
  privacyPolicyUrl?: Maybe<Scalars["String"]>;
  /**
   * Number of minutes the reservation expires in. If undefined, a default value of 7
   * minutes is used.
   */
  reservationExpiryMinutes: Scalars["Int"];
  /** One or more resourceGroups that are on this organisation. */
  resourceGroups: ResourceGroupPage;
  /** Determines if we should display resource selection before or after availability selection. */
  resourceSelectionBeforeAvailability: Scalars["Boolean"];
  /**
   * One or more resources that are on this organisation.
   *
   * If your user is restricted to only being able to access a subset
   * of the resources on the organisation, this will only return
   * resources which your user has access to.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  resources: ResourcePage;
  /**
   * Get the role of a user on this organisation.
   *
   * Currently this only supports getting the role of the current user
   * that owns the authenticated session of curent request.
   */
  role?: Maybe<UserRole>;
  /**
   * Defines what action the user should be prompted to take if a service is not bookable.
   * CALL or EMAIL
   */
  serviceNotBookableAction: ServiceNotBookableAction;
  /**
   * Zero or more services that are on this organisation.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  services: ServicePage;
  /** Prices will be shown on the booking tools when this setting is enabled. */
  showPricesOnBookingTools: Scalars["Boolean"];
  /**
   * Unique alpha-numeric, URL safe string that is used for the
   * organisation's microsite fragment.
   *
   * For example and organisation with the slug *test* has a microsite at
   * the URL *test.appointedd.com*.
   */
  slug: Scalars["String"];
  /** The default name or number SMS messages are sent from. */
  smsIntegrationSendFrom: Scalars["String"];
  squareIntegration?: Maybe<SquareIntegration>;
  stripeIntegration?: Maybe<StripeIntegration>;
  /**
   * If this organisation has the Zoom Meetings and/or Webinars
   * integrations enabled this will include the relevant account
   * IDs, otherwise they will be set to null.
   */
  zoomAccount?: Maybe<ZoomAccount>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationAssetsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  search?: Maybe<Array<AssetSearchCondition>>;
  sortBy?: Maybe<AssetSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationAvailabilityDatesArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  duration: Scalars["Int"];
  meta?: Maybe<AvailabilityRequestMetaData>;
  parts?: Maybe<Array<PartInput>>;
  ranges: Array<AvailabilityRange>;
  requestRangesIndividually?: Maybe<Scalars["Boolean"]>;
  resourceGroupIds?: Maybe<Array<Scalars["ObjectID"]>>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  serviceId: Scalars["ObjectID"];
  spaces?: Maybe<Scalars["Int"]>;
  timezone: Scalars["String"];
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationAvailabilityIntervalsArgs = {
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  duration: Scalars["Int"];
  meta?: Maybe<AvailabilityRequestMetaData>;
  parts?: Maybe<Array<PartInput>>;
  ranges: Array<AvailabilityRange>;
  requestRangesIndividually?: Maybe<Scalars["Boolean"]>;
  resourceGroupIds?: Maybe<Array<Scalars["ObjectID"]>>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  serviceId: Scalars["ObjectID"];
  spaces?: Maybe<Scalars["Int"]>;
  timezone: Scalars["String"];
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationBookingToolAvailabilityDisplayModeArgs = {
  bookingToolId: Scalars["ObjectID"];
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationBookingToolsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<BookingToolSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationBookingToolsForAccountArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<BookingToolSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationCategoriesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  search?: Maybe<Array<CategorySearchCondition>>;
  sortBy?: Maybe<CategorySortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationDiscountCodesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<DiscountCodeSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationManagersArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationPaymentArgs = {
  bookingReservations: Array<BookingReservation>;
  discount?: Maybe<DiscountInput>;
  locale: Scalars["String"];
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationResourceGroupsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  search?: Maybe<Array<ResourceGroupSearchCondition>>;
  sortBy?: Maybe<ResourceGroupSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationResourcesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  search?: Maybe<Array<ResourceSearchCondition>>;
  sortBy?: Maybe<ResourceSortKey>;
};

/**
 * An Appointedd organisation which usually represents a company or a
 * site/location of a company and contains one or more Appointedd users
 * with various access levels.
 */
export type OrganisationServicesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  filters?: Maybe<ServiceFilters>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ServiceSortKey>;
};

export type OrganisationCustomContent = {
  __typename?: "OrganisationCustomContent";
  /** ISO-630 language code for the language this content is in. */
  language: Scalars["String"];
  marketingOptInLabel?: Maybe<Scalars["String"]>;
  /** A custom privacy policy label that supports raw html */
  privacyPolicy?: Maybe<Scalars["String"]>;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type OrganisationEdge = {
  __typename?: "OrganisationEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Organisation that is on this page. */
  node: Organisation;
};

export type OrganisationIntervals = {
  __typename?: "OrganisationIntervals";
  intervals: Array<Maybe<AvailabilityIntervalResult>>;
  organisation: Organisation;
};

/**
 * Describes the details of an Appointedd user on an Appointedd organisation that
 * they are a member of as a manager.
 */
export type OrganisationManager = {
  __typename?: "OrganisationManager";
  /** Unique identifier of the Appointedd user that this refers to. */
  _id: Scalars["ObjectID"];
  /** Email address of the Appointedd user that this refers to. */
  email: Scalars["String"];
  /** First name of the Appointedd user that this refers to. */
  firstName: Scalars["String"];
  /** Last name of the Appointedd user that this refers to. */
  lastName: Scalars["String"];
  /**
   * Number of webhooks this user has created by our Zapier that can trigger of
   * an event that happens in this organisation.
   */
  numberOfZapierTriggers: Scalars["Int"];
  /** Access role that this user has on this organisation. */
  role: UserRole;
};

export type OrganisationManagerEdge = {
  __typename?: "OrganisationManagerEdge";
  /** Value of the property on the node that is used as the cursor for pagination. */
  cursor: Scalars["ObjectID"];
  /** Entity that is on this page. */
  node: OrganisationManager;
};

export type OrganisationManagerPage = {
  __typename?: "OrganisationManagerPage";
  /** Array of nodes containing the categories that are on this page. */
  edges: Array<OrganisationManagerEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: OrganisationManagerPageInfo;
};

export type OrganisationManagerPageInfo = {
  __typename?: "OrganisationManagerPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

/**
 * Page containing the resulting organisations for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type OrganisationPage = {
  __typename?: "OrganisationPage";
  /** Array of nodes containing the organisations that are on this page. */
  edges: Array<OrganisationEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: OrganisationPageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type OrganisationPageInfo = {
  __typename?: "OrganisationPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type OrganisationSearchCondition = {
  condition?: Maybe<OrganisationSearchConditionType>;
  parameters: Array<OrganisationSearchParameter>;
};

export enum OrganisationSearchConditionType {
  And = "AND",
  Or = "OR",
}

export type OrganisationSearchParameter = {
  ids?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  name?: Maybe<Scalars["String"]>;
};

export enum OrganisationSortKey {
  Natural = "NATURAL",
  Slug = "SLUG",
}

export type OrganisationsFilter = {
  isAdmin?: Maybe<Scalars["Boolean"]>;
};

/** Enumeration of the possible ordering of a page in paginated queries. */
export enum PageOrder {
  /** Queries the pages in ascending order. */
  Ascending = "ASCENDING",
  /** Queries the pages in descending order. */
  Descending = "DESCENDING",
}

/** Enumeration of possible service part types on the Service.parts[] property */
export enum PartDurationType {
  /** Part duration is stored in hours. */
  Hours = "HOURS",
  /** Part duration is stored in minutes. */
  Minutes = "MINUTES",
}

export type PartInput = {
  /** Duration of the booking part in minutes */
  duration: Scalars["Int"];
  /** The type of this booking part (block or free) */
  type: PartType;
};

/** Enumeration of possible service part types on the Service.parts[] property */
export enum PartType {
  /** The part is blocked off meaning it is not possible to book at the time of this booking part. */
  Block = "BLOCK",
  /** The part is free meaning the duration of this booking part is available for another booking. */
  Free = "FREE",
}

/** Enumeration of possible service payment options on the Service.bookingPaymentOption property */
export enum PaymentOption {
  /** A partial Booking payment can be made during the booking flow based on the defined percentage on Service.bookingDepositAmount */
  Deposit = "DEPOSIT",
  /** Booking payment must be taken in full during the booking flow */
  Full = "FULL",
  /** No payment during the Booking flow is required */
  None = "NONE",
}

export type Query = {
  __typename?: "Query";
  booking?: Maybe<Booking>;
  bookingTool?: Maybe<BookingTool>;
  bookingsForQrScanning?: Maybe<Booking>;
  cancelBookingData: CancelBookingData;
  /** Get a customer by its unique identifier. */
  customer?: Maybe<Customer>;
  discountCode?: Maybe<DiscountCode>;
  discountCodeByCode?: Maybe<DiscountCode>;
  /** Checks if a facebook user is already connected to Appointedd using the provided facebookUserId. */
  facebookUserIsUnique: Scalars["Boolean"];
  featureFlagEnabled: Scalars["Boolean"];
  /** Get a the dedicated getFacebookBusinessExtensionWidget by organisationId. */
  getFacebookBusinessExtensionWidget?: Maybe<BookingWidget>;
  globalFeatureByName: GlobalFeature;
  /**
   * Get the user that you are currently authenticated as.
   *
   * Your current user is the user that owns the access token that you
   * are making a request with.
   */
  me: User;
  /**
   * Returns a valid new account slug generated from a given new
   * account's name.
   *
   * This will apply our rules for slugs by converting the account name
   * to be in lowercase, replacing spaces with `-`, and converting any
   * non-ascii UTF-8 characters to their closest ASCII equivalent.
   *
   * If the resulting slug would conflict with an existing
   * organisation, a number is suffixed to it to resolve the
   * conflict. If this would still cause a conflict then this number is
   * simply incremented until there are no conflicting existing
   * accounts with the same slug.
   *
   * If the slug is in our blacklist this will return an appropriate
   * `BAD_USER_INPUT` error with the error's
   * `extensions.appointeddErrorCode` property set to
   * `BLACKLISTED_SLUG`.
   */
  newAccountSlug: Scalars["String"];
  /** Get an organisation by its unique identifier. */
  organisation?: Maybe<Organisation>;
  /** Get a resource by its unique identifier. */
  resource?: Maybe<Resource>;
  /** Get a resource group by its unique identifier. */
  resourceGroup?: Maybe<ResourceGroup>;
  /**
   * Get a SamlDomain by its unique identifier. Only accessible by the
   * super user associated with the SAML Domain.
   */
  samlDomain?: Maybe<SamlDomain>;
  /** Get a SamlDomainUserRole by its unique identifier. */
  samlDomainUserRole?: Maybe<SamlDomainUserRole>;
  searchMultipleOrganisationCategories: CategoryPage;
  searchMultipleOrganisationServices: ServicePage;
  service?: Maybe<Service>;
  /** Gets a single user by providing the users ID. */
  user?: Maybe<User>;
  userAccountPermission?: Maybe<UserAccountPermission>;
  yextConfiguration?: Maybe<YextConfigurationResult>;
  yextIntegrationToken?: Maybe<YextIntegrationToken>;
};

export type QueryBookingArgs = {
  id: Scalars["ObjectID"];
};

export type QueryBookingToolArgs = {
  id: Scalars["ObjectID"];
};

export type QueryBookingsForQrScanningArgs = {
  id: Scalars["ObjectID"];
};

export type QueryCustomerArgs = {
  id: Scalars["ObjectID"];
};

export type QueryDiscountCodeArgs = {
  id: Scalars["ObjectID"];
};

export type QueryDiscountCodeByCodeArgs = {
  code: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type QueryFacebookUserIsUniqueArgs = {
  facebookUserId: Scalars["String"];
};

export type QueryFeatureFlagEnabledArgs = {
  flag_id: Scalars["String"];
  organisationId: Scalars["ObjectID"];
};

export type QueryGetFacebookBusinessExtensionWidgetArgs = {
  organisationId: Scalars["ObjectID"];
};

export type QueryGlobalFeatureByNameArgs = {
  name: Scalars["String"];
};

export type QueryNewAccountSlugArgs = {
  newAccountName: Scalars["String"];
};

export type QueryOrganisationArgs = {
  id: Scalars["ObjectID"];
};

export type QueryResourceArgs = {
  id: Scalars["ObjectID"];
};

export type QueryResourceGroupArgs = {
  id: Scalars["ObjectID"];
};

export type QuerySamlDomainArgs = {
  id: Scalars["ObjectID"];
};

export type QuerySamlDomainUserRoleArgs = {
  id: Scalars["ObjectID"];
};

export type QuerySearchMultipleOrganisationCategoriesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  input: CategorySearchInput;
  last?: Maybe<Scalars["Int"]>;
};

export type QuerySearchMultipleOrganisationServicesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  input: ServiceSearchInput;
  last?: Maybe<Scalars["Int"]>;
};

export type QueryServiceArgs = {
  id: Scalars["ObjectID"];
};

export type QueryUserArgs = {
  id: Scalars["ObjectID"];
};

export type QueryUserAccountPermissionArgs = {
  id: Scalars["ObjectID"];
};

export type QueryYextConfigurationArgs = {
  organisationId: Scalars["ObjectID"];
};

export type QueryYextIntegrationTokenArgs = {
  id: Scalars["ObjectID"];
};

export type Recurrence = {
  __typename?: "Recurrence";
  bookings: Array<Booking>;
  endDate?: Maybe<Scalars["Date"]>;
  frequency: Scalars["Int"];
  frequencyType: FrequencyType;
  id: Scalars["String"];
  monthlyRepeatType?: Maybe<MonthlyRepeatType>;
  occurrences?: Maybe<Scalars["Int"]>;
  recurrenceType: RecurrenceType;
};

/** Enumeration of possible recurrence types on the Booking.recurring property */
export enum RecurrenceType {
  /** Customer must book all occurrences in the series */
  AllBookings = "ALL_BOOKINGS",
  /** Customer must book all remaining occurrences in the series (from any point in the series) */
  AllBookingsFromAPoint = "ALL_BOOKINGS_FROM_A_POINT",
  /** Customer must book all remaining occurrences in the series (from current day) */
  AllRemainingBookings = "ALL_REMAINING_BOOKINGS",
  /** Customer can select and book individual occurrences in a series */
  IndividualBookings = "INDIVIDUAL_BOOKINGS",
}

export type RecurringSchedule = Schedule & {
  __typename?: "RecurringSchedule";
  /** Unique identifier for this schedule. */
  _id: Scalars["ObjectID"];
  /**
   * Indicates if this schedule marks the entity its associated with as available
   * or unavailable.
   */
  available: Scalars["Boolean"];
  /** Date and time that this schedule was created at. */
  created: Scalars["Date"];
  /**
   * Optional date and time that this schedule was deleted at.
   *
   * If not set this indicates that this schedule is not deleted.
   */
  deleted?: Maybe<Scalars["Date"]>;
  /** Date and time that this schedule ends at. */
  end: Scalars["Date"];
  /** An optional array of dates where the schedule is not available */
  exceptions?: Maybe<Array<Scalars["Date"]>>;
  /** Unique identifier of the organisation that this schedule is in. */
  organisationId: Scalars["ObjectID"];
  /** Optional reason that this schedule was made. */
  reason?: Maybe<Scalars["String"]>;
  /**
   * Recurrence rule that defines how this schedule recurs according to the RRULE
   * specification.
   */
  rrule: Scalars["RRule"];
  /** Date and time that this schedule starts at. */
  start: Scalars["Date"];
  /** Reference to the entity that is the subject of this schedule. */
  subjectEntity: EntityRef;
  /** Unique identifier of the entity that this schedule is for. */
  subjectId: Scalars["ObjectID"];
  /**
   * Optional date and time that this schedule was last updated at.
   *
   * If not set this indicates that this schedule has not been updated since it
   * was created.
   */
  updated?: Maybe<Scalars["Date"]>;
  /** Time zone that this schedule is in. */
  zone: Scalars["IANATimeZone"];
};

export type RemoveFromWaitlistInput = {
  organisationId: Scalars["ObjectID"];
  token: Scalars["String"];
  waitlistEntryId: Scalars["ObjectID"];
};

export type RemoveFromWaitlistResult = {
  __typename?: "RemoveFromWaitlistResult";
  message?: Maybe<Scalars["String"]>;
  success: Scalars["Boolean"];
};

export type RescheduleBookingResult = {
  __typename?: "RescheduleBookingResult";
  booking: Booking;
  participant: BookingParticipant;
};

export type Reservation = {
  __typename?: "Reservation";
  /** Unique identifier for this reservation. */
  _id: Scalars["ObjectID"];
  /**
   * If set to true, additional participants can join this reservation by
   * booking on to it from your external facing booking tools (eg. your
   * microsite and/or booking widgets).
   */
  allowExternalParticipants: Scalars["Boolean"];
  end: Scalars["Date"];
  endWithBuffer: Scalars["Date"];
  maxSpaces: Scalars["Int"];
  parts: Array<ReservationPart>;
  reservedSpaces: Array<ReservedSpace>;
  start: Scalars["Date"];
  startWithBuffer: Scalars["Date"];
};

export type ReservationPart = {
  __typename?: "ReservationPart";
  end: Scalars["Date"];
  label?: Maybe<Scalars["String"]>;
  start: Scalars["Date"];
};

export type ReservationPartInput = {
  end: Scalars["Date"];
  label?: Maybe<Scalars["String"]>;
  start: Scalars["Date"];
  type: DurationType;
};

export type ReservedSpace = {
  __typename?: "ReservedSpace";
  /** Unique identifier for this reserved space on a reservation. */
  _id: Scalars["ObjectID"];
  /** Date and time that this reserved space expires at. */
  expiresAt: Scalars["Date"];
  /** Number of spaces that this reserved space uses. */
  spaces: Scalars["Int"];
};

export type Resource = {
  __typename?: "Resource";
  /** Unique identifier for this resource. */
  _id: Scalars["ObjectID"];
  availabilityV1: Array<AvailabilityResult>;
  /** Description of this resource. */
  description?: Maybe<Scalars["String"]>;
  /** A non-paginated list of resource group ids of which this resource is a member. */
  groupIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /**
   * List of resource groups which this resource belongs to.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  groups: ResourceGroupPage;
  microsoftTeamsUserCredentials?: Maybe<MicrosoftTeamsUserCredentials>;
  /** Name of this resource. */
  name: Scalars["String"];
  /** URL of this resource's profile photo. */
  profilePhotoUrl?: Maybe<Scalars["String"]>;
  /** Get one or more schedules that belong to this resource. */
  schedules: Array<Schedule>;
  /** Get utilisation statistics for each day of a month for a resource/resources. Includes day, minutes available, minutes booked and minutes blocked. */
  utilisation: Array<UtilisationResult>;
  /** Get resource working hours, available & unavailable for a specific date range */
  workingHours: WorkingHours;
};

export type ResourceAvailabilityV1Args = {
  after: Scalars["Date"];
  before: Scalars["Date"];
  duration: Array<Duration>;
  requiredSpaces?: Maybe<Scalars["Int"]>;
  serviceId?: Maybe<Scalars["ObjectID"]>;
  useBookingIncrements?: Maybe<Scalars["Boolean"]>;
};

export type ResourceGroupsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ResourceGroupSortKey>;
};

export type ResourceSchedulesArgs = {
  query?: Maybe<ResourceScheduleQuery>;
};

export type ResourceUtilisationArgs = {
  query: ResourceUtilisationQuery;
};

export type ResourceWorkingHoursArgs = {
  query: ResourceWorkingHoursQuery;
};

/**
 * Enumeration of possible resource allocation types on the Service entity
 *
 * See `Service.resourceAllocationType` for an example of how this is used.
 */
export enum ResourceAllocationType {
  /** The service can be booked only when all of the assigned resources are available. */
  All = "ALL",
  /** The service can be booked when any of the assigned resources are available. */
  Any = "ANY",
  /** The service can be booked when at least one resource from an assigned group is available. */
  Group = "GROUP",
}

export type ResourceAvailabilityQuery = {
  between: IntervalQuery;
};

export type ResourceAvailableInterval = {
  __typename?: "ResourceAvailableInterval";
  /** End date and time of this availability interval in UTC. */
  end: Scalars["Date"];
  resource: Scalars["ObjectID"];
  /** Start date and time of this availability interval in UTC. */
  start: Scalars["Date"];
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type ResourceEdge = {
  __typename?: "ResourceEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Resource that is on this page. */
  node: Resource;
};

export enum ResourceEnabledMode {
  All = "ALL",
  ByGroups = "BY_GROUPS",
  ByResource = "BY_RESOURCE",
}

export type ResourceGroup = {
  __typename?: "ResourceGroup";
  /** Unique identifier for this resource group. */
  _id: Scalars["ObjectID"];
  /** Name of this resource group. */
  name: Scalars["String"];
};

export type ResourceGroupBookingInterval = {
  __typename?: "ResourceGroupBookingInterval";
  booking: Booking;
  /** End date and time of this availability interval in UTC. */
  end: Scalars["Date"];
  /** Start date and time of this availability interval in UTC. */
  start: Scalars["Date"];
};

export type ResourceGroupEdge = {
  __typename?: "ResourceGroupEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** ResourceGroup that is on this page. */
  node: ResourceGroup;
};

export type ResourceGroupPage = {
  __typename?: "ResourceGroupPage";
  /** Array of nodes containing the resources that are on this page. */
  edges: Array<ResourceGroupEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: ResourceGroupPageInfo;
};

export type ResourceGroupPageInfo = {
  __typename?: "ResourceGroupPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type ResourceGroupSearchCondition = {
  condition?: Maybe<ResourceGroupSearchConditionType>;
  parameters: Array<ResourceGroupSearchParameter>;
};

export enum ResourceGroupSearchConditionType {
  And = "AND",
  Or = "OR",
}

export type ResourceGroupSearchParameter = {
  name?: Maybe<Scalars["String"]>;
};

export enum ResourceGroupSortKey {
  Name = "NAME",
  Natural = "NATURAL",
}

/**
 * Page containing the resulting resources for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type ResourcePage = {
  __typename?: "ResourcePage";
  /** Array of nodes containing the resources that are on this page. */
  edges: Array<ResourceEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: ResourcePageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type ResourcePageInfo = {
  __typename?: "ResourcePageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type ResourceScheduleQuery = {
  /**
   * If set, only schedules that start afterDate (inclusive) this date will be
   * included.
   */
  afterDate?: Maybe<Scalars["Date"]>;
  /**
   * If set, only schedules that end beforeDate (inclusive) this date will be
   * included.
   */
  beforeDate?: Maybe<Scalars["Date"]>;
  /** If set, only schedules that have these unique identifiers will be included. */
  ids?: Maybe<Array<Scalars["ObjectID"]>>;
};

export type ResourceSearchCondition = {
  condition?: Maybe<ResourceSearchConditionType>;
  parameters: Array<ResourceSearchParameter>;
};

export enum ResourceSearchConditionType {
  And = "AND",
  Or = "OR",
}

export type ResourceSearchParameter = {
  /** Filter resources via group id */
  groupIds?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /** Filter resources via resource id */
  ids?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /** Filter resources via resource name */
  name?: Maybe<Scalars["String"]>;
};

/** Enumeration of possible resource selection modes on the BookingTool entity */
export enum ResourceSelectionMode {
  /**
   * Resource selection is disabled entirely.
   * A user cannot make any resource selection.
   */
  Disabled = "DISABLED",
  /**
   * Resource groups are displayed in a single list.
   * A user can select a resource group from the list.
   * A users cannot select an individual resource.
   */
  Group = "GROUP",
  /**
   * Resources are displayed in a single list.
   * A user can select an individual resource from the list.
   */
  Resource = "RESOURCE",
  /**
   * Resources are organised by group, and displayed in a list under each group they belong to.
   * A user can select an individual resource from the list.
   * A user cannot select a resource group—groups are only used for visual organisation/display.
   */
  ResourceByGroup = "RESOURCE_BY_GROUP",
}

export enum ResourceSortKey {
  Name = "NAME",
  Natural = "NATURAL",
}

export type ResourceUtilisationQuery = {
  /**
   * A date in the month to get the utilisation statistics for. We only consider
   * the month and year in the provided date. The returned values will be for
   * the entire month the provided date lies within.
   */
  fromMonthContaining: Scalars["Date"];
  timezone: Scalars["String"];
};

export type ResourceWorkingHoursQuery = {
  /**
   * Only working hours intervals that start afterDate (inclusive) this date will be
   * included.
   */
  afterDate: Scalars["Date"];
  /**
   * Only working hours intervals that end beforeDate (inclusive) this date will be
   * included.
   */
  beforeDate: Scalars["Date"];
  /** Used to detetermine if the schedule query should adjust for DST */
  timezone: Scalars["IANATimeZone"];
};

/**
 * Entity that is associated with a custom identity provider attached to our
 * Cognito user pool. These exist on a per domain basis.
 */
export type SamlDomain = {
  __typename?: "SamlDomain";
  /** Unique identifier for this SamlDomain. */
  _id: Scalars["ObjectID"];
  /** The role all users without an explicit permission will inherit. */
  defaultRole: UserRole;
  /**
   * Domain name this SamlDomain document is applied to.
   * Resolves to domains[0] for backward compatibility. Prefer the domains field
   * for new consumers.
   */
  domain: Scalars["String"];
  /**
   * All email domains covered by this SAML configuration.
   * Resolves from the domains array if present, otherwise falls back to the
   * legacy domain field. Use this field for new consumers.
   */
  domains?: Maybe<Array<Scalars["String"]>>;
  /** S3 Bucket key of the currently in use SAML Metadata. */
  metadataKey: Scalars["String"];
  /**
   * List of organisations associated with this SAML Domain paginated
   * using Relay style pagination.
   */
  organisations?: Maybe<OrganisationPage>;
  /**
   * Controls if users that have an email address domain that matches the domain
   * of this SAML configuration can sign in using their password instead of the
   * SAML SSO sign in flow.
   */
  passwordSignInEnabled: Scalars["Boolean"];
  samlDomainUserRoles?: Maybe<SamlDomainUserRolePage>;
  /** The user ID of the administrator of this SamlDomain. */
  superUserId: Scalars["ObjectID"];
  /** Date that the saml domain meta data file was updated. */
  updated?: Maybe<Scalars["Date"]>;
};

/**
 * Entity that is associated with a custom identity provider attached to our
 * Cognito user pool. These exist on a per domain basis.
 */
export type SamlDomainOrganisationsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<OrganisationSortKey>;
};

/**
 * Entity that is associated with a custom identity provider attached to our
 * Cognito user pool. These exist on a per domain basis.
 */
export type SamlDomainSamlDomainUserRolesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  search?: Maybe<Array<SamlDomainUserRoleSearchCondition>>;
  sortBy?: Maybe<SamlDomainUserRoleSortKey>;
};

/**
 * Entity representing the permissions provided to a single SAML User (i.e. an email address within
 * a remote identity provider) on a single organisation. This may or may not have a matching User entity
 * within Appointedd, depending on whether the user has logged in via SAML.
 */
export type SamlDomainUserRole = {
  __typename?: "SamlDomainUserRole";
  /** Unique identifier for this SamlDomainUserRole. */
  _id: Scalars["ObjectID"];
  /**
   * If true, the user can manage customers. This is only applicable to users
   * with the "Restricted" role as all other roles already have the ability to
   * manage customers.
   */
  allowCustomerManagement?: Maybe<Scalars["Boolean"]>;
  /**
   * Flag that indicates whether a "USER" type role can also modify their
   * associated resources working hours.
   */
  allowScheduleModification: Scalars["Boolean"];
  /** If true, prevent this user from accessing the calendar sync interface. */
  calendarSyncHidden?: Maybe<Scalars["Boolean"]>;
  /** Indicates that the samlDomainUserRole has been soft deleted. */
  deleted?: Maybe<Scalars["Date"]>;
  /** Email address of the user this SAML Domain user role is associated with. */
  email: Scalars["String"];
  /** Organisation this SAML domain user role is associated with. */
  organisation: Organisation;
  /**
   * List of resources associated with this user role, only relevant if
   * the role is type "USER".
   */
  resources?: Maybe<ResourcePage>;
  /** Role that this user has on the organisation. */
  role: UserRole;
};

/**
 * Entity representing the permissions provided to a single SAML User (i.e. an email address within
 * a remote identity provider) on a single organisation. This may or may not have a matching User entity
 * within Appointedd, depending on whether the user has logged in via SAML.
 */
export type SamlDomainUserRoleResourcesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ResourceSortKey>;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type SamlDomainUserRoleEdge = {
  __typename?: "SamlDomainUserRoleEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** SamlDomainUserRole that is on this page. */
  node: SamlDomainUserRole;
};

/**
 * Page containing the resulting samlDomainUserRoles for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type SamlDomainUserRolePage = {
  __typename?: "SamlDomainUserRolePage";
  /** Array of nodes containing the samlDomainUserRoles that are on this page. */
  edges: Array<SamlDomainUserRoleEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: SamlDomainUserRolePageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type SamlDomainUserRolePageInfo = {
  __typename?: "SamlDomainUserRolePageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type SamlDomainUserRoleSearchCondition = {
  condition?: Maybe<SamlDomainUserRoleSearchConditionType>;
  parameters: Array<SamlDomainUserRoleSearchParameter>;
};

export enum SamlDomainUserRoleSearchConditionType {
  And = "AND",
  Or = "OR",
}

export type SamlDomainUserRoleSearchParameter = {
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  organisationIds?: Maybe<Array<Scalars["ObjectID"]>>;
  role?: Maybe<UserRole>;
};

export enum SamlDomainUserRoleSortKey {
  Email = "EMAIL",
  Natural = "NATURAL",
}

export type Schedule = {
  _id: Scalars["ObjectID"];
  available: Scalars["Boolean"];
  created: Scalars["Date"];
  deleted?: Maybe<Scalars["Date"]>;
  end: Scalars["Date"];
  organisationId: Scalars["ObjectID"];
  reason?: Maybe<Scalars["String"]>;
  start: Scalars["Date"];
  subjectEntity: EntityRef;
  subjectId: Scalars["ObjectID"];
  updated?: Maybe<Scalars["Date"]>;
  zone: Scalars["IANATimeZone"];
};

export type ScheduleHourMinute = {
  __typename?: "ScheduleHourMinute";
  hour: Scalars["Int"];
  minute: Scalars["Int"];
};

export type ScheduleHourMinuteInput = {
  hour: Scalars["Int"];
  minute: Scalars["Int"];
};

export type ScheduleQuery = {
  /**
   * If set, exactly one schedule matching this unique identifier will be
   * returned if it exists.
   *
   * If there are other properties on this query they must also true in order
   * for the schedule to be returned.
   */
  _id?: Maybe<Scalars["ObjectID"]>;
  /**
   * Restrict result to only schedules that are in the organisation with this
   * unique identifier.
   */
  organisationId: Scalars["ObjectID"];
};

export type ScheduleStartEnd = {
  __typename?: "ScheduleStartEnd";
  end: ScheduleHourMinute;
  start: ScheduleHourMinute;
};

export type ScheduleStartEndInput = {
  end: ScheduleHourMinuteInput;
  start: ScheduleHourMinuteInput;
};

export type Service = {
  __typename?: "Service";
  _id: Scalars["ObjectID"];
  /** If enabled customers will be able to book onto existing bookings. */
  allowOnlineGroup?: Maybe<Scalars["Boolean"]>;
  /** The assets required in order for the service to be available for booking. */
  assetIds?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /**
   * This property is only available when the services resolver is called
   * within the context of a parent BookingTool graph.
   * It returns the same result as bookingToolAvailabilityDisplayMode but it expects
   * the value to be present on the returned service node.
   *
   * This property is an alternative to bookingToolAvailabilityDisplayMode that
   * avoids any additional database requests making it more efficient when dealing
   * with large numbers of services.
   *
   * As it's only available in certain scenarios the returned value may be null.
   */
  availabilityDisplayMode?: Maybe<AvailabilityDisplayMode>;
  /**
   * Number of minutes to reserve after bookings created for this
   * service as a buffer.
   */
  bookingAfterBuffer: Scalars["Int"];
  /**
   * Number of minutes to reserve before bookings created for this
   * service as a buffer.
   */
  bookingBeforeBuffer: Scalars["Int"];
  /** Determines the % of the total booking price that should be paid for bookings where the service bookingPaymentOption is set to deposit. */
  bookingDepositAmount: Scalars["String"];
  /**
   * Optional number of hours from the current date and time that a
   * booking must be made after for this service.
   *
   * If not set this will use your organisation's
   * `bookingNoticePeriod` instead.
   */
  bookingNoticePeriod?: Maybe<Scalars["Float"]>;
  /**
   * Optional number of minutes from the current date and time that a
   * booking must be made after for this service.
   */
  bookingNoticePeriodMinutes?: Maybe<Scalars["Int"]>;
  /** Indicates how payment is taken for this service. */
  bookingPaymentOption: PaymentOption;
  /** Indicates if payment of bookings for this service is optional during the booking flow. */
  bookingPaymentOptional?: Maybe<Scalars["Boolean"]>;
  bookingToolAvailabilityDisplayMode?: Maybe<AvailabilityDisplayMode>;
  /** Determines how bookings using the service can be booked. */
  bookingVisibilityType: BookingVisibilityType;
  category: Category;
  deleted: Scalars["Boolean"];
  description?: Maybe<Scalars["String"]>;
  /** The potential durations for this service that can be selected when booking a service. */
  durations: Array<ServiceDuration>;
  /** Indicates if ticket generation is enabled for the service. */
  generateTicketsEnabled: Scalars["Boolean"];
  /**
   * The URL for an image to display for this service in booking tools.
   *
   * Currently just returns the first URL from the images field in the database
   * (which is an array of URL strings).
   */
  image?: Maybe<Scalars["String"]>;
  /**
   * Returns true if there is an active discount code that is assigned to this
   * service and hasn't been deleted.
   */
  isDiscountCodeAvailable?: Maybe<Scalars["Boolean"]>;
  location?: Maybe<Scalars["String"]>;
  /** The maximum number of customer spaces that can book this service at any one time. */
  maxParticipantsPerBooking?: Maybe<Scalars["Int"]>;
  /** Indicates if the Microsoft Teams meetings integration is enabled for the service. */
  microsoftTeamsMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  numberOfResources?: Maybe<Scalars["Int"]>;
  /** The default maximum occupancy of bookings with the service. */
  occupancy?: Maybe<Scalars["Int"]>;
  /** The display order of the service when listed. */
  order?: Maybe<Scalars["Int"]>;
  organisation: Organisation;
  /**
   * Used when the service serviceType is 'parts' that allows the creation of multi part bookings
   * contains all the possible free and block parts for a service.
   */
  parts?: Maybe<Array<Maybe<ServicePart>>>;
  /**
   * Indicates if this service allows bookings made for it to be
   * rescheduled by customers who made the booking.
   *
   * If this is enabled it will be set to the date that the feature was
   * enabled, otherwise this will be null.
   */
  rescheduleEnabled?: Maybe<Scalars["Date"]>;
  /**
   * Indicates if this service requires customers who are rescheduling
   * a booking they made for this service to require the rescheduling
   * to happen a certain number of hours before the start of that
   * booking.
   *
   * If this is enabled it will be the number of hours before the start
   * of the booking that a reschedule must happen, otherwise this will
   * be null meaning that there is no limit to when the reschedule
   * happens as long as the booking isn't in the past or already
   * started.
   */
  rescheduleNoticePeriod?: Maybe<Scalars["Float"]>;
  rescheduleResourceSelectionEnabled?: Maybe<Scalars["Date"]>;
  /**
   * Get a specific resource assigned to this service by the resource's
   * unique ID.
   */
  resource: Resource;
  /** Determines the type of resource that can be allocated to the service. */
  resourceAllocationType: ResourceAllocationType;
  /** The resource groups that will be available for the service. */
  resourceGroups?: Maybe<Array<Maybe<ServiceResourceGroup>>>;
  /** The resources that will be available for the service. */
  resourceIds?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /**
   * Get one or more resources that are on this service.
   *
   * If your user is restricted to only being able to access a subset
   * of the resources on the organisation, this will only return
   * resources which your user has access to.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  resources?: Maybe<ResourcePage>;
  /**
   * Is used by the BookingTools/App to get a filtered list of resources for
   * a specific service.
   *
   * This query conforms to the Relay pagination specification
   * (https://relay.dev/graphql/connections.htm#) and supports forward
   * pagination.
   */
  resourcesForBookingTool: ResourcePage;
  /** Settings that indicate whether the service has schedules enabled and whether they should be merged or not. */
  schedule?: Maybe<ServiceSchedule>;
  /** Get one or more schedules that belong to this service. */
  schedules: Array<Schedule>;
  /** Defines the type of the service. */
  serviceType: ServiceType;
  /**
   * Used when the service serviceType is 'multiple' that allows the configuration of multiple price points per service.
   * Includes the ability to define single pricing tiers or multiple price pints with different occupancy and pricing rules.
   */
  tiers?: Maybe<Array<ServiceTier>>;
  /** Indicates if the Zoom meetings integration is enabled for the service. */
  zoomMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
};

export type ServiceBookingToolAvailabilityDisplayModeArgs = {
  bookingToolId: Scalars["ObjectID"];
};

export type ServiceResourceArgs = {
  id: Scalars["ObjectID"];
};

export type ServiceResourcesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ResourceSortKey>;
};

export type ServiceResourcesForBookingToolArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  sortBy?: Maybe<ResourceSortKey>;
};

export type ServiceSchedulesArgs = {
  query?: Maybe<ServiceScheduleQuery>;
};

export type ServiceDuration = {
  __typename?: "ServiceDuration";
  POA?: Maybe<Scalars["Boolean"]>;
  default?: Maybe<Scalars["Boolean"]>;
  minutes: Scalars["Int"];
  oldPrice?: Maybe<Scalars["Float"]>;
  price?: Maybe<Scalars["Float"]>;
};

export type ServiceDurationInput = {
  POA?: Maybe<Scalars["Boolean"]>;
  default?: Maybe<Scalars["Boolean"]>;
  minutes: Scalars["Int"];
  oldPrice?: Maybe<Scalars["Float"]>;
  price?: Maybe<Scalars["Float"]>;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type ServiceEdge = {
  __typename?: "ServiceEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** Service that is on this page. */
  node: Service;
};

export enum ServiceEnabledMode {
  All = "ALL",
  ByCategory = "BY_CATEGORY",
  ByService = "BY_SERVICE",
}

export type ServiceFilters = {
  /**
   * Restricts results to services belonging to one or more organisations.
   *
   * Only consumed by `BookingTool.services`, where it is intersected with
   * the organisations actually attached to that booking tool (any ids not
   * on the booking tool are ignored). Has no effect on `Organisation.services`,
   * which is already implicitly scoped to its parent organisation.
   */
  organisationIds?: Maybe<Array<Scalars["String"]>>;
  resourceIds?: Maybe<Array<Scalars["String"]>>;
  /**
   * This flag when set to true in combination with visibleOnly will in the
   * event that no services are returned for the visibleOnly query, return all
   * invisible services if _no_ visible services are selected.
   */
  showInvisibleIfOnlyInvisibleSelected?: Maybe<Scalars["Boolean"]>;
  visibleOnly?: Maybe<Scalars["Boolean"]>;
};

/** Enumeration of possible contact methods suggested to the user if a service is not bookable */
export enum ServiceNotBookableAction {
  /** Prompts the user to call the organisation */
  Call = "CALL",
  /** Prompts the user to email the organisation */
  Email = "EMAIL",
}

/**
 * Page containing the resulting Services for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type ServicePage = {
  __typename?: "ServicePage";
  /** Array of nodes containing the Services that are on this page. */
  edges: Array<ServiceEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: ServicePageInfo;
};

/**
 * Information of a page that conforms to the Relay pagination
 * specification for GraphQL.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 * specification.
 */
export type ServicePageInfo = {
  __typename?: "ServicePageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type ServicePart = {
  __typename?: "ServicePart";
  /** Duration of the part in minutes */
  duration: Scalars["Int"];
  durationType: PartDurationType;
  label: Scalars["String"];
  type: PartType;
};

export type ServicePartInput = {
  duration: Scalars["Int"];
  durationType: PartDurationType;
  label: Scalars["String"];
  type: PartType;
};

/**
 * Input representing a service with price that should have the discount
 * applied to. Can be provided
 */
export type ServicePriceInput = {
  /**
   * Total price that would be charged to book on this service prior to any
   * discounts being applied. This should be provided in the lowest denomination
   * of currency (e.g. pence)
   */
  price: Scalars["Int"];
  /**
   * Unique identifier of the service the discount is applied to, this will
   * be validated against the list of services on the DiscountCode entity
   * itself to ensure that it is applicable.
   */
  serviceId: Scalars["ObjectID"];
  /** Optional identifier for this servicePrice. */
  servicePriceId?: Maybe<Scalars["String"]>;
};

export type ServiceResourceGroup = {
  __typename?: "ServiceResourceGroup";
  _id: Scalars["ObjectID"];
};

export type ServiceResourceGroupInput = {
  _id: Scalars["ObjectID"];
};

export type ServiceSchedule = {
  __typename?: "ServiceSchedule";
  enabled: Scalars["Boolean"];
  mergeSchedules?: Maybe<Scalars["Boolean"]>;
};

export type ServiceScheduleDefaultInstance = {
  __typename?: "ServiceScheduleDefaultInstance";
  off: Scalars["Boolean"];
  schedule: Array<ScheduleStartEnd>;
};

export type ServiceScheduleDefaultInstanceInput = {
  off: Scalars["Boolean"];
  schedule: Array<ScheduleStartEndInput>;
};

export type ServiceScheduleExceptionInstance = {
  __typename?: "ServiceScheduleExceptionInstance";
  date: Scalars["String"];
  off: Scalars["Boolean"];
  schedule: Array<ScheduleStartEnd>;
};

export type ServiceScheduleExceptionInstanceInput = {
  date: Scalars["String"];
  off: Scalars["Boolean"];
  schedule: Array<ScheduleStartEndInput>;
};

export type ServiceScheduleInput = {
  enabled: Scalars["Boolean"];
  mergeSchedules?: Maybe<Scalars["Boolean"]>;
};

export type ServiceScheduleQuery = {
  /**
   * If set, only schedules that start afterDate (inclusive) this date will be
   * included.
   */
  afterDate?: Maybe<Scalars["Date"]>;
  /**
   * If set, only schedules that end beforeDate (inclusive) this date will be
   * included.
   */
  beforeDate?: Maybe<Scalars["Date"]>;
  /** If set, only schedules that have these unique identifiers will be included. */
  ids?: Maybe<Array<Scalars["ObjectID"]>>;
};

export type ServiceSearchInput = {
  searchTerm?: Maybe<Scalars["String"]>;
  selectedOrganisationIds: Array<Scalars["ObjectID"]>;
};

export enum ServiceSortKey {
  Name = "NAME",
  Natural = "NATURAL",
  Order = "ORDER",
}

export type ServiceTier = {
  __typename?: "ServiceTier";
  _id: Scalars["ObjectID"];
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  pricePoints: Array<ServiceTierPricePoint>;
  pricingType: TierPricingType;
};

export type ServiceTierInput = {
  _id?: Maybe<Scalars["ObjectID"]>;
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  pricePoints: Array<ServiceTierPricePointInput>;
  pricingType: TierPricingType;
};

export type ServiceTierPricePoint = {
  __typename?: "ServiceTierPricePoint";
  _id: Scalars["ObjectID"];
  name?: Maybe<Scalars["String"]>;
  pricePerQuantity: Scalars["Float"];
  spacesPerQuantity: Scalars["Int"];
};

export type ServiceTierPricePointInput = {
  _id?: Maybe<Scalars["ObjectID"]>;
  name?: Maybe<Scalars["String"]>;
  pricePerQuantity: Scalars["Float"];
  spacesPerQuantity: Scalars["Int"];
};

/**
 * Enumeration of possible structure types on the Service entity
 *
 * See `Service.structure` for an example of how this is used.
 */
export enum ServiceType {
  /** The service is intended for Events with a single duration. */
  Event = "EVENT",
  /** Multi part service with optional gaps of availability. */
  Parts = "PARTS",
  /** One single service that allows multiple durations. */
  Standard = "STANDARD",
  /** Service with multiple tiers that may contain one or many pricing options. */
  Tiered = "TIERED",
}

export type SmsIntegration =
  | AppointeddSmsIntegration
  | MessagebirdSmsIntegration
  | TwilioSmsIntegration;

/** Represents the square integration being enabled on an organisation. */
export type SquareIntegration = {
  __typename?: "SquareIntegration";
  /** The square locationId that identifies this organisation. */
  locationId: Scalars["String"];
};

/** Represents the stripe integration being enabled on an organisation. */
export type StripeIntegration = {
  __typename?: "StripeIntegration";
  /** The Stripe accountId that identifies this organisation. */
  accountId: Scalars["String"];
};

/**
 * Represents an intent to capture payment before payment is actually captured.
 * This is part of Stripe's flow for handling 3DS authentication.
 *
 * We currently only require the clientSecret.
 * https://stripe.com/docs/payments/payment-intents
 */
export type StripePaymentIntent = {
  __typename?: "StripePaymentIntent";
  clientSecret: Scalars["String"];
};

export type SyncSuperUserInviteInput = {
  /** Id of the organisation related to the invite the super user accepted. */
  organisationId: Scalars["ObjectID"];
  /** Id of the user who is the super user that has just accepted a user invite. */
  userId: Scalars["ObjectID"];
};

/** Enumeration of possible tier pricing types on the Service.tiers[] property */
export enum TierPricingType {
  /** The service tier has one or many named price points defined */
  Multiple = "MULTIPLE",
  /** The service tier only has a single unnamed price point defined. */
  Single = "SINGLE",
}

export type TwilioSmsIntegration = {
  __typename?: "TwilioSmsIntegration";
  accountSid: Scalars["String"];
  name: Scalars["String"];
};

/** Enumeration of possible units of measurement types on the BookingTool entity */
export enum UnitOfMeasurement {
  /** Measured in Kilometres */
  Kilometres = "KILOMETRES",
  /** Measured in Miles */
  Miles = "MILES",
}

export type UpdateBookingToolProperties = {
  brand?: Maybe<BrandInput>;
  customColours?: Maybe<CustomColoursInput>;
  fonts?: Maybe<FontsInput>;
  forcePhoneValidationToCountry?: Maybe<Scalars["String"]>;
  forceServiceSelection?: Maybe<Scalars["Boolean"]>;
  locationSelection?: Maybe<LocationSelectionInput>;
  name?: Maybe<Scalars["String"]>;
  organisations?: Maybe<Array<BookingToolOrganisationEntry>>;
  percentageThresholdForShowingRemainingNumberOfSpaces?: Maybe<Scalars["Int"]>;
  resourceSelectionMode?: Maybe<ResourceSelectionMode>;
  restrictToResourceGroupIds?: Maybe<Array<Scalars["ObjectID"]>>;
  restrictToResourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  restrictToServiceCategoryIds?: Maybe<Array<Scalars["ObjectID"]>>;
  serviceEntries?: Maybe<Array<BookingToolServiceEntry>>;
  unitOfMeasurement?: Maybe<UnitOfMeasurement>;
};

export type UpdateDiscountCodeInput = {
  /** Id of the discount code being updated */
  _id: Scalars["ObjectID"];
  /**
   * Boolean representing whether this discount code is currently active.
   * If 'true' this discount code is available for redemption.
   */
  active?: Maybe<Scalars["Boolean"]>;
  /**
   * Code that the end-user must provide to redeem this discount.
   * If this code is being created as live, the code must not already
   * be the same (case insensitively) as another live code for this
   * organisation.
   */
  code?: Maybe<Scalars["String"]>;
  /** Object representing the deduction applied to a given price. */
  discount?: Maybe<DiscountCodeDiscountInput>;
  /** Range of time in which this discount code can be redeemed. */
  expiry?: Maybe<DiscountCodeExpiryInput>;
  /**
   * Internal human-readable label identifying this discount code, this
   * label is not exposed to the end-user.
   */
  label?: Maybe<Scalars["String"]>;
  /** Maximum number of times this discount code can be claimed globally. */
  maxClaims?: Maybe<Scalars["Int"]>;
  /** Maximum number of times this discount code can be claimed for a given email address. */
  maxClaimsPerCustomer?: Maybe<Scalars["Int"]>;
  /** The services this discount code is applicable to. */
  serviceIds?: Maybe<Array<Scalars["ObjectID"]>>;
};

export type UpdateSamlDomainInput = {
  /** Url of the SAML file saved in an S3 bucket */
  s3SamlKey: Scalars["String"];
  /** Id of the saml domain */
  samlDomainId: Scalars["ObjectID"];
  /** Id of the user making the request */
  userId: Scalars["ObjectID"];
};

export type UpdateSamlDomainUserRoleInput = {
  /**
   * If true, the user can manage customers. This is only applicable to users
   * with the "Restricted" role as all other roles already have the ability to
   * manage customers.
   */
  allowCustomerManagement?: Maybe<Scalars["Boolean"]>;
  /**
   * Flag that indicates whether a "USER" type role can also modify their
   * associated resources working hours.
   */
  allowScheduleModification?: Maybe<Scalars["Boolean"]>;
  /** If true, prevent this user from accessing the calendar sync interface. */
  calendarSyncHidden?: Maybe<Scalars["Boolean"]>;
  /** The email address of the user who is having their role updated */
  email: Scalars["String"];
  /** Id of the organisation that the user will have access to */
  organisationId: Scalars["ObjectID"];
  /** An array of resourceIds that represent the resources this user has access to */
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /** The role that determines the users level of access */
  role: UserRole;
  /** Id of the samlDomainUserRole we want to edit */
  samlDomainUserRoleId: Scalars["ObjectID"];
};

export type UpdateSchedule = {
  /** Unique identifier fo the schedule to update. */
  _id: Scalars["ObjectID"];
  /**
   * Indicates if this schedule marks the entity its associated with as available
   * or unavailable.
   */
  available?: Maybe<Scalars["Boolean"]>;
  /** Date and time that this schedule ends at. */
  end?: Maybe<Scalars["Date"]>;
  /** An optional array of dates where the schedule is not available */
  exceptions?: Maybe<Array<Scalars["Date"]>>;
  /** Optional reason that this schedule was made. */
  reason?: Maybe<Scalars["String"]>;
  /**
   * Recurrence rule that defines how this schedule recurs according to the RRULE
   * specification.
   */
  rrule?: Maybe<Scalars["RRule"]>;
  /** Date and time that this schedule starts at. */
  start?: Maybe<Scalars["Date"]>;
  /**
   * Optional name of the time zone that this schedule is in.
   *
   * If not set this will default to the organisation's time zone.
   */
  zone?: Maybe<Scalars["IANATimeZone"]>;
};

export type UpdateServiceInput = {
  allowOnlineGroup?: Maybe<Scalars["Boolean"]>;
  assetIds?: Maybe<Array<Scalars["ObjectID"]>>;
  bookingDepositAmount?: Maybe<Scalars["String"]>;
  bookingNoticePeriod?: Maybe<Scalars["Int"]>;
  bookingPaymentOption?: Maybe<PaymentOption>;
  bookingPaymentOptional?: Maybe<Scalars["Boolean"]>;
  bookingVisibilityType?: Maybe<BookingVisibilityType>;
  buffers?: Maybe<BuffersInput>;
  categoryId?: Maybe<Scalars["ObjectID"]>;
  description?: Maybe<Scalars["String"]>;
  durations?: Maybe<Array<ServiceDurationInput>>;
  generateTicketsEnabled?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ObjectID"];
  image?: Maybe<Scalars["String"]>;
  location?: Maybe<Scalars["String"]>;
  maxParticipantsPerBooking?: Maybe<Scalars["Int"]>;
  microsoftTeamsMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  occupancy?: Maybe<Scalars["Int"]>;
  order?: Maybe<Scalars["Int"]>;
  organisationId: Scalars["ObjectID"];
  parts?: Maybe<Array<ServicePartInput>>;
  rescheduleEnabled?: Maybe<Scalars["Boolean"]>;
  rescheduleNoticePeriodHours?: Maybe<Scalars["Float"]>;
  rescheduleResourceSelectionEnabled?: Maybe<Scalars["Boolean"]>;
  resourceAllocationType?: Maybe<ResourceAllocationType>;
  resourceGroups?: Maybe<Array<ServiceResourceGroupInput>>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  schedule?: Maybe<ServiceScheduleInput>;
  tiers?: Maybe<Array<ServiceTierInput>>;
  zoomMeetingsEnabled?: Maybe<Scalars["Boolean"]>;
};

export type UpdateUserAccountPermissionInput = {
  /** Unique identifier for this UserAccountPermission. */
  _id: Scalars["ObjectID"];
  /** Indicates whether this user account permission can modify their associated resources working hours. */
  allowScheduleModification?: Maybe<Scalars["Boolean"]>;
  /** The ids of the allowed resources for this user account permission. */
  allowedResourceIds?: Maybe<Array<Scalars["ObjectID"]>>;
  /** The level of access this UserAccountPermission grants on the target organisation. */
  role?: Maybe<UserAccountPermissionRole>;
};

export type UpdateUserInput = {
  _id: Scalars["ObjectID"];
  name?: Maybe<Scalars["String"]>;
};

export type UpdateUserLocaleInput = {
  locale?: Maybe<Scalars["String"]>;
};

export type UpdateUserSignInDetailsInput = {
  _id: Scalars["ObjectID"];
  currentPassword: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  newPassword?: Maybe<Scalars["String"]>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type User = {
  __typename?: "User";
  /** Unique identifier for this Appointedd user. */
  _id: Scalars["ObjectID"];
  /** Indicates if the user has admin/owner on at least one account (organisation). */
  adminOnAtLeastOneAccount: Scalars["Boolean"];
  /** The number of user account permissions for manageable users that have the role admin. */
  adminRoleCount: Scalars["Int"];
  /**
   * Returns paginated resource groups which the user has access to. If the user is restricted, this only returns
   * resource groups where the user user has access to all resources on the group
   */
  allowedResourceGroups: ResourceGroupPage;
  /** Indicates if the user was created via the Appointedd ap_token slack integration. */
  apTokenUser: Scalars["Boolean"];
  bookingTools: BookingToolPage;
  /** Gets all the clients that have access to accounts this user is an admin of. */
  clients: Array<UserClient>;
  /**
   * Get the current organisation that this user is currently signed in to. This
   * will return `null` if the user is not currently signed in to any
   * organisation.
   */
  currentOrganisation?: Maybe<Organisation>;
  /** Email address of this user. */
  email: Scalars["String"];
  /**
   * Indicates if the user's cognito user is connected to a facebook account.
   * If true the user will be able to sign into Appointedd using
   * their connected facebook account
   */
  facebookAccountIsConnected: Scalars["Boolean"];
  /**
   * Indicates if the user's cognito user is connected to a google account.
   * If true the user will be able to sign into Appointedd using
   * their connected google account
   */
  googleAccountIsConnected: Scalars["Boolean"];
  /**
   * Indicates if the user is attempting to connect a cognito account to a google account.
   * If set the LinkUserToGoogle mutation should be able to connect the account to google.
   */
  googleAccountIsPending: Scalars["String"];
  /** Indicates if the user is allowed to access Data Insights. */
  hasDataInsights: Scalars["Boolean"];
  /** Indicates if the users account has MFA enabled. */
  isMfaEnabled: Scalars["Boolean"];
  /** Indicates if the creation of a saml_domain document is allowed for this user */
  isSamlDomainCreationAllowed: Scalars["Boolean"];
  /**
   * The language code that the user has selected for the web application to be translated to.
   * If null then the locale will be auto detected from the browser.
   */
  locale?: Maybe<Scalars["String"]>;
  /** Returns the page containing the resulting manageable users. */
  manageableUsers: UserPage;
  /** Name of this user. */
  name: Scalars["String"];
  /**
   * Get the relationship between this user and an organisation in
   * Appointedd by the organisation's unique identifier.
   *
   * You can use the resulting record to access data on the
   * organisation if you require it.
   */
  organisation: Organisation;
  /** Gets all the organisations that this user has access to. */
  organisations?: Maybe<Array<Maybe<Organisation>>>;
  /** The number of user account permissions for manageable users that have the role restricted. */
  restrictedRoleCount: Scalars["Int"];
  /** The saml domain document associated to this user */
  samlDomain?: Maybe<SamlDomain>;
  /** Indicates if the user is allowed to access the setup page for SAML. */
  samlSetupAllowed: Scalars["Boolean"];
  /** Whether the user has completed the setup checklist. */
  setupChecklistCompleted: Scalars["Boolean"];
  /** The setup checklist steps this user has completed. */
  setupChecklistCompletedSteps: Array<Maybe<UserSetupChecklistStep>>;
  /** The number of user account permissions for manageable users that have the role standard. */
  standardRoleCount: Scalars["Int"];
  /** Returns paginated UserAccountPermissions for this user. */
  userAccountPermissions: UserAccountPermissionPage;
  yextIntegrationTokens: YextIntegrationTokenPage;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserAllowedResourceGroupsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ResourceGroupSortKey>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserBookingToolsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<BookingToolSortKey>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserManageableUsersArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserOrganisationArgs = {
  id: Scalars["ObjectID"];
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserOrganisationsArgs = {
  apTokenOverride?: Maybe<ApTokenOverrideInput>;
  filter?: Maybe<OrganisationsFilter>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserUserAccountPermissionsArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

/**
 * A user is an entity in Appointedd that has permissions to access one
 * or more organisations in Appointedd and can authenticate requests
 * as themselves.
 */
export type UserYextIntegrationTokensArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
};

export type UserAccountPermission = {
  __typename?: "UserAccountPermission";
  /** Unique identifier for this UserAccountPermission. */
  _id: Scalars["ObjectID"];
  /** Indicates whether this user account permission can modify their associated resources working hours. */
  allowScheduleModification?: Maybe<Scalars["Boolean"]>;
  /** The organisation this UserAccountPermission refers to. */
  organisation: Organisation;
  /** Resources this role grants access to. Only relevant if the role is "RESTRICTED" */
  resources?: Maybe<ResourcePage>;
  /** The level of access this UserAccountPermission grants on the target organisation */
  role: UserAccountPermissionRole;
  /**
   * The user this UserAccountPermission refers to.
   *
   * If this value is not present, this UserAccountPermission is still awaiting
   * redemption via a user invite.
   */
  user?: Maybe<User>;
};

export type UserAccountPermissionResourcesArgs = {
  after?: Maybe<Scalars["ObjectID"]>;
  before?: Maybe<Scalars["ObjectID"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
  order?: Maybe<PageOrder>;
  sortBy?: Maybe<ResourceSortKey>;
};

/**
 * Page containing the resulting UserAccountPermissions for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type UserAccountPermissionPage = {
  __typename?: "UserAccountPermissionPage";
  /** Array of nodes containing the users that are on this page. */
  edges: Array<UserAccountPermissionPageEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: UserAccountPermissionPageInfo;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type UserAccountPermissionPageEdge = {
  __typename?: "UserAccountPermissionPageEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** UserAccountPermission that is on this page. */
  node: UserAccountPermission;
};

export type UserAccountPermissionPageInfo = {
  __typename?: "UserAccountPermissionPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

/**
 * Role value used on a UserAccountPermission. Equivalent
 * to the roles previously used in the manager array on
 * an organisation.
 */
export enum UserAccountPermissionRole {
  Admin = "ADMIN",
  Restricted = "RESTRICTED",
  Standard = "STANDARD",
}

export type UserClient = {
  __typename?: "UserClient";
  /** Unique identifier for this client. */
  _id: Scalars["ObjectID"];
  /** Accounts this client is restricted to. */
  accountIds?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /** Timestamp of when client was deleted. */
  deleted?: Maybe<Scalars["Date"]>;
  /** Description for this client. */
  description?: Maybe<Scalars["String"]>;
  /** Name of this client. */
  name: Scalars["String"];
  /** User email associated with this client. */
  userEmail: Scalars["String"];
};

export type UserClientCreateInput = {
  accountIds?: Maybe<Array<Scalars["ObjectID"]>>;
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type UserClientCreateResponse = {
  __typename?: "UserClientCreateResponse";
  /** Unique identifier for this client. */
  _id: Scalars["ObjectID"];
  /** Accounts this client is restricted to. */
  accountIds?: Maybe<Array<Maybe<Scalars["ObjectID"]>>>;
  /** Description for this client. */
  description?: Maybe<Scalars["String"]>;
  /** Name of this client. */
  name: Scalars["String"];
  /** Unique identifier for this client. */
  secret: Scalars["String"];
  /** User email associated with this client. */
  userEmail: Scalars["String"];
};

export type UserClientUpdateInput = {
  _id: Scalars["ObjectID"];
  accountIds?: Maybe<Array<Scalars["ObjectID"]>>;
  description?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type UserInvitation = {
  __typename?: "UserInvitation";
  _id: Scalars["ObjectID"];
  createdByUserId: Scalars["ObjectID"];
  description?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
};

/**
 * Page containing the resulting users for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type UserPage = {
  __typename?: "UserPage";
  /** Array of nodes containing the users that are on this page. */
  edges: Array<UserPageEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: UserPageInfo;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type UserPageEdge = {
  __typename?: "UserPageEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  /** User that is on this page. */
  node: User;
};

export type UserPageInfo = {
  __typename?: "UserPageInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

/**
 * Enumeration of the names of possible roles for Appointedd
 * users which specifies a specific access level that an
 * Appointedd user has on an Appointedd organisation.
 */
export enum UserRole {
  /** Administrator users have full access to an Appointedd organisation. */
  Admin = "ADMIN",
  /**
   * Owner users have full access to an Appointedd organisation and is also
   * the root user (first user created) for that organisation.
   */
  Owner = "OWNER",
  /**
   * Standard users on an organisation do not have access to certain
   * settings and may have their access restricted to specific resources.
   */
  User = "USER",
}

export enum UserSetupChecklistStep {
  BookingSettings = "BOOKING_SETTINGS",
  BookingTools = "BOOKING_TOOLS",
  CalendarSync = "CALENDAR_SYNC",
  ChecklistStarted = "CHECKLIST_STARTED",
  EmailSms = "EMAIL_SMS",
  InviteUsers = "INVITE_USERS",
  ResourceAvailability = "RESOURCE_AVAILABILITY",
  ServiceDetails = "SERVICE_DETAILS",
  TestBooking = "TEST_BOOKING",
}

export type UtilisationResult = {
  __typename?: "UtilisationResult";
  /** The day of a given month as a string which we are getting the utilisation statistics for. */
  day: Scalars["String"];
  /** The total minutes available (only considers resources schedules) for a resource for a day. */
  minutesAvailable: Scalars["Int"];
  /** The total minutes blocked (breaks) for a resource for a day. */
  minutesBlocked: Scalars["Int"];
  /** The total minutes booked for a resource for a day. */
  minutesBooked: Scalars["Int"];
  /** The total number of bookings starting on a day. */
  numberOfBookings: Scalars["Int"];
};

export type WorkingHours = {
  __typename?: "WorkingHours";
  available: Array<Interval>;
  unavailable: Array<Interval>;
};

export type YextDisplayCoordinates = {
  __typename?: "YextDisplayCoordinates";
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
};

export type YextIntegrationMappingResult = {
  __typename?: "YextIntegrationMappingResult";
  entityId: Scalars["String"];
  organisationId: Scalars["ObjectID"];
  syncAvailability?: Maybe<Scalars["Boolean"]>;
  syncLocation?: Maybe<Scalars["Boolean"]>;
  syncReservationUrl?: Maybe<Scalars["Boolean"]>;
};

export type YextIntegrationToken = {
  __typename?: "YextIntegrationToken";
  _id: Scalars["ObjectID"];
  created: Scalars["Date"];
  expiresAt: Scalars["Date"];
  locationEntity?: Maybe<YextLocationEntity>;
  metadata: YextIntegrationTokenMetadata;
  scopes: Array<Maybe<Scalars["String"]>>;
  updated?: Maybe<Scalars["Date"]>;
};

export type YextIntegrationTokenLocationEntityArgs = {
  entityId: Scalars["String"];
};

export type YextIntegrationTokenInfo = {
  __typename?: "YextIntegrationTokenInfo";
  /** Cursor for the last node in this page's edges. */
  endCursor?: Maybe<Scalars["ObjectID"]>;
  /** Used to indicate whether more edges exist after the current page. */
  hasNextPage: Scalars["Boolean"];
  /** Used to indicate whether more edges exist before the current page. */
  hasPreviousPage: Scalars["Boolean"];
  /** Cursor for the first node in this page's edges. */
  startCursor?: Maybe<Scalars["ObjectID"]>;
  /**
   * Number of pages in the query that this page is a part of.
   *
   * This is a custom extension and not part of the Relay pagination
   * specification.
   */
  total: Scalars["Int"];
};

export type YextIntegrationTokenMetadata = {
  __typename?: "YextIntegrationTokenMetadata";
  yextAccountName: Scalars["String"];
  yextAppSpecificAccountId: Scalars["String"];
};

/**
 * Page containing the resulting Yext Integration Tokens for a paginated query.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 * specification with some additional extensions.
 */
export type YextIntegrationTokenPage = {
  __typename?: "YextIntegrationTokenPage";
  /** Array of nodes containing the Yext integration tokens that are on this page. */
  edges: Array<YextIntegrationTokenPageEdge>;
  /**
   * Information about the current page in relation to other pages for
   * this paginated query.
   *
   * Conforms to the
   * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
   * specification.
   */
  pageInfo: YextIntegrationTokenInfo;
};

/**
 * Information for a node in a page.
 *
 * Conforms to the
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 * specification.
 */
export type YextIntegrationTokenPageEdge = {
  __typename?: "YextIntegrationTokenPageEdge";
  /**
   * Value of the property on the node that is used as the cursor for
   * pagination.
   */
  cursor: Scalars["ObjectID"];
  node: YextIntegrationToken;
};

export type YextLocationEntity = {
  __typename?: "YextLocationEntity";
  _id: Scalars["String"];
  address?: Maybe<ConvertedYextAddress>;
  coordinates?: Maybe<YextDisplayCoordinates>;
  uid: Scalars["String"];
};

export type ZoomAccount = {
  __typename?: "ZoomAccount";
  accountId?: Maybe<Scalars["String"]>;
  webinarAccountId?: Maybe<Scalars["String"]>;
};

export type YextConfigurationResult = {
  __typename?: "yextConfigurationResult";
  entityId: Scalars["String"];
  preview: ConvertedYextAddress;
  syncAvailability: Scalars["Boolean"];
  syncLocation: Scalars["Boolean"];
  syncReservationUrl: Scalars["Boolean"];
  syncedBookingToolId?: Maybe<Scalars["ObjectID"]>;
  token: YextIntegrationToken;
  tokenId: Scalars["ObjectID"];
};

export type GetBookingToolDataQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  serviceFilters?: Maybe<ServiceFilters>;
  serviceCursor?: Maybe<Scalars["ObjectID"]>;
  organisationCursor?: Maybe<Scalars["ObjectID"]>;
}>;

export type GetBookingToolDataQuery = { __typename?: "Query" } & {
  bookingTool?: Maybe<
    { __typename?: "BookingTool" } & Pick<
      BookingTool,
      | "name"
      | "_id"
      | "forcePhoneValidationToCountry"
      | "forceServiceSelection"
      | "resourceSelectionMode"
      | "forceOrganisationSelection"
      | "percentageThresholdForShowingRemainingNumberOfSpaces"
      | "mapkitAuthenticationToken"
      | "unitOfMeasurement"
      | "hideAppointeddFooter"
      | "organisationAvailabilityFlow"
    > & {
        services: { __typename?: "ServicePage" } & {
          edges: Array<
            { __typename?: "ServiceEdge" } & Pick<ServiceEdge, "cursor"> & {
                node: { __typename?: "Service" } & Pick<
                  Service,
                  | "_id"
                  | "name"
                  | "description"
                  | "image"
                  | "maxParticipantsPerBooking"
                  | "occupancy"
                  | "bookingVisibilityType"
                  | "bookingPaymentOption"
                  | "bookingDepositAmount"
                  | "isDiscountCodeAvailable"
                  | "availabilityDisplayMode"
                  | "numberOfResources"
                  | "resourceAllocationType"
                > & {
                    tiers?: Maybe<
                      Array<
                        { __typename?: "ServiceTier" } & Pick<
                          ServiceTier,
                          "_id" | "name" | "description" | "pricingType"
                        > & {
                            pricePoints: Array<
                              { __typename?: "ServiceTierPricePoint" } & Pick<
                                ServiceTierPricePoint,
                                | "_id"
                                | "name"
                                | "pricePerQuantity"
                                | "spacesPerQuantity"
                              >
                            >;
                          }
                      >
                    >;
                    durations: Array<
                      { __typename?: "ServiceDuration" } & Pick<
                        ServiceDuration,
                        "default" | "minutes" | "price" | "oldPrice" | "POA"
                      >
                    >;
                    parts?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: "ServicePart" } & Pick<
                            ServicePart,
                            "label" | "type" | "duration" | "durationType"
                          >
                        >
                      >
                    >;
                    organisation: { __typename?: "Organisation" } & Pick<
                      Organisation,
                      "_id"
                    >;
                    category: { __typename?: "Category" } & Pick<
                      Category,
                      "_id" | "name" | "order"
                    >;
                  };
              }
          >;
          pageInfo: { __typename?: "ServicePageInfo" } & Pick<
            ServicePageInfo,
            | "hasNextPage"
            | "hasPreviousPage"
            | "total"
            | "startCursor"
            | "endCursor"
          >;
        };
        organisations: { __typename?: "OrganisationPage" } & {
          edges: Array<
            { __typename?: "OrganisationEdge" } & Pick<
              OrganisationEdge,
              "cursor"
            > & {
                node: { __typename?: "Organisation" } & Pick<
                  Organisation,
                  | "_id"
                  | "defaultTimeZone"
                  | "name"
                  | "slug"
                  | "bookingNoticePeriod"
                  | "currency"
                  | "allowBookingNotes"
                  | "allowResourceGroupSelection"
                  | "allowResourceImageDisplay"
                  | "allowResourceSelection"
                  | "allowSelectAnyResource"
                  | "areConfirmationEmailsEnabled"
                  | "areInvoiceEmailsEnabled"
                  | "forceTimezone"
                  | "isPhoneNumberRequiredForBookings"
                  | "reservationExpiryMinutes"
                  | "resourceSelectionBeforeAvailability"
                  | "serviceNotBookableAction"
                  | "showPricesOnBookingTools"
                  | "bookingConfirmationMessage"
                  | "businessPhone"
                  | "communicationFromEmail"
                  | "customBookingNotesText"
                  | "customNoAvailabilityText"
                  | "privacyPolicyUrl"
                  | "marketingEnabled"
                  | "marketingOptInLabel"
                  | "enableMarketingOptIn"
                  | "enabledFeatureFlags"
                > & {
                    location?: Maybe<
                      { __typename?: "Location" } & Pick<
                        Location,
                        "address" | "latitude" | "longitude"
                      >
                    >;
                    adyenIntegrationToken?: Maybe<
                      { __typename?: "AdyenIntegrationToken" } & Pick<
                        AdyenIntegrationToken,
                        | "_id"
                        | "adyenCheckoutBaseUrl"
                        | "cardHolderNameRequired"
                      >
                    >;
                    stripeIntegration?: Maybe<
                      { __typename?: "StripeIntegration" } & Pick<
                        StripeIntegration,
                        "accountId"
                      >
                    >;
                    squareIntegration?: Maybe<
                      { __typename?: "SquareIntegration" } & Pick<
                        SquareIntegration,
                        "locationId"
                      >
                    >;
                    externalCrmFields: Array<
                      { __typename?: "CrmField" } & Pick<
                        CrmField,
                        "id" | "name" | "type" | "required"
                      >
                    >;
                    externalBookingQuestions: Array<
                      { __typename?: "BookingQuestion" } & Pick<
                        BookingQuestion,
                        "id" | "type" | "name" | "required" | "url"
                      > & {
                          services?: Maybe<
                            Array<
                              { __typename?: "Service" } & Pick<Service, "_id">
                            >
                          >;
                          options?: Maybe<
                            Array<
                              {
                                __typename?: "BookingQuestionDropdownOption";
                              } & Pick<
                                BookingQuestionDropdownOption,
                                "optionId" | "value"
                              >
                            >
                          >;
                          subquestions?: Maybe<
                            Array<
                              {
                                __typename?: "BookingQuestionSubquestion";
                              } & Pick<
                                BookingQuestionSubquestion,
                                | "id"
                                | "type"
                                | "name"
                                | "required"
                                | "dropdownTriggers"
                                | "url"
                              > & {
                                  options?: Maybe<
                                    Array<
                                      {
                                        __typename?: "BookingQuestionDropdownOption";
                                      } & Pick<
                                        BookingQuestionDropdownOption,
                                        "optionId" | "value"
                                      >
                                    >
                                  >;
                                }
                            >
                          >;
                        }
                    >;
                    micrositeColours: {
                      __typename?: "MicrositeColours";
                    } & Pick<MicrositeColours, "primary" | "secondary">;
                    customContent?: Maybe<
                      Array<
                        { __typename?: "OrganisationCustomContent" } & Pick<
                          OrganisationCustomContent,
                          "language" | "marketingOptInLabel" | "privacyPolicy"
                        >
                      >
                    >;
                  };
              }
          >;
          pageInfo: { __typename?: "OrganisationPageInfo" } & Pick<
            OrganisationPageInfo,
            | "hasNextPage"
            | "hasPreviousPage"
            | "total"
            | "startCursor"
            | "endCursor"
          >;
        };
        locationSelection?: Maybe<
          { __typename?: "LocationSelection" } & Pick<
            LocationSelection,
            | "searchAndMapEnabled"
            | "includedCountries"
            | "maxLocationSearchRange"
            | "minLocationsToDisplay"
            | "maxLocationsToDisplay"
          > & {
              overrideLocationSearchQueryMapping?: Maybe<
                Array<
                  { __typename?: "LocationQueryMapping" } & Pick<
                    LocationQueryMapping,
                    "to" | "from"
                  >
                >
              >;
            }
        >;
        customColours?: Maybe<
          { __typename?: "CustomColours" } & Pick<
            CustomColours,
            | "primary"
            | "secondary"
            | "logoUrl"
            | "primaryActionColour"
            | "primaryDarkColour"
            | "primaryLightColour"
            | "accentColour"
            | "theme"
            | "fontUrl"
            | "fontFamily"
            | "pageBackground"
          >
        >;
        brand?: Maybe<
          { __typename?: "Brand" } & Pick<
            Brand,
            | "name"
            | "brandThemeMode"
            | "allowVisitorThemeOverride"
            | "logoUrl"
            | "bannerUrl"
            | "fontUrl"
            | "fontFamily"
            | "faviconUrl"
            | "pageTitleSuffix"
          > & {
              light?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
              dark?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
            }
        >;
        fonts?: Maybe<
          { __typename?: "Fonts" } & Pick<Fonts, "regular" | "bold">
        >;
      }
  >;
};

export type GetBookingToolSettingsQueryVariables = Exact<{
  id: Scalars["ObjectID"];
}>;

export type GetBookingToolSettingsQuery = { __typename?: "Query" } & {
  bookingTool?: Maybe<
    { __typename?: "BookingTool" } & Pick<
      BookingTool,
      | "name"
      | "_id"
      | "forcePhoneValidationToCountry"
      | "forceServiceSelection"
      | "resourceSelectionMode"
      | "forceOrganisationSelection"
      | "percentageThresholdForShowingRemainingNumberOfSpaces"
      | "mapkitAuthenticationToken"
      | "unitOfMeasurement"
      | "hideAppointeddFooter"
      | "organisationAvailabilityFlow"
    > & {
        locationSelection?: Maybe<
          { __typename?: "LocationSelection" } & Pick<
            LocationSelection,
            | "searchAndMapEnabled"
            | "includedCountries"
            | "maxLocationSearchRange"
            | "minLocationsToDisplay"
            | "maxLocationsToDisplay"
          > & {
              overrideLocationSearchQueryMapping?: Maybe<
                Array<
                  { __typename?: "LocationQueryMapping" } & Pick<
                    LocationQueryMapping,
                    "to" | "from"
                  >
                >
              >;
            }
        >;
        customColours?: Maybe<
          { __typename?: "CustomColours" } & Pick<
            CustomColours,
            | "primary"
            | "secondary"
            | "logoUrl"
            | "primaryActionColour"
            | "primaryDarkColour"
            | "primaryLightColour"
            | "accentColour"
            | "theme"
            | "fontUrl"
            | "fontFamily"
            | "pageBackground"
          >
        >;
        brand?: Maybe<
          { __typename?: "Brand" } & Pick<
            Brand,
            | "name"
            | "brandThemeMode"
            | "allowVisitorThemeOverride"
            | "logoUrl"
            | "bannerUrl"
            | "fontUrl"
            | "fontFamily"
            | "faviconUrl"
            | "pageTitleSuffix"
          > & {
              light?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
              dark?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
            }
        >;
        fonts?: Maybe<
          { __typename?: "Fonts" } & Pick<Fonts, "regular" | "bold">
        >;
      }
  >;
};

export type GetBookingToolScopedServicesQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  serviceCursor?: Maybe<Scalars["ObjectID"]>;
  serviceFilters?: Maybe<ServiceFilters>;
}>;

export type GetBookingToolScopedServicesQuery = { __typename?: "Query" } & {
  bookingTool?: Maybe<
    { __typename?: "BookingTool" } & {
      services: { __typename?: "ServicePage" } & {
        edges: Array<
          { __typename?: "ServiceEdge" } & Pick<ServiceEdge, "cursor"> & {
              node: { __typename?: "Service" } & Pick<
                Service,
                | "_id"
                | "name"
                | "description"
                | "image"
                | "maxParticipantsPerBooking"
                | "occupancy"
                | "bookingVisibilityType"
                | "bookingPaymentOption"
                | "bookingDepositAmount"
                | "isDiscountCodeAvailable"
                | "availabilityDisplayMode"
                | "numberOfResources"
                | "resourceAllocationType"
              > & {
                  tiers?: Maybe<
                    Array<
                      { __typename?: "ServiceTier" } & Pick<
                        ServiceTier,
                        "_id" | "name" | "description" | "pricingType"
                      > & {
                          pricePoints: Array<
                            { __typename?: "ServiceTierPricePoint" } & Pick<
                              ServiceTierPricePoint,
                              | "_id"
                              | "name"
                              | "pricePerQuantity"
                              | "spacesPerQuantity"
                            >
                          >;
                        }
                    >
                  >;
                  durations: Array<
                    { __typename?: "ServiceDuration" } & Pick<
                      ServiceDuration,
                      "default" | "minutes" | "price" | "oldPrice" | "POA"
                    >
                  >;
                  parts?: Maybe<
                    Array<
                      Maybe<
                        { __typename?: "ServicePart" } & Pick<
                          ServicePart,
                          "label" | "type" | "duration" | "durationType"
                        >
                      >
                    >
                  >;
                  organisation: { __typename?: "Organisation" } & Pick<
                    Organisation,
                    "_id"
                  >;
                  category: { __typename?: "Category" } & Pick<
                    Category,
                    "_id" | "name" | "order"
                  >;
                };
            }
        >;
        pageInfo: { __typename?: "ServicePageInfo" } & Pick<
          ServicePageInfo,
          | "hasNextPage"
          | "hasPreviousPage"
          | "total"
          | "startCursor"
          | "endCursor"
        >;
      };
    }
  >;
};

export type GetOrganisationDetailsQueryVariables = Exact<{
  id: Scalars["ObjectID"];
}>;

export type GetOrganisationDetailsQuery = { __typename?: "Query" } & {
  organisation?: Maybe<
    { __typename?: "Organisation" } & Pick<
      Organisation,
      | "_id"
      | "defaultTimeZone"
      | "name"
      | "slug"
      | "bookingNoticePeriod"
      | "currency"
      | "allowBookingNotes"
      | "allowResourceGroupSelection"
      | "allowResourceImageDisplay"
      | "allowResourceSelection"
      | "allowSelectAnyResource"
      | "areConfirmationEmailsEnabled"
      | "areInvoiceEmailsEnabled"
      | "forceTimezone"
      | "isPhoneNumberRequiredForBookings"
      | "reservationExpiryMinutes"
      | "resourceSelectionBeforeAvailability"
      | "serviceNotBookableAction"
      | "showPricesOnBookingTools"
      | "bookingConfirmationMessage"
      | "businessPhone"
      | "communicationFromEmail"
      | "customBookingNotesText"
      | "customNoAvailabilityText"
      | "privacyPolicyUrl"
      | "enabledFeatureFlags"
      | "marketingEnabled"
      | "marketingOptInLabel"
      | "enableMarketingOptIn"
      | "hideAppointeddFooter"
    > & {
        location?: Maybe<
          { __typename?: "Location" } & Pick<
            Location,
            "address" | "latitude" | "longitude"
          >
        >;
        adyenIntegrationToken?: Maybe<
          { __typename?: "AdyenIntegrationToken" } & Pick<
            AdyenIntegrationToken,
            "_id" | "adyenCheckoutBaseUrl" | "cardHolderNameRequired"
          >
        >;
        stripeIntegration?: Maybe<
          { __typename?: "StripeIntegration" } & Pick<
            StripeIntegration,
            "accountId"
          >
        >;
        squareIntegration?: Maybe<
          { __typename?: "SquareIntegration" } & Pick<
            SquareIntegration,
            "locationId"
          >
        >;
        externalCrmFields: Array<
          { __typename?: "CrmField" } & Pick<
            CrmField,
            "id" | "name" | "type" | "required"
          >
        >;
        externalBookingQuestions: Array<
          { __typename?: "BookingQuestion" } & Pick<
            BookingQuestion,
            "id" | "type" | "name" | "required" | "url"
          > & {
              services?: Maybe<
                Array<{ __typename?: "Service" } & Pick<Service, "_id">>
              >;
              options?: Maybe<
                Array<
                  { __typename?: "BookingQuestionDropdownOption" } & Pick<
                    BookingQuestionDropdownOption,
                    "optionId" | "value"
                  >
                >
              >;
              subquestions?: Maybe<
                Array<
                  { __typename?: "BookingQuestionSubquestion" } & Pick<
                    BookingQuestionSubquestion,
                    | "id"
                    | "type"
                    | "name"
                    | "required"
                    | "dropdownTriggers"
                    | "url"
                  > & {
                      options?: Maybe<
                        Array<
                          {
                            __typename?: "BookingQuestionDropdownOption";
                          } & Pick<
                            BookingQuestionDropdownOption,
                            "optionId" | "value"
                          >
                        >
                      >;
                    }
                >
              >;
            }
        >;
        micrositeColours: { __typename?: "MicrositeColours" } & Pick<
          MicrositeColours,
          "primary" | "secondary"
        >;
        brandConfig?: Maybe<
          { __typename?: "Brand" } & Pick<
            Brand,
            | "name"
            | "brandThemeMode"
            | "allowVisitorThemeOverride"
            | "logoUrl"
            | "bannerUrl"
            | "fontUrl"
            | "fontFamily"
            | "faviconUrl"
            | "pageTitleSuffix"
          > & {
              light?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
              dark?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
            }
        >;
        customContent?: Maybe<
          Array<
            { __typename?: "OrganisationCustomContent" } & Pick<
              OrganisationCustomContent,
              "language" | "marketingOptInLabel" | "privacyPolicy"
            >
          >
        >;
      }
  >;
};

export type GetOrganisationQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  serviceCursor?: Maybe<Scalars["ObjectID"]>;
  serviceFilters?: Maybe<ServiceFilters>;
}>;

export type GetOrganisationQuery = { __typename?: "Query" } & {
  organisation?: Maybe<
    { __typename?: "Organisation" } & Pick<
      Organisation,
      | "_id"
      | "defaultTimeZone"
      | "name"
      | "slug"
      | "bookingNoticePeriod"
      | "currency"
      | "allowBookingNotes"
      | "allowResourceGroupSelection"
      | "allowResourceImageDisplay"
      | "allowResourceSelection"
      | "allowSelectAnyResource"
      | "areConfirmationEmailsEnabled"
      | "areInvoiceEmailsEnabled"
      | "forceTimezone"
      | "isPhoneNumberRequiredForBookings"
      | "reservationExpiryMinutes"
      | "resourceSelectionBeforeAvailability"
      | "serviceNotBookableAction"
      | "showPricesOnBookingTools"
      | "bookingConfirmationMessage"
      | "businessPhone"
      | "communicationFromEmail"
      | "customBookingNotesText"
      | "customNoAvailabilityText"
      | "privacyPolicyUrl"
      | "enabledFeatureFlags"
      | "marketingEnabled"
      | "marketingOptInLabel"
      | "enableMarketingOptIn"
      | "hideAppointeddFooter"
    > & {
        location?: Maybe<
          { __typename?: "Location" } & Pick<
            Location,
            "address" | "latitude" | "longitude"
          >
        >;
        adyenIntegrationToken?: Maybe<
          { __typename?: "AdyenIntegrationToken" } & Pick<
            AdyenIntegrationToken,
            "_id" | "adyenCheckoutBaseUrl" | "cardHolderNameRequired"
          >
        >;
        stripeIntegration?: Maybe<
          { __typename?: "StripeIntegration" } & Pick<
            StripeIntegration,
            "accountId"
          >
        >;
        squareIntegration?: Maybe<
          { __typename?: "SquareIntegration" } & Pick<
            SquareIntegration,
            "locationId"
          >
        >;
        externalCrmFields: Array<
          { __typename?: "CrmField" } & Pick<
            CrmField,
            "id" | "name" | "type" | "required"
          >
        >;
        externalBookingQuestions: Array<
          { __typename?: "BookingQuestion" } & Pick<
            BookingQuestion,
            "id" | "type" | "name" | "required" | "url"
          > & {
              services?: Maybe<
                Array<{ __typename?: "Service" } & Pick<Service, "_id">>
              >;
              options?: Maybe<
                Array<
                  { __typename?: "BookingQuestionDropdownOption" } & Pick<
                    BookingQuestionDropdownOption,
                    "optionId" | "value"
                  >
                >
              >;
              subquestions?: Maybe<
                Array<
                  { __typename?: "BookingQuestionSubquestion" } & Pick<
                    BookingQuestionSubquestion,
                    | "id"
                    | "type"
                    | "name"
                    | "required"
                    | "dropdownTriggers"
                    | "url"
                  > & {
                      options?: Maybe<
                        Array<
                          {
                            __typename?: "BookingQuestionDropdownOption";
                          } & Pick<
                            BookingQuestionDropdownOption,
                            "optionId" | "value"
                          >
                        >
                      >;
                    }
                >
              >;
            }
        >;
        micrositeColours: { __typename?: "MicrositeColours" } & Pick<
          MicrositeColours,
          "primary" | "secondary"
        >;
        brandConfig?: Maybe<
          { __typename?: "Brand" } & Pick<
            Brand,
            | "name"
            | "brandThemeMode"
            | "allowVisitorThemeOverride"
            | "logoUrl"
            | "bannerUrl"
            | "fontUrl"
            | "fontFamily"
            | "faviconUrl"
            | "pageTitleSuffix"
          > & {
              light?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
              dark?: Maybe<
                { __typename?: "BrandPalette" } & Pick<
                  BrandPalette,
                  | "primaryColor"
                  | "primaryActionColor"
                  | "primaryDarkColor"
                  | "primaryLightColor"
                  | "accentColor"
                  | "surfaceColor"
                  | "textColor"
                  | "pageBackground"
                  | "logoUrl"
                  | "bannerUrl"
                >
              >;
            }
        >;
        customContent?: Maybe<
          Array<
            { __typename?: "OrganisationCustomContent" } & Pick<
              OrganisationCustomContent,
              "language" | "marketingOptInLabel" | "privacyPolicy"
            >
          >
        >;
        services: { __typename?: "ServicePage" } & {
          edges: Array<
            { __typename?: "ServiceEdge" } & Pick<ServiceEdge, "cursor"> & {
                node: { __typename?: "Service" } & Pick<
                  Service,
                  | "_id"
                  | "name"
                  | "description"
                  | "image"
                  | "maxParticipantsPerBooking"
                  | "occupancy"
                  | "bookingVisibilityType"
                  | "bookingPaymentOption"
                  | "bookingDepositAmount"
                  | "isDiscountCodeAvailable"
                  | "numberOfResources"
                  | "resourceAllocationType"
                > & {
                    tiers?: Maybe<
                      Array<
                        { __typename?: "ServiceTier" } & Pick<
                          ServiceTier,
                          "_id" | "name" | "description" | "pricingType"
                        > & {
                            pricePoints: Array<
                              { __typename?: "ServiceTierPricePoint" } & Pick<
                                ServiceTierPricePoint,
                                | "_id"
                                | "name"
                                | "pricePerQuantity"
                                | "spacesPerQuantity"
                              >
                            >;
                          }
                      >
                    >;
                    durations: Array<
                      { __typename?: "ServiceDuration" } & Pick<
                        ServiceDuration,
                        "default" | "minutes" | "price" | "oldPrice"
                      >
                    >;
                    parts?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: "ServicePart" } & Pick<
                            ServicePart,
                            "label" | "type" | "duration" | "durationType"
                          >
                        >
                      >
                    >;
                    category: { __typename?: "Category" } & Pick<
                      Category,
                      "_id" | "name" | "order"
                    >;
                    organisation: { __typename?: "Organisation" } & Pick<
                      Organisation,
                      "_id"
                    >;
                  };
              }
          >;
          pageInfo: { __typename?: "ServicePageInfo" } & Pick<
            ServicePageInfo,
            | "hasNextPage"
            | "hasPreviousPage"
            | "total"
            | "startCursor"
            | "endCursor"
          >;
        };
      }
  >;
};

export type GetOrganisationPaymentQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  bookingReservations: Array<BookingReservation> | BookingReservation;
  discount?: Maybe<DiscountInput>;
  locale: Scalars["String"];
}>;

export type GetOrganisationPaymentQuery = { __typename?: "Query" } & {
  organisation?: Maybe<
    { __typename?: "Organisation" } & Pick<Organisation, "_id"> & {
        payment: { __typename?: "BookingPayment" } & Pick<
          BookingPayment,
          | "totalPrice"
          | "totalPriceInPence"
          | "paymentPrice"
          | "paymentPriceInPence"
          | "appliedDiscountValue"
          | "minChargeAdjustmentValue"
          | "isPaymentOptional"
        >;
      }
  >;
};

export type CreateBookingsForBookingToolMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput> | BookingInput;
  locale: Scalars["String"];
  createdSource: Scalars["String"];
}>;

export type CreateBookingsForBookingToolMutation = {
  __typename?: "Mutation";
} & {
  createBookingsForBookingTool: { __typename: "CreateBookingsResult" } & {
    bookings: Array<
      { __typename?: "BookingToolBookingResult" } & Pick<
        BookingToolBookingResult,
        "_id"
      >
    >;
  };
};

export type CreateBookingsWithUnpaidInvoiceMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput> | BookingInput;
  discount?: Maybe<BookingToolDiscountInput>;
  locale: Scalars["String"];
  createdSource: Scalars["String"];
}>;

export type CreateBookingsWithUnpaidInvoiceMutation = {
  __typename?: "Mutation";
} & {
  createBookingsWithUnpaidInvoice: { __typename: "CreateBookingsResult" } & {
    bookings: Array<
      { __typename?: "BookingToolBookingResult" } & Pick<
        BookingToolBookingResult,
        "_id"
      >
    >;
  };
};

export type GetCancelBookingDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCancelBookingDataQuery = { __typename?: "Query" } & {
  cancelBookingData: { __typename?: "CancelBookingData" } & Pick<
    CancelBookingData,
    | "bookingId"
    | "customerId"
    | "startTime"
    | "endTime"
    | "timezone"
    | "isRecurring"
    | "locale"
    | "alreadyCancelled"
  > & {
      organisation: { __typename?: "CancelBookingOrganisation" } & Pick<
        CancelBookingOrganisation,
        "_id" | "name" | "slug" | "cancellationNoticePeriod"
      > & {
          brandConfig?: Maybe<
            { __typename?: "Brand" } & Pick<
              Brand,
              | "name"
              | "brandThemeMode"
              | "allowVisitorThemeOverride"
              | "logoUrl"
              | "bannerUrl"
              | "fontUrl"
              | "fontFamily"
              | "faviconUrl"
              | "pageTitleSuffix"
            > & {
                light?: Maybe<
                  { __typename?: "BrandPalette" } & Pick<
                    BrandPalette,
                    | "primaryColor"
                    | "primaryActionColor"
                    | "primaryDarkColor"
                    | "primaryLightColor"
                    | "accentColor"
                    | "surfaceColor"
                    | "textColor"
                    | "pageBackground"
                    | "logoUrl"
                    | "bannerUrl"
                  >
                >;
                dark?: Maybe<
                  { __typename?: "BrandPalette" } & Pick<
                    BrandPalette,
                    | "primaryColor"
                    | "primaryActionColor"
                    | "primaryDarkColor"
                    | "primaryLightColor"
                    | "accentColor"
                    | "surfaceColor"
                    | "textColor"
                    | "pageBackground"
                    | "logoUrl"
                    | "bannerUrl"
                  >
                >;
              }
          >;
        };
      service: { __typename?: "CancelBookingService" } & Pick<
        CancelBookingService,
        "_id" | "name"
      >;
      resource?: Maybe<
        { __typename?: "CancelBookingResource" } & Pick<
          CancelBookingResource,
          "_id" | "name"
        >
      >;
    };
};

export type CancelBookingMutationVariables = Exact<{
  bookingId: Scalars["ObjectID"];
  customerId: Scalars["ObjectID"];
  recurringCascade?: Maybe<Scalars["Boolean"]>;
}>;

export type CancelBookingMutation = { __typename?: "Mutation" } & {
  cancelBooking: { __typename?: "CancelBookingResult" } & Pick<
    CancelBookingResult,
    "success"
  >;
};

export type GetOrganisationAvailabilityDatesQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  serviceId: Scalars["ObjectID"];
  resourceIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
  resourceGroupIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
  ranges: Array<AvailabilityRange> | AvailabilityRange;
  duration: Scalars["Int"];
  parts?: Maybe<Array<PartInput> | PartInput>;
  spaces: Scalars["Int"];
  timezone: Scalars["String"];
  meta: AvailabilityRequestMetaData;
  requestRangesIndividually?: Maybe<Scalars["Boolean"]>;
}>;

export type GetOrganisationAvailabilityDatesQuery = { __typename?: "Query" } & {
  organisation?: Maybe<
    { __typename?: "Organisation" } & Pick<Organisation, "_id"> & {
        availabilityDates: Array<
          { __typename?: "AvailableDate" } & Pick<AvailableDate, "date">
        >;
      }
  >;
};

export type GetOrganisationAvailabilityIntervalsQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  serviceId: Scalars["ObjectID"];
  resourceIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
  resourceGroupIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
  ranges: Array<AvailabilityRange> | AvailabilityRange;
  duration: Scalars["Int"];
  parts?: Maybe<Array<PartInput> | PartInput>;
  spaces: Scalars["Int"];
  timezone: Scalars["String"];
  meta: AvailabilityRequestMetaData;
  requestRangesIndividually?: Maybe<Scalars["Boolean"]>;
}>;

export type GetOrganisationAvailabilityIntervalsQuery = {
  __typename?: "Query";
} & {
  organisation?: Maybe<
    { __typename?: "Organisation" } & Pick<Organisation, "_id"> & {
        availabilityIntervals: Array<
          | ({ __typename: "AvailableInterval" } & Pick<
              AvailableInterval,
              "start" | "end" | "resourceIds" | "remainingSpaces"
            >)
          | ({ __typename: "GroupBookingInterval" } & Pick<
              GroupBookingInterval,
              "start" | "end" | "remainingSpaces"
            > & {
                booking: { __typename?: "Booking" } & Pick<
                  Booking,
                  "_id" | "start" | "end" | "price" | "remainingSpaces"
                > & {
                    recurring?: Maybe<
                      { __typename?: "Recurrence" } & Pick<
                        Recurrence,
                        | "id"
                        | "recurrenceType"
                        | "frequencyType"
                        | "frequency"
                        | "occurrences"
                        | "endDate"
                      > & {
                          bookings: Array<
                            { __typename?: "Booking" } & Pick<
                              Booking,
                              | "_id"
                              | "start"
                              | "end"
                              | "price"
                              | "remainingSpaces"
                            >
                          >;
                        }
                    >;
                  };
              })
        >;
      }
  >;
};

export type CreateReservationMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["String"]>;
  expiresAfter?: Maybe<Scalars["Int"]>;
  parts: Array<ReservationPartInput> | ReservationPartInput;
  requiredSpaces?: Maybe<Scalars["Int"]>;
  resourceId?: Maybe<Scalars["ObjectID"]>;
  resourceGroupId?: Maybe<Scalars["ObjectID"]>;
  serviceId: Scalars["ObjectID"];
  timeZone?: Maybe<Scalars["String"]>;
  source: Scalars["String"];
  intervalResourceIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
}>;

export type CreateReservationMutation = { __typename?: "Mutation" } & {
  createReservation: { __typename?: "CreateReservationResult" } & {
    reservation: { __typename?: "Reservation" } & Pick<Reservation, "start">;
    reservedSpace: { __typename?: "ReservedSpace" } & Pick<
      ReservedSpace,
      "_id"
    >;
  };
};

export type DeleteReservedSpaceMutationVariables = Exact<{
  organisationId: Scalars["ObjectID"];
  reservedSpaceId: Scalars["ObjectID"];
}>;

export type DeleteReservedSpaceMutation = { __typename?: "Mutation" } & Pick<
  Mutation,
  "deleteReservedSpace"
>;

export type CreateReservationRecurringBookingMutationVariables = Exact<{
  input: CreateReservationRecurringInput;
}>;

export type CreateReservationRecurringBookingMutation = {
  __typename?: "Mutation";
} & {
  createReservationForRecurringBooking: {
    __typename?: "CreateReservationResult";
  } & {
    reservation: { __typename?: "Reservation" } & Pick<Reservation, "start">;
    reservedSpace: { __typename?: "ReservedSpace" } & Pick<
      ReservedSpace,
      "_id"
    >;
  };
};

export type GetOrganisationsAvailabilityQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  range: AvailabilityRange;
  timezone?: Maybe<Scalars["String"]>;
  queryByOrganisationTimeZone?: Maybe<Scalars["Boolean"]>;
  organisationIds: Array<Scalars["ObjectID"]> | Scalars["ObjectID"];
  meta: AvailabilityRequestMetaData;
}>;

export type GetOrganisationsAvailabilityQuery = { __typename?: "Query" } & {
  bookingTool?: Maybe<
    { __typename?: "BookingTool" } & Pick<BookingTool, "_id" | "name"> & {
        organisationsAvailability: Array<
          { __typename?: "OrganisationIntervals" } & {
            organisation: { __typename?: "Organisation" } & Pick<
              Organisation,
              "_id" | "name" | "defaultTimeZone"
            >;
            intervals: Array<
              Maybe<
                | ({ __typename?: "AvailableInterval" } & Pick<
                    AvailableInterval,
                    "start" | "end" | "resourceIds"
                  >)
                | ({ __typename?: "GroupBookingInterval" } & Pick<
                    GroupBookingInterval,
                    "start" | "end" | "remainingSpaces"
                  > & {
                      booking: { __typename?: "Booking" } & Pick<
                        Booking,
                        "_id" | "start" | "end" | "price" | "remainingSpaces"
                      > & {
                          recurring?: Maybe<
                            { __typename?: "Recurrence" } & Pick<
                              Recurrence,
                              | "id"
                              | "recurrenceType"
                              | "frequencyType"
                              | "frequency"
                              | "occurrences"
                              | "endDate"
                            > & {
                                bookings: Array<
                                  { __typename?: "Booking" } & Pick<
                                    Booking,
                                    | "_id"
                                    | "start"
                                    | "end"
                                    | "price"
                                    | "remainingSpaces"
                                  >
                                >;
                              }
                          >;
                        };
                    })
              >
            >;
          }
        >;
      }
  >;
};

export type CreateAdyenSessionMutationVariables = Exact<{
  organisationId: Scalars["ObjectID"];
  value: Scalars["Float"];
  countryCode: Scalars["String"];
  locale: Scalars["String"];
  currency: Scalars["String"];
}>;

export type CreateAdyenSessionMutation = { __typename?: "Mutation" } & {
  createAdyenSession: { __typename?: "AdyenSession" } & Pick<
    AdyenSession,
    "paymentMethods" | "clientKey"
  >;
};

export type CreateBookingWithAdyenInvoiceMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput> | BookingInput;
  browserInfo?: Maybe<AdyenBrowserInfo>;
  createdSource: Scalars["String"];
  locale: Scalars["String"];
  origin: Scalars["String"];
  paymentAuthenticationData: AdyenAuthenticationData;
  paymentCurrency: Scalars["String"];
  paymentDiscount?: Maybe<BookingToolDiscountInput>;
  paymentMethodData?: Maybe<Scalars["String"]>;
  paymentInvoiceId?: Maybe<Scalars["ObjectID"]>;
  payment3DSResult?: Maybe<Scalars["String"]>;
  paymentValue: Scalars["Float"];
}>;

export type CreateBookingWithAdyenInvoiceMutation = {
  __typename?: "Mutation";
} & {
  createBookingsWithAdyenInvoice: {
    __typename?: "CreateBookingsWithAdyenResult";
  } & Pick<
    CreateBookingsWithAdyenResult,
    "action" | "invoiceId" | "resultCode"
  > & {
      bookings: Array<
        { __typename?: "BookingToolBookingResult" } & Pick<
          BookingToolBookingResult,
          "_id"
        >
      >;
    };
};

export type CalculateDiscountQueryVariables = Exact<{
  organisationId: Scalars["ObjectID"];
  code: Scalars["String"];
  servicePrices: Array<ServicePriceInput> | ServicePriceInput;
  email: Scalars["String"];
}>;

export type CalculateDiscountQuery = { __typename?: "Query" } & {
  discountCodeByCode?: Maybe<
    { __typename?: "DiscountCode" } & {
      calculatedDiscount:
        | ({ __typename?: "CalculatedDiscounts" } & {
            discounts: Array<
              { __typename?: "CalculatedDiscount" } & Pick<
                CalculatedDiscount,
                "servicePriceId" | "serviceId" | "discount" | "discountedPrice"
              >
            >;
          })
        | ({ __typename?: "NoDiscount" } & Pick<
            NoDiscount,
            "noDiscountReason"
          >);
    }
  >;
};

export type CreateBookingsWithSquareInvoiceMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput> | BookingInput;
  cardToken: Scalars["String"];
  squareBuyerVerificationToken: Scalars["String"];
  locale: Scalars["String"];
  createdSource: Scalars["String"];
  discount?: Maybe<BookingToolDiscountInput>;
}>;

export type CreateBookingsWithSquareInvoiceMutation = {
  __typename?: "Mutation";
} & {
  createBookingsWithSquareInvoice: { __typename: "CreateBookingsResult" } & {
    bookings: Array<
      { __typename?: "BookingToolBookingResult" } & Pick<
        BookingToolBookingResult,
        "_id"
      >
    >;
  };
};

export type CreateStripePaymentIntentMutationVariables = Exact<{
  input: CreateStripePaymentIntentInput;
}>;

export type CreateStripePaymentIntentMutation = { __typename?: "Mutation" } & {
  createStripePaymentIntent: { __typename?: "StripePaymentIntent" } & Pick<
    StripePaymentIntent,
    "clientSecret"
  >;
};

export type CreateBookingsWithStripeInvoiceMutationVariables = Exact<{
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  bookings: Array<BookingInput> | BookingInput;
  cardToken: Scalars["String"];
  locale: Scalars["String"];
  createdSource: Scalars["String"];
  discount?: Maybe<BookingToolDiscountInput>;
}>;

export type CreateBookingsWithStripeInvoiceMutation = {
  __typename?: "Mutation";
} & {
  createBookingsWithStripeInvoice: { __typename: "CreateBookingsResult" } & {
    bookings: Array<
      { __typename?: "BookingToolBookingResult" } & Pick<
        BookingToolBookingResult,
        "_id"
      >
    >;
  };
};

export type GetServiceResourcesForBookingToolQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  bookingToolId?: Maybe<Scalars["ObjectID"]>;
  resourceIds?: Maybe<Array<Scalars["ObjectID"]> | Scalars["ObjectID"]>;
  cursor?: Maybe<Scalars["ObjectID"]>;
}>;

export type GetServiceResourcesForBookingToolQuery = {
  __typename?: "Query";
} & {
  service?: Maybe<
    { __typename?: "Service" } & {
      resourcesForBookingTool: { __typename?: "ResourcePage" } & {
        edges: Array<
          { __typename?: "ResourceEdge" } & Pick<ResourceEdge, "cursor"> & {
              node: { __typename?: "Resource" } & Pick<
                Resource,
                "_id" | "name" | "profilePhotoUrl" | "description"
              > & {
                  groups: { __typename?: "ResourceGroupPage" } & {
                    edges: Array<
                      { __typename?: "ResourceGroupEdge" } & Pick<
                        ResourceGroupEdge,
                        "cursor"
                      > & {
                          node: { __typename?: "ResourceGroup" } & Pick<
                            ResourceGroup,
                            "_id" | "name"
                          >;
                        }
                    >;
                    pageInfo: { __typename?: "ResourceGroupPageInfo" } & Pick<
                      ResourceGroupPageInfo,
                      | "hasNextPage"
                      | "hasPreviousPage"
                      | "total"
                      | "startCursor"
                      | "endCursor"
                    >;
                  };
                };
            }
        >;
        pageInfo: { __typename?: "ResourcePageInfo" } & Pick<
          ResourcePageInfo,
          | "hasNextPage"
          | "hasPreviousPage"
          | "total"
          | "startCursor"
          | "endCursor"
        >;
      };
    }
  >;
};

export type GetServiceResourcesQueryVariables = Exact<{
  id: Scalars["ObjectID"];
  cursor?: Maybe<Scalars["ObjectID"]>;
}>;

export type GetServiceResourcesQuery = { __typename?: "Query" } & {
  service?: Maybe<
    { __typename?: "Service" } & {
      resources?: Maybe<
        { __typename?: "ResourcePage" } & {
          edges: Array<
            { __typename?: "ResourceEdge" } & Pick<ResourceEdge, "cursor"> & {
                node: { __typename?: "Resource" } & Pick<
                  Resource,
                  "_id" | "name" | "profilePhotoUrl" | "description"
                > & {
                    groups: { __typename?: "ResourceGroupPage" } & {
                      edges: Array<
                        { __typename?: "ResourceGroupEdge" } & Pick<
                          ResourceGroupEdge,
                          "cursor"
                        > & {
                            node: { __typename?: "ResourceGroup" } & Pick<
                              ResourceGroup,
                              "_id" | "name"
                            >;
                          }
                      >;
                      pageInfo: { __typename?: "ResourceGroupPageInfo" } & Pick<
                        ResourceGroupPageInfo,
                        | "hasNextPage"
                        | "hasPreviousPage"
                        | "total"
                        | "startCursor"
                        | "endCursor"
                      >;
                    };
                  };
              }
          >;
          pageInfo: { __typename?: "ResourcePageInfo" } & Pick<
            ResourcePageInfo,
            | "hasNextPage"
            | "hasPreviousPage"
            | "total"
            | "startCursor"
            | "endCursor"
          >;
        }
      >;
    }
  >;
};

export type CreatePostDataMutationVariables = Exact<{
  input: CreateParticipantUploadPresignedUrlInput;
}>;

export type CreatePostDataMutation = { __typename?: "Mutation" } & Pick<
  Mutation,
  "createParticipantUploadPresignedUrl"
>;

export const GetBookingToolDataDocument = gql`
  query GetBookingToolData(
    $id: ObjectID!
    $serviceFilters: ServiceFilters
    $serviceCursor: ObjectID
    $organisationCursor: ObjectID
  ) {
    bookingTool(id: $id) {
      name
      _id
      forcePhoneValidationToCountry
      forceServiceSelection
      resourceSelectionMode
      forceOrganisationSelection
      percentageThresholdForShowingRemainingNumberOfSpaces
      services(
        first: 500
        after: $serviceCursor
        order: ASCENDING
        filters: $serviceFilters
        sortBy: ORDER
      ) {
        edges {
          node {
            _id
            name
            description
            image
            tiers {
              _id
              name
              description
              pricingType
              pricePoints {
                _id
                name
                pricePerQuantity
                spacesPerQuantity
              }
            }
            durations {
              default
              minutes
              price
              oldPrice
              POA
            }
            parts {
              label
              type
              duration
              durationType
            }
            organisation {
              _id
            }
            category {
              _id
              name
              order
            }
            maxParticipantsPerBooking
            occupancy
            bookingVisibilityType
            bookingPaymentOption
            bookingDepositAmount
            isDiscountCodeAvailable
            availabilityDisplayMode
            numberOfResources
            resourceAllocationType
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
      organisations(
        first: 300
        after: $organisationCursor
        order: ASCENDING
        sortBy: NATURAL
      ) {
        edges {
          node {
            _id
            defaultTimeZone
            name
            slug
            location {
              address
              latitude
              longitude
            }
            bookingNoticePeriod
            currency
            adyenIntegrationToken {
              _id
              adyenCheckoutBaseUrl
              cardHolderNameRequired
            }
            stripeIntegration {
              accountId
            }
            squareIntegration {
              locationId
            }
            externalCrmFields {
              id
              name
              type
              required
            }
            externalBookingQuestions {
              id
              type
              name
              required
              services {
                _id
              }
              options {
                optionId
                value
              }
              url
              subquestions {
                id
                type
                name
                required
                dropdownTriggers
                options {
                  optionId
                  value
                }
                url
              }
            }
            micrositeColours {
              primary
              secondary
            }
            allowBookingNotes
            allowResourceGroupSelection
            allowResourceImageDisplay
            allowResourceSelection
            allowSelectAnyResource
            areConfirmationEmailsEnabled
            areInvoiceEmailsEnabled
            forceTimezone
            isPhoneNumberRequiredForBookings
            reservationExpiryMinutes
            resourceSelectionBeforeAvailability
            serviceNotBookableAction
            showPricesOnBookingTools
            bookingConfirmationMessage
            businessPhone
            communicationFromEmail
            customBookingNotesText
            customNoAvailabilityText
            privacyPolicyUrl
            marketingEnabled
            marketingOptInLabel
            enableMarketingOptIn
            enabledFeatureFlags
            customContent {
              language
              marketingOptInLabel
              privacyPolicy
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
      mapkitAuthenticationToken
      locationSelection {
        searchAndMapEnabled
        includedCountries
        maxLocationSearchRange
        minLocationsToDisplay
        maxLocationsToDisplay
        overrideLocationSearchQueryMapping {
          to
          from
        }
      }
      unitOfMeasurement
      customColours {
        primary
        secondary
        logoUrl
        primaryActionColour
        primaryDarkColour
        primaryLightColour
        accentColour
        theme
        fontUrl
        fontFamily
        pageBackground
      }
      brand {
        name
        light {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        dark {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        brandThemeMode
        allowVisitorThemeOverride
        logoUrl
        bannerUrl
        fontUrl
        fontFamily
        faviconUrl
        pageTitleSuffix
      }
      fonts {
        regular
        bold
      }
      hideAppointeddFooter
      organisationAvailabilityFlow
    }
  }
`;

/**
 * __useGetBookingToolDataQuery__
 *
 * To run a query within a React component, call `useGetBookingToolDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingToolDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingToolDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      serviceFilters: // value for 'serviceFilters'
 *      serviceCursor: // value for 'serviceCursor'
 *      organisationCursor: // value for 'organisationCursor'
 *   },
 * });
 */
export function useGetBookingToolDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBookingToolDataQuery,
    GetBookingToolDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingToolDataQuery,
    GetBookingToolDataQueryVariables
  >(GetBookingToolDataDocument, options);
}
export function useGetBookingToolDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingToolDataQuery,
    GetBookingToolDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingToolDataQuery,
    GetBookingToolDataQueryVariables
  >(GetBookingToolDataDocument, options);
}
export type GetBookingToolDataQueryHookResult = ReturnType<
  typeof useGetBookingToolDataQuery
>;
export type GetBookingToolDataLazyQueryHookResult = ReturnType<
  typeof useGetBookingToolDataLazyQuery
>;
export type GetBookingToolDataQueryResult = Apollo.QueryResult<
  GetBookingToolDataQuery,
  GetBookingToolDataQueryVariables
>;
export const GetBookingToolSettingsDocument = gql`
  query GetBookingToolSettings($id: ObjectID!) {
    bookingTool(id: $id) {
      name
      _id
      forcePhoneValidationToCountry
      forceServiceSelection
      resourceSelectionMode
      forceOrganisationSelection
      percentageThresholdForShowingRemainingNumberOfSpaces
      mapkitAuthenticationToken
      locationSelection {
        searchAndMapEnabled
        includedCountries
        maxLocationSearchRange
        minLocationsToDisplay
        maxLocationsToDisplay
        overrideLocationSearchQueryMapping {
          to
          from
        }
      }
      unitOfMeasurement
      customColours {
        primary
        secondary
        logoUrl
        primaryActionColour
        primaryDarkColour
        primaryLightColour
        accentColour
        theme
        fontUrl
        fontFamily
        pageBackground
      }
      brand {
        name
        light {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        dark {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        brandThemeMode
        allowVisitorThemeOverride
        logoUrl
        bannerUrl
        fontUrl
        fontFamily
        faviconUrl
        pageTitleSuffix
      }
      fonts {
        regular
        bold
      }
      hideAppointeddFooter
      organisationAvailabilityFlow
    }
  }
`;

/**
 * __useGetBookingToolSettingsQuery__
 *
 * To run a query within a React component, call `useGetBookingToolSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingToolSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingToolSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingToolSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBookingToolSettingsQuery,
    GetBookingToolSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingToolSettingsQuery,
    GetBookingToolSettingsQueryVariables
  >(GetBookingToolSettingsDocument, options);
}
export function useGetBookingToolSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingToolSettingsQuery,
    GetBookingToolSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingToolSettingsQuery,
    GetBookingToolSettingsQueryVariables
  >(GetBookingToolSettingsDocument, options);
}
export type GetBookingToolSettingsQueryHookResult = ReturnType<
  typeof useGetBookingToolSettingsQuery
>;
export type GetBookingToolSettingsLazyQueryHookResult = ReturnType<
  typeof useGetBookingToolSettingsLazyQuery
>;
export type GetBookingToolSettingsQueryResult = Apollo.QueryResult<
  GetBookingToolSettingsQuery,
  GetBookingToolSettingsQueryVariables
>;
export const GetBookingToolScopedServicesDocument = gql`
  query GetBookingToolScopedServices(
    $id: ObjectID!
    $serviceCursor: ObjectID
    $serviceFilters: ServiceFilters
  ) {
    bookingTool(id: $id) {
      services(
        first: 500
        after: $serviceCursor
        order: ASCENDING
        filters: $serviceFilters
        sortBy: ORDER
      ) {
        edges {
          node {
            _id
            name
            description
            image
            tiers {
              _id
              name
              description
              pricingType
              pricePoints {
                _id
                name
                pricePerQuantity
                spacesPerQuantity
              }
            }
            durations {
              default
              minutes
              price
              oldPrice
              POA
            }
            parts {
              label
              type
              duration
              durationType
            }
            organisation {
              _id
            }
            category {
              _id
              name
              order
            }
            maxParticipantsPerBooking
            occupancy
            bookingVisibilityType
            bookingPaymentOption
            bookingDepositAmount
            isDiscountCodeAvailable
            availabilityDisplayMode
            numberOfResources
            resourceAllocationType
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
    }
  }
`;

/**
 * __useGetBookingToolScopedServicesQuery__
 *
 * To run a query within a React component, call `useGetBookingToolScopedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingToolScopedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingToolScopedServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      serviceCursor: // value for 'serviceCursor'
 *      serviceFilters: // value for 'serviceFilters'
 *   },
 * });
 */
export function useGetBookingToolScopedServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBookingToolScopedServicesQuery,
    GetBookingToolScopedServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBookingToolScopedServicesQuery,
    GetBookingToolScopedServicesQueryVariables
  >(GetBookingToolScopedServicesDocument, options);
}
export function useGetBookingToolScopedServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingToolScopedServicesQuery,
    GetBookingToolScopedServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBookingToolScopedServicesQuery,
    GetBookingToolScopedServicesQueryVariables
  >(GetBookingToolScopedServicesDocument, options);
}
export type GetBookingToolScopedServicesQueryHookResult = ReturnType<
  typeof useGetBookingToolScopedServicesQuery
>;
export type GetBookingToolScopedServicesLazyQueryHookResult = ReturnType<
  typeof useGetBookingToolScopedServicesLazyQuery
>;
export type GetBookingToolScopedServicesQueryResult = Apollo.QueryResult<
  GetBookingToolScopedServicesQuery,
  GetBookingToolScopedServicesQueryVariables
>;
export const GetOrganisationDetailsDocument = gql`
  query GetOrganisationDetails($id: ObjectID!) {
    organisation(id: $id) {
      _id
      defaultTimeZone
      name
      slug
      location {
        address
        latitude
        longitude
      }
      bookingNoticePeriod
      currency
      adyenIntegrationToken {
        _id
        adyenCheckoutBaseUrl
        cardHolderNameRequired
      }
      stripeIntegration {
        accountId
      }
      squareIntegration {
        locationId
      }
      externalCrmFields {
        id
        name
        type
        required
      }
      externalBookingQuestions {
        id
        type
        name
        required
        services {
          _id
        }
        options {
          optionId
          value
        }
        url
        subquestions {
          id
          type
          name
          required
          dropdownTriggers
          options {
            optionId
            value
          }
          url
        }
      }
      micrositeColours {
        primary
        secondary
      }
      brandConfig {
        name
        light {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        dark {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        brandThemeMode
        allowVisitorThemeOverride
        logoUrl
        bannerUrl
        fontUrl
        fontFamily
        faviconUrl
        pageTitleSuffix
      }
      allowBookingNotes
      allowResourceGroupSelection
      allowResourceImageDisplay
      allowResourceSelection
      allowSelectAnyResource
      areConfirmationEmailsEnabled
      areInvoiceEmailsEnabled
      forceTimezone
      isPhoneNumberRequiredForBookings
      reservationExpiryMinutes
      resourceSelectionBeforeAvailability
      serviceNotBookableAction
      showPricesOnBookingTools
      bookingConfirmationMessage
      businessPhone
      communicationFromEmail
      customBookingNotesText
      customNoAvailabilityText
      privacyPolicyUrl
      customContent {
        language
        marketingOptInLabel
        privacyPolicy
      }
      enabledFeatureFlags
      marketingEnabled
      marketingOptInLabel
      enableMarketingOptIn
      hideAppointeddFooter
    }
  }
`;

/**
 * __useGetOrganisationDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationDetailsQuery,
    GetOrganisationDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganisationDetailsQuery,
    GetOrganisationDetailsQueryVariables
  >(GetOrganisationDetailsDocument, options);
}
export function useGetOrganisationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationDetailsQuery,
    GetOrganisationDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationDetailsQuery,
    GetOrganisationDetailsQueryVariables
  >(GetOrganisationDetailsDocument, options);
}
export type GetOrganisationDetailsQueryHookResult = ReturnType<
  typeof useGetOrganisationDetailsQuery
>;
export type GetOrganisationDetailsLazyQueryHookResult = ReturnType<
  typeof useGetOrganisationDetailsLazyQuery
>;
export type GetOrganisationDetailsQueryResult = Apollo.QueryResult<
  GetOrganisationDetailsQuery,
  GetOrganisationDetailsQueryVariables
>;
export const GetOrganisationDocument = gql`
  query GetOrganisation(
    $id: ObjectID!
    $serviceCursor: ObjectID
    $serviceFilters: ServiceFilters
  ) {
    organisation(id: $id) {
      _id
      defaultTimeZone
      name
      slug
      location {
        address
        latitude
        longitude
      }
      bookingNoticePeriod
      currency
      adyenIntegrationToken {
        _id
        adyenCheckoutBaseUrl
        cardHolderNameRequired
      }
      stripeIntegration {
        accountId
      }
      squareIntegration {
        locationId
      }
      externalCrmFields {
        id
        name
        type
        required
      }
      externalBookingQuestions {
        id
        type
        name
        required
        services {
          _id
        }
        options {
          optionId
          value
        }
        url
        subquestions {
          id
          type
          name
          required
          dropdownTriggers
          options {
            optionId
            value
          }
          url
        }
      }
      micrositeColours {
        primary
        secondary
      }
      brandConfig {
        name
        light {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        dark {
          primaryColor
          primaryActionColor
          primaryDarkColor
          primaryLightColor
          accentColor
          surfaceColor
          textColor
          pageBackground
          logoUrl
          bannerUrl
        }
        brandThemeMode
        allowVisitorThemeOverride
        logoUrl
        bannerUrl
        fontUrl
        fontFamily
        faviconUrl
        pageTitleSuffix
      }
      allowBookingNotes
      allowResourceGroupSelection
      allowResourceImageDisplay
      allowResourceSelection
      allowSelectAnyResource
      areConfirmationEmailsEnabled
      areInvoiceEmailsEnabled
      forceTimezone
      isPhoneNumberRequiredForBookings
      reservationExpiryMinutes
      resourceSelectionBeforeAvailability
      serviceNotBookableAction
      showPricesOnBookingTools
      bookingConfirmationMessage
      businessPhone
      communicationFromEmail
      customBookingNotesText
      customNoAvailabilityText
      privacyPolicyUrl
      customContent {
        language
        marketingOptInLabel
        privacyPolicy
      }
      services(
        first: 100
        after: $serviceCursor
        order: ASCENDING
        filters: $serviceFilters
        sortBy: ORDER
      ) {
        edges {
          node {
            _id
            name
            description
            image
            tiers {
              _id
              name
              description
              pricingType
              pricePoints {
                _id
                name
                pricePerQuantity
                spacesPerQuantity
              }
            }
            durations {
              default
              minutes
              price
              oldPrice
            }
            parts {
              label
              type
              duration
              durationType
            }
            category {
              _id
              name
              order
            }
            maxParticipantsPerBooking
            occupancy
            bookingVisibilityType
            bookingPaymentOption
            bookingDepositAmount
            isDiscountCodeAvailable
            organisation {
              _id
            }
            numberOfResources
            resourceAllocationType
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
      enabledFeatureFlags
      marketingEnabled
      marketingOptInLabel
      enableMarketingOptIn
      hideAppointeddFooter
    }
  }
`;

/**
 * __useGetOrganisationQuery__
 *
 * To run a query within a React component, call `useGetOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      serviceCursor: // value for 'serviceCursor'
 *      serviceFilters: // value for 'serviceFilters'
 *   },
 * });
 */
export function useGetOrganisationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationQuery,
    GetOrganisationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(
    GetOrganisationDocument,
    options,
  );
}
export function useGetOrganisationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationQuery,
    GetOrganisationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationQuery,
    GetOrganisationQueryVariables
  >(GetOrganisationDocument, options);
}
export type GetOrganisationQueryHookResult = ReturnType<
  typeof useGetOrganisationQuery
>;
export type GetOrganisationLazyQueryHookResult = ReturnType<
  typeof useGetOrganisationLazyQuery
>;
export type GetOrganisationQueryResult = Apollo.QueryResult<
  GetOrganisationQuery,
  GetOrganisationQueryVariables
>;
export const GetOrganisationPaymentDocument = gql`
  query GetOrganisationPayment(
    $id: ObjectID!
    $bookingReservations: [BookingReservation!]!
    $discount: DiscountInput
    $locale: String!
  ) {
    organisation(id: $id) {
      _id
      payment(
        bookingReservations: $bookingReservations
        discount: $discount
        locale: $locale
      ) {
        totalPrice
        totalPriceInPence
        paymentPrice
        paymentPriceInPence
        appliedDiscountValue
        minChargeAdjustmentValue
        isPaymentOptional
      }
    }
  }
`;

/**
 * __useGetOrganisationPaymentQuery__
 *
 * To run a query within a React component, call `useGetOrganisationPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bookingReservations: // value for 'bookingReservations'
 *      discount: // value for 'discount'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetOrganisationPaymentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationPaymentQuery,
    GetOrganisationPaymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganisationPaymentQuery,
    GetOrganisationPaymentQueryVariables
  >(GetOrganisationPaymentDocument, options);
}
export function useGetOrganisationPaymentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationPaymentQuery,
    GetOrganisationPaymentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationPaymentQuery,
    GetOrganisationPaymentQueryVariables
  >(GetOrganisationPaymentDocument, options);
}
export type GetOrganisationPaymentQueryHookResult = ReturnType<
  typeof useGetOrganisationPaymentQuery
>;
export type GetOrganisationPaymentLazyQueryHookResult = ReturnType<
  typeof useGetOrganisationPaymentLazyQuery
>;
export type GetOrganisationPaymentQueryResult = Apollo.QueryResult<
  GetOrganisationPaymentQuery,
  GetOrganisationPaymentQueryVariables
>;
export const CreateBookingsForBookingToolDocument = gql`
  mutation createBookingsForBookingTool(
    $bookingToolId: ObjectID
    $bookings: [BookingInput!]!
    $locale: String!
    $createdSource: String!
  ) {
    createBookingsForBookingTool(
      bookingToolId: $bookingToolId
      bookings: $bookings
      locale: $locale
      createdSource: $createdSource
    ) {
      __typename
      bookings {
        _id
      }
    }
  }
`;
export type CreateBookingsForBookingToolMutationFn = Apollo.MutationFunction<
  CreateBookingsForBookingToolMutation,
  CreateBookingsForBookingToolMutationVariables
>;

/**
 * __useCreateBookingsForBookingToolMutation__
 *
 * To run a mutation, you first call `useCreateBookingsForBookingToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingsForBookingToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingsForBookingToolMutation, { data, loading, error }] = useCreateBookingsForBookingToolMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      bookings: // value for 'bookings'
 *      locale: // value for 'locale'
 *      createdSource: // value for 'createdSource'
 *   },
 * });
 */
export function useCreateBookingsForBookingToolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingsForBookingToolMutation,
    CreateBookingsForBookingToolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingsForBookingToolMutation,
    CreateBookingsForBookingToolMutationVariables
  >(CreateBookingsForBookingToolDocument, options);
}
export type CreateBookingsForBookingToolMutationHookResult = ReturnType<
  typeof useCreateBookingsForBookingToolMutation
>;
export type CreateBookingsForBookingToolMutationResult =
  Apollo.MutationResult<CreateBookingsForBookingToolMutation>;
export type CreateBookingsForBookingToolMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingsForBookingToolMutation,
    CreateBookingsForBookingToolMutationVariables
  >;
export const CreateBookingsWithUnpaidInvoiceDocument = gql`
  mutation createBookingsWithUnpaidInvoice(
    $bookingToolId: ObjectID
    $bookings: [BookingInput!]!
    $discount: BookingToolDiscountInput
    $locale: String!
    $createdSource: String!
  ) {
    createBookingsWithUnpaidInvoice(
      bookingToolId: $bookingToolId
      bookings: $bookings
      discount: $discount
      locale: $locale
      createdSource: $createdSource
    ) {
      __typename
      bookings {
        _id
      }
    }
  }
`;
export type CreateBookingsWithUnpaidInvoiceMutationFn = Apollo.MutationFunction<
  CreateBookingsWithUnpaidInvoiceMutation,
  CreateBookingsWithUnpaidInvoiceMutationVariables
>;

/**
 * __useCreateBookingsWithUnpaidInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateBookingsWithUnpaidInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingsWithUnpaidInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingsWithUnpaidInvoiceMutation, { data, loading, error }] = useCreateBookingsWithUnpaidInvoiceMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      bookings: // value for 'bookings'
 *      discount: // value for 'discount'
 *      locale: // value for 'locale'
 *      createdSource: // value for 'createdSource'
 *   },
 * });
 */
export function useCreateBookingsWithUnpaidInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingsWithUnpaidInvoiceMutation,
    CreateBookingsWithUnpaidInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingsWithUnpaidInvoiceMutation,
    CreateBookingsWithUnpaidInvoiceMutationVariables
  >(CreateBookingsWithUnpaidInvoiceDocument, options);
}
export type CreateBookingsWithUnpaidInvoiceMutationHookResult = ReturnType<
  typeof useCreateBookingsWithUnpaidInvoiceMutation
>;
export type CreateBookingsWithUnpaidInvoiceMutationResult =
  Apollo.MutationResult<CreateBookingsWithUnpaidInvoiceMutation>;
export type CreateBookingsWithUnpaidInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingsWithUnpaidInvoiceMutation,
    CreateBookingsWithUnpaidInvoiceMutationVariables
  >;
export const GetCancelBookingDataDocument = gql`
  query GetCancelBookingData {
    cancelBookingData {
      bookingId
      customerId
      startTime
      endTime
      timezone
      isRecurring
      locale
      alreadyCancelled
      organisation {
        _id
        name
        slug
        cancellationNoticePeriod
        brandConfig {
          name
          light {
            primaryColor
            primaryActionColor
            primaryDarkColor
            primaryLightColor
            accentColor
            surfaceColor
            textColor
            pageBackground
            logoUrl
            bannerUrl
          }
          dark {
            primaryColor
            primaryActionColor
            primaryDarkColor
            primaryLightColor
            accentColor
            surfaceColor
            textColor
            pageBackground
            logoUrl
            bannerUrl
          }
          brandThemeMode
          allowVisitorThemeOverride
          logoUrl
          bannerUrl
          fontUrl
          fontFamily
          faviconUrl
          pageTitleSuffix
        }
      }
      service {
        _id
        name
      }
      resource {
        _id
        name
      }
    }
  }
`;

/**
 * __useGetCancelBookingDataQuery__
 *
 * To run a query within a React component, call `useGetCancelBookingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelBookingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelBookingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCancelBookingDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCancelBookingDataQuery,
    GetCancelBookingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCancelBookingDataQuery,
    GetCancelBookingDataQueryVariables
  >(GetCancelBookingDataDocument, options);
}
export function useGetCancelBookingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCancelBookingDataQuery,
    GetCancelBookingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCancelBookingDataQuery,
    GetCancelBookingDataQueryVariables
  >(GetCancelBookingDataDocument, options);
}
export type GetCancelBookingDataQueryHookResult = ReturnType<
  typeof useGetCancelBookingDataQuery
>;
export type GetCancelBookingDataLazyQueryHookResult = ReturnType<
  typeof useGetCancelBookingDataLazyQuery
>;
export type GetCancelBookingDataQueryResult = Apollo.QueryResult<
  GetCancelBookingDataQuery,
  GetCancelBookingDataQueryVariables
>;
export const CancelBookingDocument = gql`
  mutation CancelBooking(
    $bookingId: ObjectID!
    $customerId: ObjectID!
    $recurringCascade: Boolean
  ) {
    cancelBooking(
      bookingId: $bookingId
      customerId: $customerId
      recurringCascade: $recurringCascade
    ) {
      success
    }
  }
`;
export type CancelBookingMutationFn = Apollo.MutationFunction<
  CancelBookingMutation,
  CancelBookingMutationVariables
>;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      customerId: // value for 'customerId'
 *      recurringCascade: // value for 'recurringCascade'
 *   },
 * });
 */
export function useCancelBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelBookingMutation,
    CancelBookingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelBookingMutation,
    CancelBookingMutationVariables
  >(CancelBookingDocument, options);
}
export type CancelBookingMutationHookResult = ReturnType<
  typeof useCancelBookingMutation
>;
export type CancelBookingMutationResult =
  Apollo.MutationResult<CancelBookingMutation>;
export type CancelBookingMutationOptions = Apollo.BaseMutationOptions<
  CancelBookingMutation,
  CancelBookingMutationVariables
>;
export const GetOrganisationAvailabilityDatesDocument = gql`
  query GetOrganisationAvailabilityDates(
    $id: ObjectID!
    $bookingToolId: ObjectID
    $serviceId: ObjectID!
    $resourceIds: [ObjectID!]
    $resourceGroupIds: [ObjectID!]
    $ranges: [AvailabilityRange!]!
    $duration: Int!
    $parts: [PartInput!]
    $spaces: Int!
    $timezone: String!
    $meta: AvailabilityRequestMetaData!
    $requestRangesIndividually: Boolean
  ) {
    organisation(id: $id) {
      _id
      availabilityDates(
        bookingToolId: $bookingToolId
        ranges: $ranges
        duration: $duration
        parts: $parts
        serviceId: $serviceId
        resourceIds: $resourceIds
        resourceGroupIds: $resourceGroupIds
        spaces: $spaces
        timezone: $timezone
        meta: $meta
        requestRangesIndividually: $requestRangesIndividually
      ) {
        date
      }
    }
  }
`;

/**
 * __useGetOrganisationAvailabilityDatesQuery__
 *
 * To run a query within a React component, call `useGetOrganisationAvailabilityDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationAvailabilityDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationAvailabilityDatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bookingToolId: // value for 'bookingToolId'
 *      serviceId: // value for 'serviceId'
 *      resourceIds: // value for 'resourceIds'
 *      resourceGroupIds: // value for 'resourceGroupIds'
 *      ranges: // value for 'ranges'
 *      duration: // value for 'duration'
 *      parts: // value for 'parts'
 *      spaces: // value for 'spaces'
 *      timezone: // value for 'timezone'
 *      meta: // value for 'meta'
 *      requestRangesIndividually: // value for 'requestRangesIndividually'
 *   },
 * });
 */
export function useGetOrganisationAvailabilityDatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationAvailabilityDatesQuery,
    GetOrganisationAvailabilityDatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganisationAvailabilityDatesQuery,
    GetOrganisationAvailabilityDatesQueryVariables
  >(GetOrganisationAvailabilityDatesDocument, options);
}
export function useGetOrganisationAvailabilityDatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationAvailabilityDatesQuery,
    GetOrganisationAvailabilityDatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationAvailabilityDatesQuery,
    GetOrganisationAvailabilityDatesQueryVariables
  >(GetOrganisationAvailabilityDatesDocument, options);
}
export type GetOrganisationAvailabilityDatesQueryHookResult = ReturnType<
  typeof useGetOrganisationAvailabilityDatesQuery
>;
export type GetOrganisationAvailabilityDatesLazyQueryHookResult = ReturnType<
  typeof useGetOrganisationAvailabilityDatesLazyQuery
>;
export type GetOrganisationAvailabilityDatesQueryResult = Apollo.QueryResult<
  GetOrganisationAvailabilityDatesQuery,
  GetOrganisationAvailabilityDatesQueryVariables
>;
export const GetOrganisationAvailabilityIntervalsDocument = gql`
  query GetOrganisationAvailabilityIntervals(
    $id: ObjectID!
    $bookingToolId: ObjectID
    $serviceId: ObjectID!
    $resourceIds: [ObjectID!]
    $resourceGroupIds: [ObjectID!]
    $ranges: [AvailabilityRange!]!
    $duration: Int!
    $parts: [PartInput!]
    $spaces: Int!
    $timezone: String!
    $meta: AvailabilityRequestMetaData!
    $requestRangesIndividually: Boolean
  ) {
    organisation(id: $id) {
      _id
      availabilityIntervals(
        bookingToolId: $bookingToolId
        ranges: $ranges
        duration: $duration
        parts: $parts
        serviceId: $serviceId
        resourceIds: $resourceIds
        resourceGroupIds: $resourceGroupIds
        spaces: $spaces
        timezone: $timezone
        meta: $meta
        requestRangesIndividually: $requestRangesIndividually
      ) {
        __typename
        ... on AvailableInterval {
          start
          end
          resourceIds
          remainingSpaces
        }
        ... on GroupBookingInterval {
          start
          end
          remainingSpaces
          booking {
            _id
            start
            end
            price
            remainingSpaces
            recurring {
              id
              recurrenceType
              bookings {
                _id
                start
                end
                price
                remainingSpaces
              }
              frequencyType
              frequency
              occurrences
              endDate
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganisationAvailabilityIntervalsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationAvailabilityIntervalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationAvailabilityIntervalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationAvailabilityIntervalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bookingToolId: // value for 'bookingToolId'
 *      serviceId: // value for 'serviceId'
 *      resourceIds: // value for 'resourceIds'
 *      resourceGroupIds: // value for 'resourceGroupIds'
 *      ranges: // value for 'ranges'
 *      duration: // value for 'duration'
 *      parts: // value for 'parts'
 *      spaces: // value for 'spaces'
 *      timezone: // value for 'timezone'
 *      meta: // value for 'meta'
 *      requestRangesIndividually: // value for 'requestRangesIndividually'
 *   },
 * });
 */
export function useGetOrganisationAvailabilityIntervalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationAvailabilityIntervalsQuery,
    GetOrganisationAvailabilityIntervalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganisationAvailabilityIntervalsQuery,
    GetOrganisationAvailabilityIntervalsQueryVariables
  >(GetOrganisationAvailabilityIntervalsDocument, options);
}
export function useGetOrganisationAvailabilityIntervalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationAvailabilityIntervalsQuery,
    GetOrganisationAvailabilityIntervalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationAvailabilityIntervalsQuery,
    GetOrganisationAvailabilityIntervalsQueryVariables
  >(GetOrganisationAvailabilityIntervalsDocument, options);
}
export type GetOrganisationAvailabilityIntervalsQueryHookResult = ReturnType<
  typeof useGetOrganisationAvailabilityIntervalsQuery
>;
export type GetOrganisationAvailabilityIntervalsLazyQueryHookResult =
  ReturnType<typeof useGetOrganisationAvailabilityIntervalsLazyQuery>;
export type GetOrganisationAvailabilityIntervalsQueryResult =
  Apollo.QueryResult<
    GetOrganisationAvailabilityIntervalsQuery,
    GetOrganisationAvailabilityIntervalsQueryVariables
  >;
export const CreateReservationDocument = gql`
  mutation CreateReservation(
    $bookingToolId: String
    $expiresAfter: Int
    $parts: [ReservationPartInput!]!
    $requiredSpaces: Int
    $resourceId: ObjectID
    $resourceGroupId: ObjectID
    $serviceId: ObjectID!
    $timeZone: String
    $source: String!
    $intervalResourceIds: [ObjectID!]
  ) {
    createReservation(
      bookingToolId: $bookingToolId
      expiresAfter: $expiresAfter
      parts: $parts
      requiredSpaces: $requiredSpaces
      resourceId: $resourceId
      resourceGroupId: $resourceGroupId
      serviceId: $serviceId
      timeZone: $timeZone
      source: $source
      intervalResourceIds: $intervalResourceIds
    ) {
      reservation {
        start
      }
      reservedSpace {
        _id
      }
    }
  }
`;
export type CreateReservationMutationFn = Apollo.MutationFunction<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      expiresAfter: // value for 'expiresAfter'
 *      parts: // value for 'parts'
 *      requiredSpaces: // value for 'requiredSpaces'
 *      resourceId: // value for 'resourceId'
 *      resourceGroupId: // value for 'resourceGroupId'
 *      serviceId: // value for 'serviceId'
 *      timeZone: // value for 'timeZone'
 *      source: // value for 'source'
 *      intervalResourceIds: // value for 'intervalResourceIds'
 *   },
 * });
 */
export function useCreateReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >(CreateReservationDocument, options);
}
export type CreateReservationMutationHookResult = ReturnType<
  typeof useCreateReservationMutation
>;
export type CreateReservationMutationResult =
  Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;
export const DeleteReservedSpaceDocument = gql`
  mutation DeleteReservedSpace(
    $organisationId: ObjectID!
    $reservedSpaceId: ObjectID!
  ) {
    deleteReservedSpace(
      organisationId: $organisationId
      reservedSpaceId: $reservedSpaceId
    )
  }
`;
export type DeleteReservedSpaceMutationFn = Apollo.MutationFunction<
  DeleteReservedSpaceMutation,
  DeleteReservedSpaceMutationVariables
>;

/**
 * __useDeleteReservedSpaceMutation__
 *
 * To run a mutation, you first call `useDeleteReservedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservedSpaceMutation, { data, loading, error }] = useDeleteReservedSpaceMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      reservedSpaceId: // value for 'reservedSpaceId'
 *   },
 * });
 */
export function useDeleteReservedSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReservedSpaceMutation,
    DeleteReservedSpaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReservedSpaceMutation,
    DeleteReservedSpaceMutationVariables
  >(DeleteReservedSpaceDocument, options);
}
export type DeleteReservedSpaceMutationHookResult = ReturnType<
  typeof useDeleteReservedSpaceMutation
>;
export type DeleteReservedSpaceMutationResult =
  Apollo.MutationResult<DeleteReservedSpaceMutation>;
export type DeleteReservedSpaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteReservedSpaceMutation,
  DeleteReservedSpaceMutationVariables
>;
export const CreateReservationRecurringBookingDocument = gql`
  mutation CreateReservationRecurringBooking(
    $input: CreateReservationRecurringInput!
  ) {
    createReservationForRecurringBooking(input: $input) {
      reservation {
        start
      }
      reservedSpace {
        _id
      }
    }
  }
`;
export type CreateReservationRecurringBookingMutationFn =
  Apollo.MutationFunction<
    CreateReservationRecurringBookingMutation,
    CreateReservationRecurringBookingMutationVariables
  >;

/**
 * __useCreateReservationRecurringBookingMutation__
 *
 * To run a mutation, you first call `useCreateReservationRecurringBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationRecurringBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationRecurringBookingMutation, { data, loading, error }] = useCreateReservationRecurringBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReservationRecurringBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReservationRecurringBookingMutation,
    CreateReservationRecurringBookingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReservationRecurringBookingMutation,
    CreateReservationRecurringBookingMutationVariables
  >(CreateReservationRecurringBookingDocument, options);
}
export type CreateReservationRecurringBookingMutationHookResult = ReturnType<
  typeof useCreateReservationRecurringBookingMutation
>;
export type CreateReservationRecurringBookingMutationResult =
  Apollo.MutationResult<CreateReservationRecurringBookingMutation>;
export type CreateReservationRecurringBookingMutationOptions =
  Apollo.BaseMutationOptions<
    CreateReservationRecurringBookingMutation,
    CreateReservationRecurringBookingMutationVariables
  >;
export const GetOrganisationsAvailabilityDocument = gql`
  query GetOrganisationsAvailability(
    $id: ObjectID!
    $range: AvailabilityRange!
    $timezone: String
    $queryByOrganisationTimeZone: Boolean
    $organisationIds: [ObjectID!]!
    $meta: AvailabilityRequestMetaData!
  ) {
    bookingTool(id: $id) {
      _id
      name
      organisationsAvailability(
        range: $range
        timezone: $timezone
        queryByOrganisationTimeZone: $queryByOrganisationTimeZone
        organisationIds: $organisationIds
        meta: $meta
      ) {
        organisation {
          _id
          name
          defaultTimeZone
        }
        intervals {
          ... on AvailableInterval {
            start
            end
            resourceIds
          }
          ... on GroupBookingInterval {
            start
            end
            remainingSpaces
            booking {
              _id
              start
              end
              price
              remainingSpaces
              recurring {
                id
                recurrenceType
                bookings {
                  _id
                  start
                  end
                  price
                  remainingSpaces
                }
                frequencyType
                frequency
                occurrences
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganisationsAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetOrganisationsAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationsAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationsAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      range: // value for 'range'
 *      timezone: // value for 'timezone'
 *      queryByOrganisationTimeZone: // value for 'queryByOrganisationTimeZone'
 *      organisationIds: // value for 'organisationIds'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useGetOrganisationsAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganisationsAvailabilityQuery,
    GetOrganisationsAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganisationsAvailabilityQuery,
    GetOrganisationsAvailabilityQueryVariables
  >(GetOrganisationsAvailabilityDocument, options);
}
export function useGetOrganisationsAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganisationsAvailabilityQuery,
    GetOrganisationsAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganisationsAvailabilityQuery,
    GetOrganisationsAvailabilityQueryVariables
  >(GetOrganisationsAvailabilityDocument, options);
}
export type GetOrganisationsAvailabilityQueryHookResult = ReturnType<
  typeof useGetOrganisationsAvailabilityQuery
>;
export type GetOrganisationsAvailabilityLazyQueryHookResult = ReturnType<
  typeof useGetOrganisationsAvailabilityLazyQuery
>;
export type GetOrganisationsAvailabilityQueryResult = Apollo.QueryResult<
  GetOrganisationsAvailabilityQuery,
  GetOrganisationsAvailabilityQueryVariables
>;
export const CreateAdyenSessionDocument = gql`
  mutation createAdyenSession(
    $organisationId: ObjectID!
    $value: Float!
    $countryCode: String!
    $locale: String!
    $currency: String!
  ) {
    createAdyenSession(
      organisationId: $organisationId
      value: $value
      countryCode: $countryCode
      locale: $locale
      currency: $currency
    ) {
      paymentMethods
      clientKey
    }
  }
`;
export type CreateAdyenSessionMutationFn = Apollo.MutationFunction<
  CreateAdyenSessionMutation,
  CreateAdyenSessionMutationVariables
>;

/**
 * __useCreateAdyenSessionMutation__
 *
 * To run a mutation, you first call `useCreateAdyenSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdyenSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdyenSessionMutation, { data, loading, error }] = useCreateAdyenSessionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      value: // value for 'value'
 *      countryCode: // value for 'countryCode'
 *      locale: // value for 'locale'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useCreateAdyenSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdyenSessionMutation,
    CreateAdyenSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdyenSessionMutation,
    CreateAdyenSessionMutationVariables
  >(CreateAdyenSessionDocument, options);
}
export type CreateAdyenSessionMutationHookResult = ReturnType<
  typeof useCreateAdyenSessionMutation
>;
export type CreateAdyenSessionMutationResult =
  Apollo.MutationResult<CreateAdyenSessionMutation>;
export type CreateAdyenSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateAdyenSessionMutation,
  CreateAdyenSessionMutationVariables
>;
export const CreateBookingWithAdyenInvoiceDocument = gql`
  mutation createBookingWithAdyenInvoice(
    $bookingToolId: ObjectID
    $bookings: [BookingInput!]!
    $browserInfo: AdyenBrowserInfo
    $createdSource: String!
    $locale: String!
    $origin: String!
    $paymentAuthenticationData: AdyenAuthenticationData!
    $paymentCurrency: String!
    $paymentDiscount: BookingToolDiscountInput
    $paymentMethodData: String
    $paymentInvoiceId: ObjectID
    $payment3DSResult: String
    $paymentValue: Float!
  ) {
    createBookingsWithAdyenInvoice(
      bookingToolId: $bookingToolId
      bookings: $bookings
      browserInfo: $browserInfo
      createdSource: $createdSource
      locale: $locale
      origin: $origin
      paymentAuthenticationData: $paymentAuthenticationData
      paymentCurrency: $paymentCurrency
      paymentDiscount: $paymentDiscount
      paymentMethodData: $paymentMethodData
      paymentInvoiceId: $paymentInvoiceId
      payment3DSResult: $payment3DSResult
      paymentValue: $paymentValue
    ) {
      action
      bookings {
        _id
      }
      invoiceId
      resultCode
    }
  }
`;
export type CreateBookingWithAdyenInvoiceMutationFn = Apollo.MutationFunction<
  CreateBookingWithAdyenInvoiceMutation,
  CreateBookingWithAdyenInvoiceMutationVariables
>;

/**
 * __useCreateBookingWithAdyenInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateBookingWithAdyenInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingWithAdyenInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingWithAdyenInvoiceMutation, { data, loading, error }] = useCreateBookingWithAdyenInvoiceMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      bookings: // value for 'bookings'
 *      browserInfo: // value for 'browserInfo'
 *      createdSource: // value for 'createdSource'
 *      locale: // value for 'locale'
 *      origin: // value for 'origin'
 *      paymentAuthenticationData: // value for 'paymentAuthenticationData'
 *      paymentCurrency: // value for 'paymentCurrency'
 *      paymentDiscount: // value for 'paymentDiscount'
 *      paymentMethodData: // value for 'paymentMethodData'
 *      paymentInvoiceId: // value for 'paymentInvoiceId'
 *      payment3DSResult: // value for 'payment3DSResult'
 *      paymentValue: // value for 'paymentValue'
 *   },
 * });
 */
export function useCreateBookingWithAdyenInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingWithAdyenInvoiceMutation,
    CreateBookingWithAdyenInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingWithAdyenInvoiceMutation,
    CreateBookingWithAdyenInvoiceMutationVariables
  >(CreateBookingWithAdyenInvoiceDocument, options);
}
export type CreateBookingWithAdyenInvoiceMutationHookResult = ReturnType<
  typeof useCreateBookingWithAdyenInvoiceMutation
>;
export type CreateBookingWithAdyenInvoiceMutationResult =
  Apollo.MutationResult<CreateBookingWithAdyenInvoiceMutation>;
export type CreateBookingWithAdyenInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingWithAdyenInvoiceMutation,
    CreateBookingWithAdyenInvoiceMutationVariables
  >;
export const CalculateDiscountDocument = gql`
  query CalculateDiscount(
    $organisationId: ObjectID!
    $code: String!
    $servicePrices: [ServicePriceInput!]!
    $email: String!
  ) {
    discountCodeByCode(code: $code, organisationId: $organisationId) {
      calculatedDiscount(input: $servicePrices, email: $email) {
        ... on NoDiscount {
          noDiscountReason
        }
        ... on CalculatedDiscounts {
          discounts {
            servicePriceId
            serviceId
            discount
            discountedPrice
          }
        }
      }
    }
  }
`;

/**
 * __useCalculateDiscountQuery__
 *
 * To run a query within a React component, call `useCalculateDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateDiscountQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      code: // value for 'code'
 *      servicePrices: // value for 'servicePrices'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCalculateDiscountQuery(
  baseOptions: Apollo.QueryHookOptions<
    CalculateDiscountQuery,
    CalculateDiscountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CalculateDiscountQuery,
    CalculateDiscountQueryVariables
  >(CalculateDiscountDocument, options);
}
export function useCalculateDiscountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CalculateDiscountQuery,
    CalculateDiscountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CalculateDiscountQuery,
    CalculateDiscountQueryVariables
  >(CalculateDiscountDocument, options);
}
export type CalculateDiscountQueryHookResult = ReturnType<
  typeof useCalculateDiscountQuery
>;
export type CalculateDiscountLazyQueryHookResult = ReturnType<
  typeof useCalculateDiscountLazyQuery
>;
export type CalculateDiscountQueryResult = Apollo.QueryResult<
  CalculateDiscountQuery,
  CalculateDiscountQueryVariables
>;
export const CreateBookingsWithSquareInvoiceDocument = gql`
  mutation CreateBookingsWithSquareInvoice(
    $bookingToolId: ObjectID
    $bookings: [BookingInput!]!
    $cardToken: String!
    $squareBuyerVerificationToken: String!
    $locale: String!
    $createdSource: String!
    $discount: BookingToolDiscountInput
  ) {
    createBookingsWithSquareInvoice(
      bookingToolId: $bookingToolId
      bookings: $bookings
      cardToken: $cardToken
      squareBuyerVerificationToken: $squareBuyerVerificationToken
      locale: $locale
      createdSource: $createdSource
      discount: $discount
    ) {
      __typename
      bookings {
        _id
      }
    }
  }
`;
export type CreateBookingsWithSquareInvoiceMutationFn = Apollo.MutationFunction<
  CreateBookingsWithSquareInvoiceMutation,
  CreateBookingsWithSquareInvoiceMutationVariables
>;

/**
 * __useCreateBookingsWithSquareInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateBookingsWithSquareInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingsWithSquareInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingsWithSquareInvoiceMutation, { data, loading, error }] = useCreateBookingsWithSquareInvoiceMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      bookings: // value for 'bookings'
 *      cardToken: // value for 'cardToken'
 *      squareBuyerVerificationToken: // value for 'squareBuyerVerificationToken'
 *      locale: // value for 'locale'
 *      createdSource: // value for 'createdSource'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useCreateBookingsWithSquareInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingsWithSquareInvoiceMutation,
    CreateBookingsWithSquareInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingsWithSquareInvoiceMutation,
    CreateBookingsWithSquareInvoiceMutationVariables
  >(CreateBookingsWithSquareInvoiceDocument, options);
}
export type CreateBookingsWithSquareInvoiceMutationHookResult = ReturnType<
  typeof useCreateBookingsWithSquareInvoiceMutation
>;
export type CreateBookingsWithSquareInvoiceMutationResult =
  Apollo.MutationResult<CreateBookingsWithSquareInvoiceMutation>;
export type CreateBookingsWithSquareInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingsWithSquareInvoiceMutation,
    CreateBookingsWithSquareInvoiceMutationVariables
  >;
export const CreateStripePaymentIntentDocument = gql`
  mutation CreateStripePaymentIntent($input: CreateStripePaymentIntentInput!) {
    createStripePaymentIntent(input: $input) {
      clientSecret
    }
  }
`;
export type CreateStripePaymentIntentMutationFn = Apollo.MutationFunction<
  CreateStripePaymentIntentMutation,
  CreateStripePaymentIntentMutationVariables
>;

/**
 * __useCreateStripePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateStripePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripePaymentIntentMutation, { data, loading, error }] = useCreateStripePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripePaymentIntentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripePaymentIntentMutation,
    CreateStripePaymentIntentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStripePaymentIntentMutation,
    CreateStripePaymentIntentMutationVariables
  >(CreateStripePaymentIntentDocument, options);
}
export type CreateStripePaymentIntentMutationHookResult = ReturnType<
  typeof useCreateStripePaymentIntentMutation
>;
export type CreateStripePaymentIntentMutationResult =
  Apollo.MutationResult<CreateStripePaymentIntentMutation>;
export type CreateStripePaymentIntentMutationOptions =
  Apollo.BaseMutationOptions<
    CreateStripePaymentIntentMutation,
    CreateStripePaymentIntentMutationVariables
  >;
export const CreateBookingsWithStripeInvoiceDocument = gql`
  mutation CreateBookingsWithStripeInvoice(
    $bookingToolId: ObjectID
    $bookings: [BookingInput!]!
    $cardToken: String!
    $locale: String!
    $createdSource: String!
    $discount: BookingToolDiscountInput
  ) {
    createBookingsWithStripeInvoice(
      bookingToolId: $bookingToolId
      bookings: $bookings
      cardToken: $cardToken
      locale: $locale
      createdSource: $createdSource
      discount: $discount
    ) {
      __typename
      bookings {
        _id
      }
    }
  }
`;
export type CreateBookingsWithStripeInvoiceMutationFn = Apollo.MutationFunction<
  CreateBookingsWithStripeInvoiceMutation,
  CreateBookingsWithStripeInvoiceMutationVariables
>;

/**
 * __useCreateBookingsWithStripeInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateBookingsWithStripeInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingsWithStripeInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingsWithStripeInvoiceMutation, { data, loading, error }] = useCreateBookingsWithStripeInvoiceMutation({
 *   variables: {
 *      bookingToolId: // value for 'bookingToolId'
 *      bookings: // value for 'bookings'
 *      cardToken: // value for 'cardToken'
 *      locale: // value for 'locale'
 *      createdSource: // value for 'createdSource'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useCreateBookingsWithStripeInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBookingsWithStripeInvoiceMutation,
    CreateBookingsWithStripeInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBookingsWithStripeInvoiceMutation,
    CreateBookingsWithStripeInvoiceMutationVariables
  >(CreateBookingsWithStripeInvoiceDocument, options);
}
export type CreateBookingsWithStripeInvoiceMutationHookResult = ReturnType<
  typeof useCreateBookingsWithStripeInvoiceMutation
>;
export type CreateBookingsWithStripeInvoiceMutationResult =
  Apollo.MutationResult<CreateBookingsWithStripeInvoiceMutation>;
export type CreateBookingsWithStripeInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateBookingsWithStripeInvoiceMutation,
    CreateBookingsWithStripeInvoiceMutationVariables
  >;
export const GetServiceResourcesForBookingToolDocument = gql`
  query GetServiceResourcesForBookingTool(
    $id: ObjectID!
    $bookingToolId: ObjectID
    $resourceIds: [ObjectID!]
    $cursor: ObjectID
  ) {
    service(id: $id) {
      resourcesForBookingTool(
        bookingToolId: $bookingToolId
        resourceIds: $resourceIds
        first: 100
        after: $cursor
        order: ASCENDING
        sortBy: NAME
      ) {
        edges {
          node {
            _id
            name
            profilePhotoUrl
            description
            groups(order: ASCENDING, sortBy: NAME) {
              edges {
                node {
                  _id
                  name
                }
                cursor
              }
              pageInfo {
                hasNextPage
                hasPreviousPage
                total
                startCursor
                endCursor
              }
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
    }
  }
`;

/**
 * __useGetServiceResourcesForBookingToolQuery__
 *
 * To run a query within a React component, call `useGetServiceResourcesForBookingToolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceResourcesForBookingToolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceResourcesForBookingToolQuery({
 *   variables: {
 *      id: // value for 'id'
 *      bookingToolId: // value for 'bookingToolId'
 *      resourceIds: // value for 'resourceIds'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetServiceResourcesForBookingToolQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServiceResourcesForBookingToolQuery,
    GetServiceResourcesForBookingToolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceResourcesForBookingToolQuery,
    GetServiceResourcesForBookingToolQueryVariables
  >(GetServiceResourcesForBookingToolDocument, options);
}
export function useGetServiceResourcesForBookingToolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceResourcesForBookingToolQuery,
    GetServiceResourcesForBookingToolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceResourcesForBookingToolQuery,
    GetServiceResourcesForBookingToolQueryVariables
  >(GetServiceResourcesForBookingToolDocument, options);
}
export type GetServiceResourcesForBookingToolQueryHookResult = ReturnType<
  typeof useGetServiceResourcesForBookingToolQuery
>;
export type GetServiceResourcesForBookingToolLazyQueryHookResult = ReturnType<
  typeof useGetServiceResourcesForBookingToolLazyQuery
>;
export type GetServiceResourcesForBookingToolQueryResult = Apollo.QueryResult<
  GetServiceResourcesForBookingToolQuery,
  GetServiceResourcesForBookingToolQueryVariables
>;
export const GetServiceResourcesDocument = gql`
  query GetServiceResources($id: ObjectID!, $cursor: ObjectID) {
    service(id: $id) {
      resources(first: 100, after: $cursor, order: ASCENDING, sortBy: NAME) {
        edges {
          node {
            _id
            name
            profilePhotoUrl
            description
            groups(order: ASCENDING, sortBy: NAME) {
              edges {
                node {
                  _id
                  name
                }
                cursor
              }
              pageInfo {
                hasNextPage
                hasPreviousPage
                total
                startCursor
                endCursor
              }
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          total
          startCursor
          endCursor
        }
      }
    }
  }
`;

/**
 * __useGetServiceResourcesQuery__
 *
 * To run a query within a React component, call `useGetServiceResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetServiceResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServiceResourcesQuery,
    GetServiceResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceResourcesQuery,
    GetServiceResourcesQueryVariables
  >(GetServiceResourcesDocument, options);
}
export function useGetServiceResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceResourcesQuery,
    GetServiceResourcesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceResourcesQuery,
    GetServiceResourcesQueryVariables
  >(GetServiceResourcesDocument, options);
}
export type GetServiceResourcesQueryHookResult = ReturnType<
  typeof useGetServiceResourcesQuery
>;
export type GetServiceResourcesLazyQueryHookResult = ReturnType<
  typeof useGetServiceResourcesLazyQuery
>;
export type GetServiceResourcesQueryResult = Apollo.QueryResult<
  GetServiceResourcesQuery,
  GetServiceResourcesQueryVariables
>;
export const CreatePostDataDocument = gql`
  mutation createPostData($input: CreateParticipantUploadPresignedUrlInput!) {
    createParticipantUploadPresignedUrl(input: $input)
  }
`;
export type CreatePostDataMutationFn = Apollo.MutationFunction<
  CreatePostDataMutation,
  CreatePostDataMutationVariables
>;

/**
 * __useCreatePostDataMutation__
 *
 * To run a mutation, you first call `useCreatePostDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostDataMutation, { data, loading, error }] = useCreatePostDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePostDataMutation,
    CreatePostDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePostDataMutation,
    CreatePostDataMutationVariables
  >(CreatePostDataDocument, options);
}
export type CreatePostDataMutationHookResult = ReturnType<
  typeof useCreatePostDataMutation
>;
export type CreatePostDataMutationResult =
  Apollo.MutationResult<CreatePostDataMutation>;
export type CreatePostDataMutationOptions = Apollo.BaseMutationOptions<
  CreatePostDataMutation,
  CreatePostDataMutationVariables
>;
